const ro = () => {
  var t;
  const e = (t = document.querySelector("html")) == null ? void 0 : t.getAttribute("lang");
  if (e != null)
    return e;
}, io = () => "pathname" in window.location ? window.location.pathname : void 0;
function ao(e) {
  return e != null && document.querySelector(e) != null ? "challenger" : "control";
}
const so = () => {
  var t;
  const e = (t = document.querySelector('meta[name="version"]')) == null ? void 0 : t.getAttribute("content");
  if (e != null)
    return e;
}, st = () => {
  const e = navigator.userAgent.toLowerCase();
  return /fban|fbav|facebookexternalhit|fbios|fbid|fbsn/i.test(e);
}, Ye = () => /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
  navigator.userAgent
) ? "Mobile" : "Desktop", co = () => "height" in window.screen ? window.screen.height : void 0, lo = () => "width" in window.screen ? window.screen.width : void 0, ct = "meta[name=csrf-token]";
let Me;
function Pe() {
  if (Me != null)
    return Me;
  const e = document.querySelector(ct);
  if (e != null) {
    const t = e.getAttribute("content");
    if (t != null)
      return Me = t, Me;
  }
  return "";
}
function he(e, t, n, r, i) {
  const c = new XMLHttpRequest();
  c.open(e, t, !0), c.onload = () => {
    c.status >= 200 && c.status < 400 && JSON.parse(c.response);
  }, c.onerror = (a) => {
  }, e === "POST" && (c.setRequestHeader(
    "Content-Type",
    "application/x-www-form-urlencoded; charset=UTF-8"
  ), c.setRequestHeader("x-csrf-token", Pe())), c.send(n);
}
const ye = (e) => Object.keys(e).map((t) => `${encodeURIComponent(t)}=${encodeURIComponent(e[t])}`).join("&"), _e = (e, t) => {
  const n = ye(t), r = new XMLHttpRequest();
  return r.open("GET", ` ${e}?${n}`, !0), r.setRequestHeader(
    "Content-type",
    "application/x-www-form-urlencoded; charset=UTF-8"
  ), r.send();
}, lt = (e) => {
  const t = Object.keys(e);
  let n = t.length;
  const r = new Array(n);
  for (; n-- > 0; ) r[n] = [t[n], e[t[n]]];
  return r;
}, mt = () => ({
  userAgent: navigator.userAgent,
  facebook: st(),
  performanceTimeline: "timing" in window.performance,
  DOMHighResTimeStamp: "now" in window.performance,
  networkInformation: "connection" in window.navigator,
  navigationEntry: De("navigation"),
  resourceTimingEntry: De("resource"),
  webShare: "share" in window.navigator,
  visibilityChange: "visibilityState" in document,
  pageHide: "onpagehide" in window,
  fetch: "fetch" in window,
  sendBeacon: "sendBeacon" in window.navigator,
  webSocket: WebSocket != null,
  localStorage: localStorage.length != null,
  performanceObserver: window.PerformanceObserver != null,
  mutationObserver: window.MutationObserver != null,
  intersectionObserver: window.IntersectionObserver != null,
  performancePaintTiming: De("paint")
}), De = (e) => {
  if ("getEntriesByType" in performance) {
    const t = window.performance.getEntriesByType(e);
    return t != null && t.length > 0;
  } else
    return !1;
}, mo = () => {
  const e = mt();
  return he(
    "POST",
    "/2",
    ye(e)
  );
}, dt = () => {
  const e = document.querySelector("[data-metrics__body]");
  if (e != null) {
    const t = Array.prototype.slice.call(e.children), n = document.querySelector("[data-metrics__content]");
    if (n != null) {
      const s = Array.prototype.slice.call(
        n.children
      );
      t.push(s);
    }
    const r = t.reduce(
      (s, o) => s.concat(o),
      []
    );
    [0.25, 0.5, 0.75].forEach(function(s) {
      const o = Math.round(r.length * s), m = r[o], d = (s.toString().replace(/^[0.]+/, "") + "0").slice(0, 2);
      m.dataset.metrics = d;
    });
    const c = r.length - 1, a = r[c];
    a.dataset.metrics = "100";
  }
}, uo = function() {
  dt();
  const e = document.querySelectorAll(
    "[data-metrics]"
  ), t = Array.prototype.slice.call(
    e
  ), n = function(r) {
    new IntersectionObserver(function(c, a) {
      c.forEach(function(s) {
        var o;
        if (s.isIntersecting) {
          const m = {
            locale: window.OP_METRICS.locale,
            pathname: document.location.pathname,
            referrer: window.OP_METRICS.referrer,
            screenHeight: window.OP_METRICS.screen_height,
            screenWidth: window.OP_METRICS.screen_width,
            version: window.OP_METRICS.site_version,
            template: window.OP_METRICS.template,
            elementSelector: "Metrics-" + ((o = s.target) == null ? void 0 : o.getAttribute("data-metrics")),
            timeSeen: s.time.toString()
          };
          a.disconnect(), he("POST", "/3", ye(m));
        }
      });
    }).observe(r);
  };
  t.forEach(n);
}, ut = () => typeof window.performance.getEntriesByType == "function" && window.performance.getEntriesByType("navigation") != null && window.performance.getEntriesByType("navigation").length > 0 ? window.performance.getEntriesByType("navigation")[0] : typeof window.performance.timing == "object" && window.performance.timing != null ? window.performance.timing : void 0;
function gt() {
  if (typeof navigator == "object") {
    const e = navigator.connection ?? navigator.mozConnection ?? navigator.webkitConnection ?? navigator.msConnection;
    return e != null && "effectiveType" in e && "rtt" in e && "saveData" in e ? {
      effectiveType: e.effectiveType,
      rtt: e.rtt,
      saveData: e.saveData
    } : void 0;
  } else
    return;
}
const pt = () => {
  if (typeof window.performance.getEntriesByType == "function" && window.performance.getEntriesByType("paint") != null && window.performance.getEntriesByType("paint").length > 0)
    return performance.getEntriesByType("paint").reduce((n, r) => ({ ...n, [r.name]: r.startTime }), {});
}, ht = () => {
  if (typeof window.performance.getEntriesByType == "function" && window.performance.getEntriesByType("resource") != null && window.performance.getEntriesByType("resource").length > 0) {
    const t = window.performance.getEntriesByType(
      "resource"
    ), n = t.reduce(
      (c, a) => c + a.transferSize,
      0
    ), r = t.reduce(
      (c, a) => c + a.encodedBodySize,
      0
    ), i = t.reduce(
      (c, a) => c + a.decodedBodySize,
      0
    );
    return {
      transferSize: n,
      encodedBodySize: r,
      decodedBodySize: i
    };
  } else
    return;
}, go = () => {
  const e = new FormData(), t = ht(), n = pt(), r = ut(), i = gt(), c = {
    locale: window.OP_METRICS.locale,
    referrer: window.OP_METRICS.referrer,
    pathname: window.OP_METRICS.id,
    template: window.OP_METRICS.template,
    screenWidth: window.OP_METRICS.screen_width,
    screenHeight: window.OP_METRICS.screen_height,
    version: window.OP_METRICS.site_version
  }, a = {};
  return i !== void 0 && (a.rtt = i.rtt, a.saveData = i.saveData, a.effectiveType = i.effectiveType), n != null && (n["first-contentful-paint"] != null && (a.firstContentfulPaint = n["first-contentful-paint"]), n["first-paint"] != null && (a.firstPaint = n["first-paint"])), a.transferSize = t == null ? void 0 : t.transferSize, a.encodedBodySize = t == null ? void 0 : t.encodedBodySize, a.decodedBodySize = t == null ? void 0 : t.decodedBodySize, e.append("metadata", JSON.stringify(c)), e.append("timeline", JSON.stringify(r)), e.append("optional", JSON.stringify(a)), bt(e);
};
function bt(e) {
  const t = new XMLHttpRequest();
  if (t.open("POST", "/7", !0), t.setRequestHeader("x-csrf-token", Pe()), e != null)
    return t.send(e);
}
const Le = (e, t) => {
  const n = t;
  if (typeof window.navigator == "object" && typeof window.navigator.sendBeacon == "function") {
    const r = St(n);
    try {
      if (window.navigator.sendBeacon(e, r))
        return;
    } catch {
      _e(e, n);
    }
  } else
    try {
      _e(e, n);
    } catch {
      ft(e, n);
    }
}, ft = (e, t) => {
  const n = ye(t), r = new Image();
  return r.src = `https://${window.location.host}/${e}?${n}`, r;
}, St = (e) => {
  const t = e, n = new FormData();
  if (n.append("authenticity_token", Pe()), typeof Object.entries == "function")
    for (const [r, i] of Object.entries(t))
      n.append(r, i);
  else
    lt(t).forEach((i) => {
      n.append(i[0], i[1]);
    });
  return n;
}, po = (e, t) => {
  new IntersectionObserver(
    (r, i) => {
      Array.prototype.slice.call(r).forEach(function(c) {
        var a;
        if (c.isIntersecting) {
          const s = {
            locale: window.OP_METRICS.locale,
            pathname: window.OP_METRICS.id,
            referrer: window.OP_METRICS.referrer,
            screenHeight: window.OP_METRICS.screen_height,
            screenWidth: window.OP_METRICS.screen_width,
            version: window.OP_METRICS.site_version,
            template: window.OP_METRICS.template,
            elementSelector: t.type === "data" ? t.name + "_" + ((a = c.target) == null ? void 0 : a.getAttribute("data-" + t.name)) : t.name,
            timeSeen: c.time.toString()
          };
          i.disconnect(), Le("/3", s);
        }
      });
    }
  ).observe(e);
}, Ge = (e) => {
  const t = "/5", n = e, r = {
    locale: window.OP_METRICS.locale,
    referrer: window.OP_METRICS.referrer,
    pathname: window.OP_METRICS.id,
    template: window.OP_METRICS.template,
    screenWidth: window.OP_METRICS.screen_width,
    screenHeight: window.OP_METRICS.screen_height,
    version: window.OP_METRICS.site_version,
    eventType: n,
    end: String(performance.now())
  };
  Le(t, r);
}, ho = () => {
  Ye() === "Mobile" && document.addEventListener("visibilitychange", (n) => {
    document.visibilityState === "hidden" && Ge(n == null ? void 0 : n.type);
  });
  const t = ["beforeunload", "unload"];
  "onpagehide" in self && t.unshift("pagehide"), t.forEach(
    (n) => window.addEventListener(n, (r) => Ge(r == null ? void 0 : r.type), !0)
  );
}, bo = () => {
  const e = Ye();
  let t = "touchstart";
  e === "Desktop" && (t = "click"), Array.from(document.getElementsByTagName("a")).forEach((r) => {
    r.addEventListener(t, () => {
      var a;
      const i = r.className, c = (a = r.parentElement) == null ? void 0 : a.className;
      return Et(i, c);
    });
  });
};
function Et(e, t) {
  const n = "/4", r = {
    elementSelector: e,
    parentSelector: t,
    locale: window.OP_METRICS.locale,
    pathname: window.OP_METRICS.id,
    referrer: window.OP_METRICS.referrer,
    screenHeight: window.OP_METRICS.screen_height,
    screenWidth: window.OP_METRICS.screen_width,
    version: window.OP_METRICS.site_version,
    template: window.OP_METRICS.template
  };
  Le(n, r);
}
const fo = (e) => {
  e.addEventListener("click", () => {
    const t = window.OP_METRICS.id, n = window.OP_METRICS.locale;
    t != null && n != null && he(
      "GET",
      `/click_more_click_counts?id=${t}&locale=${n}`,
      void 0
    ), e.style.display = "none";
  });
}, So = (e) => {
  new IntersectionObserver(
    (n, r) => {
      Array.prototype.forEach.call(
        n,
        (i) => {
          if (i.isIntersecting) {
            const c = window.OP_METRICS.id, a = window.OP_METRICS.locale;
            c != null && a != null && he(
              "GET",
              `/click_more_view_counts?id=${c}&locale=${a}`,
              void 0
            ), r.disconnect();
          }
        }
      );
    }
  ).observe(e);
}, Eo = () => {
  const e = window.metricsConfig.gTag_container_ID;
  e != null ? function(t) {
    window[t] == null && (window[t] = []), window[t].push({
      "gtm.start": (/* @__PURE__ */ new Date()).getTime(),
      event: "gtm.js"
    });
    const n = document.getElementsByTagName(
      "script"
    )[0], r = document.createElement("script"), i = "";
    r.async = !1, r.src = "https://www.googletagmanager.com/gtm.js?id=" + e + i, n != null && (n.parentNode != null ? n.parentNode.insertBefore(r, n) : n.insertBefore(r, n));
  }("dataLayer") : console.error("The gTag container ID did not load properly");
}, yt = () => {
  const e = [];
  return {
    getErrors: () => e,
    captureError: (t, n = "") => {
      const r = {
        Error: !0,
        EvalError: !0,
        InternalError: !0,
        RangeError: !0,
        ReferenceError: !0,
        SyntaxError: !0,
        TypeError: !0,
        URIError: !0,
        InvalidStateError: !0,
        SecurityError: !0
      }, i = (m) => /.+(\s).+/g.test(m);
      console.error(t);
      const { name: c, message: a } = t, s = i(a) ? n ? `${a} [${n}]` : a : void 0, o = r[c] ? c : void 0;
      e.push(
        { trustedName: o, trustedMessage: s }
      );
    }
  };
}, Je = yt(), { captureError: W } = Je, C = (e, t = "") => {
  try {
    return e();
  } catch (n) {
    return t ? W(n, t) : W(n);
  }
}, se = (e, t = [], n = [], r = !1) => {
  let i;
  try {
    i = e();
  } catch {
    return;
  }
  let c;
  const a = t.length;
  let s = i;
  try {
    for (c = 0; c < a; c++) {
      const o = t[c];
      s = s[o];
    }
  } catch {
    return;
  }
  return r && n.length ? s.apply(i, n) : r && !n.length ? s.apply(i) : s;
}, wt = () => ({ data: Je.getErrors() });
var oe = /* @__PURE__ */ ((e) => (e.WINDOWS = "Windows", e.LINUX = "Linux", e.APPLE = "Apple", e.OTHER = "Other", e))(oe || {});
const Qe = !self.document && self.WorkerGlobalScope;
function Mt() {
  const e = [].constructor;
  try {
    (-1).toFixed(-1);
  } catch (t) {
    return t.message.length + (e + "").split(e.name).join("").length;
  }
}
const Oe = Mt(), K = Oe == 80, de = Oe == 58, pe = Oe == 77, Ze = K && "flat" in Array.prototype && !("ReportingObserver" in self);
function et() {
  return "brave" in navigator && // @ts-ignore
  Object.getPrototypeOf(navigator.brave).constructor.name == "Brave" && // @ts-ignore
  navigator.brave.isBrave.toString() == "function isBrave() { [native code] }";
}
function At() {
  const e = {
    unknown: !1,
    allow: !1,
    standard: !1,
    strict: !1
  };
  try {
    if ((() => {
      try {
        window.OfflineAudioContext = // @ts-ignore
        OfflineAudioContext || webkitOfflineAudioContext;
      } catch {
      }
      if (!window.OfflineAudioContext)
        return !1;
      const a = new OfflineAudioContext(1, 1, 44100).createAnalyser(), s = new Float32Array(a.frequencyBinCount);
      return a.getFloatFrequencyData(s), new Set(s).size > 1;
    })())
      return e.strict = !0, e;
    const n = /(Chrom(e|ium)|Microsoft Edge) PDF (Plugin|Viewer)/, r = [...navigator.plugins], i = r.filter((c) => n.test(c.name)).length == 2;
    return r.length && !i ? (e.standard = !0, e) : (e.allow = !0, e);
  } catch {
    return e.unknown = !0, e;
  }
}
const kt = (e) => {
  const t = /* @__PURE__ */ new Set([
    "FRAGMENT_SHADER.HIGH_FLOAT.precision",
    "FRAGMENT_SHADER.HIGH_FLOAT.rangeMax",
    "FRAGMENT_SHADER.HIGH_FLOAT.rangeMin",
    "FRAGMENT_SHADER.HIGH_INT.precision",
    "FRAGMENT_SHADER.HIGH_INT.rangeMax",
    "FRAGMENT_SHADER.HIGH_INT.rangeMin",
    "FRAGMENT_SHADER.LOW_FLOAT.precision",
    "FRAGMENT_SHADER.LOW_FLOAT.rangeMax",
    "FRAGMENT_SHADER.LOW_FLOAT.rangeMin",
    "FRAGMENT_SHADER.MEDIUM_FLOAT.precision",
    "FRAGMENT_SHADER.MEDIUM_FLOAT.rangeMax",
    "FRAGMENT_SHADER.MEDIUM_FLOAT.rangeMin",
    "MAX_COMBINED_FRAGMENT_UNIFORM_COMPONENTS",
    "MAX_COMBINED_UNIFORM_BLOCKS",
    "MAX_COMBINED_VERTEX_UNIFORM_COMPONENTS",
    "MAX_DRAW_BUFFERS_WEBGL",
    "MAX_FRAGMENT_INPUT_COMPONENTS",
    "MAX_FRAGMENT_UNIFORM_BLOCKS",
    "MAX_FRAGMENT_UNIFORM_COMPONENTS",
    "MAX_TEXTURE_MAX_ANISOTROPY_EXT",
    "MAX_TRANSFORM_FEEDBACK_INTERLEAVED_COMPONENTS",
    "MAX_UNIFORM_BUFFER_BINDINGS",
    "MAX_VARYING_COMPONENTS",
    "MAX_VERTEX_OUTPUT_COMPONENTS",
    "MAX_VERTEX_UNIFORM_BLOCKS",
    "MAX_VERTEX_UNIFORM_COMPONENTS",
    "SHADING_LANGUAGE_VERSION",
    "UNMASKED_RENDERER_WEBGL",
    "UNMASKED_VENDOR_WEBGL",
    "VERSION",
    "VERTEX_SHADER.HIGH_FLOAT.precision",
    "VERTEX_SHADER.HIGH_FLOAT.rangeMax",
    "VERTEX_SHADER.HIGH_FLOAT.rangeMin",
    "VERTEX_SHADER.HIGH_INT.precision",
    "VERTEX_SHADER.HIGH_INT.rangeMax",
    "VERTEX_SHADER.HIGH_INT.rangeMin",
    "VERTEX_SHADER.LOW_FLOAT.precision",
    "VERTEX_SHADER.LOW_FLOAT.rangeMax",
    "VERTEX_SHADER.LOW_FLOAT.rangeMin",
    "VERTEX_SHADER.MEDIUM_FLOAT.precision",
    "VERTEX_SHADER.MEDIUM_FLOAT.rangeMax",
    "VERTEX_SHADER.MEDIUM_FLOAT.rangeMin"
  ]);
  return Object.keys(e).reduce((r, i) => (t.has(i) || (r[i] = e[i]), r), {});
}, Ve = (e) => (
  // order is important
  /windows phone/ig.test(e) ? "Windows Phone" : /win(dows|16|32|64|95|98|nt)|wow64/ig.test(e) ? "Windows" : /android/ig.test(e) ? "Android" : /cros/ig.test(e) ? "Chrome OS" : /linux/ig.test(e) ? "Linux" : /ipad/ig.test(e) ? "iPad" : /iphone/ig.test(e) ? "iPhone" : /ipod/ig.test(e) ? "iPod" : /ios/ig.test(e) ? "iOS" : /mac/ig.test(e) ? "Mac" : "Other"
);
function Tt(e, t) {
  const n = (
    // order is important
    /win(dows|16|32|64|95|98|nt)|wow64/ig.test(e) ? oe.WINDOWS : /android|linux|cros/ig.test(e) ? oe.LINUX : /(i(os|p(ad|hone|od)))|mac/ig.test(e) ? oe.APPLE : oe.OTHER
  );
  if (!t) return [n];
  const r = (
    // order is important
    /win/ig.test(t) ? oe.WINDOWS : /android|arm|linux/ig.test(t) ? oe.LINUX : /(i(os|p(ad|hone|od)))|mac/ig.test(t) ? oe.APPLE : oe.OTHER
  );
  return [n, r];
}
const { userAgent: vt, platform: Dt } = self.navigator || {}, [ke, We] = Tt(vt, Dt), Ct = ({ ua: e, os: t, isBrave: n }) => {
  const r = /ipad|iphone|ipod|ios|mac/ig.test(t), i = /OPR\//g.test(e), c = /Vivaldi/g.test(e), a = /DuckDuckGo/g.test(e), s = /YaBrowser/g.test(e), o = e.match(/(palemoon)\/(\d+)./i), m = e.match(/(edgios|edg|edge|edga)\/(\d+)./i), d = m && /edgios/i.test(m[1]), u = e.match(/(crios|chrome)\/(\d+)./i), b = e.match(/(fxios|firefox)\/(\d+)./i), S = /AppleWebKit/g.test(e) && /Safari/g.test(e) && !b && !u && !m && e.match(/(version)\/(\d+)\.(\d|\.)+\s(mobile|safari)/i);
  if (u) {
    const h = u[1], g = u[2];
    return `${h} ${g}${i ? " Opera" : c ? " Vivaldi" : a ? " DuckDuckGo" : s ? " Yandex" : m ? " Edge" : n ? " Brave" : ""}`;
  } else if (d) {
    const h = m[1], g = m[2];
    return `${h} ${g}`;
  } else if (b) {
    const h = o ? o[1] : b[1], g = o ? o[2] : b[2];
    return `${h} ${g}`;
  } else if (r && S) {
    const h = "Safari", g = S[2];
    return `${h} ${g}`;
  }
  return "unknown";
}, Rt = ({ userAgent: e, excludeBuild: t = !0 }) => {
  if (!e)
    return "unknown";
  const n = /\((khtml|unlike|vizio|like gec|internal dummy|org\.eclipse|openssl|ipv6|via translate|safari|cardamon).+|xt\d+\)/ig, r = /\((.+)\)/, i = /((android).+)/i, c = /^(linux|[a-z]|wv|mobile|[a-z]{2}(-|_)[a-z]{2}|[a-z]{2})$|windows|(rv:|trident|webview|iemobile).+/i, a = /build\/.+\s|\sbuild\/.+/i, s = /android( |-)\d+/i, o = /((windows).+)/i, m = /^(windows|ms(-|)office|microsoft|compatible|[a-z]|x64|[a-z]{2}(-|_)[a-z]{2}|[a-z]{2})$|(rv:|outlook|ms(-|)office|microsoft|trident|\.net|msie|httrack|media center|infopath|aol|opera|iemobile|webbrowser).+/i, d = /w(ow|in)64/i, u = /cros/i, b = /^([a-z]|x11|[a-z]{2}(-|_)[a-z]{2}|[a-z]{2})$|(rv:|trident).+/i, l = /\d+\.\d+\.\d+/i, S = /linux|x11|ubuntu|debian/i, h = /^([a-z]|x11|unknown|compatible|[a-z]{2}(-|_)[a-z]{2}|[a-z]{2})$|(rv:|java|oracle|\+http|http|unknown|mozilla|konqueror|valve).+/i, g = /(cpu iphone|cpu os|iphone os|mac os|macos|intel os|ppc mac).+/i, y = /^([a-z]|macintosh|compatible|mimic|[a-z]{2}(-|_)[a-z]{2}|[a-z]{2}|rv|\d+\.\d+)$|(rv:|silk|valve).+/i, p = /(ppc |intel |)(mac|mac |)os (x |x|)(\d{2}(_|\.)\d{1,2}|\d{2,})/i, k = /((symbianos|nokia|blackberry|morphos|mac).+)|\/linux|freebsd|symbos|series \d+|win\d+|unix|hp-ux|bsdi|bsd|x86_64/i, v = (I, E) => I.filter((f) => E.test(f)).length;
  if (e = e.trim().replace(/\s{2,}/, " ").replace(n, ""), r.test(e)) {
    const E = e.match(r)[0].slice(1, -1).replace(/,/g, ";").split(";").map((f) => f.trim());
    if (v(E, i))
      return E.map((f) => s.test(f) ? s.exec(f)[0].replace("-", " ") : f).filter((f) => !c.test(f)).join(" ").replace(t ? a : "", "").trim().replace(/\s{2,}/, " ");
    if (v(E, o))
      return E.filter((f) => !m.test(f)).join(" ").replace(/\sNT (\d+\.\d+)/, (f, D) => D == "10.0" ? " 10" : D == "6.3" ? " 8.1" : D == "6.2" ? " 8" : D == "6.1" ? " 7" : D == "6.0" ? " Vista" : D == "5.2" ? " XP Pro" : D == "5.1" ? " XP" : D == "5.0" ? " 2000" : D == "4.0" ? f : " " + D).replace(d, "(64-bit)").trim().replace(/\s{2,}/, " ");
    if (v(E, u))
      return E.filter((f) => !b.test(f)).join(" ").replace(t ? l : "", "").trim().replace(/\s{2,}/, " ");
    if (v(E, S))
      return E.filter((f) => !h.test(f)).join(" ").trim().replace(/\s{2,}/, " ");
    if (v(E, g))
      return E.map((f) => {
        if (p.test(f)) {
          const D = p.exec(f)[0], A = {
            "10_7": "Lion",
            "10_8": "Mountain Lion",
            "10_9": "Mavericks",
            "10_10": "Yosemite",
            "10_11": "El Capitan",
            "10_12": "Sierra",
            "10_13": "High Sierra",
            "10_14": "Mojave",
            "10_15": "Catalina",
            11: "Big Sur",
            12: "Monterey",
            13: "Ventura"
          }, T = ((/(\d{2}(_|\.)\d{1,2}|\d{2,})/.exec(D) || [])[0] || "").replace(/\./g, "_"), F = /^10/.test(T) ? T : (/^\d{2,}/.exec(T) || [])[0], L = A[F];
          return L ? `macOS ${L}` : D;
        }
        return f;
      }).filter((f) => !y.test(f)).join(" ").replace(/\slike mac.+/ig, "").trim().replace(/\s{2,}/, " ");
    {
      const f = E.filter((D) => k.test(D));
      return f.length ? f.join(" ").trim().replace(/\s{2,}/, " ") : E.join(" ");
    }
  } else
    return "unknown";
}, Nt = (e) => {
  const n = (/Mozilla\/5\.0 \((Macintosh; Intel Mac OS X 10_15_7|Windows NT 10\.0; Win64; x64|(X11; (CrOS|Linux) x86_64)|(Linux; Android 10(; K|)))\) AppleWebKit\/537\.36 \(KHTML, like Gecko\) Chrome\/\d+\.0\.0\.0( Mobile|) Safari\/537\.36/.exec(e) || [])[1];
  return K && !!n;
}, xt = () => {
  const e = {};
  let t = 0;
  return {
    logTestResult: ({ test: n, passed: r, time: i = 0 }) => {
    },
    getLog: () => e,
    getTotal: () => t
  };
}, It = xt(), { logTestResult: Se } = It, Pt = () => new Promise((e) => setTimeout(() => e(null))), le = [
  [128512],
  [9786],
  [129333, 8205, 9794, 65039],
  [9832],
  [9784],
  [9895],
  [8265],
  [8505],
  [127987, 65039, 8205, 9895, 65039],
  [129394],
  [9785],
  [9760],
  [129489, 8205, 129456],
  [129487, 8205, 9794, 65039],
  [9975],
  [129489, 8205, 129309, 8205, 129489],
  [9752],
  [9968],
  [9961],
  [9972],
  [9992],
  [9201],
  [9928],
  [9730],
  [9969],
  [9731],
  [9732],
  [9976],
  [9823],
  [9937],
  [9e3],
  [9993],
  [9999],
  [128105, 8205, 10084, 65039, 8205, 128139, 8205, 128104],
  [128104, 8205, 128105, 8205, 128103, 8205, 128102],
  [128104, 8205, 128105, 8205, 128102],
  // android 11
  [128512],
  [169],
  [174],
  [8482],
  [128065, 65039, 8205, 128488, 65039],
  // other
  [10002],
  [9986],
  [9935],
  [9874],
  [9876],
  [9881],
  [9939],
  [9879],
  [9904],
  [9905],
  [9888],
  [9762],
  [9763],
  [11014],
  [8599],
  [10145],
  [11013],
  [9883],
  [10017],
  [10013],
  [9766],
  [9654],
  [9197],
  [9199],
  [9167],
  [9792],
  [9794],
  [10006],
  [12336],
  [9877],
  [9884],
  [10004],
  [10035],
  [10055],
  [9724],
  [9642],
  [10083],
  [10084],
  [9996],
  [9757],
  [9997],
  [10052],
  [9878],
  [8618],
  [9775],
  [9770],
  [9774],
  [9745],
  [10036],
  [127344],
  [127359]
].map((e) => String.fromCodePoint(...e)), ce = `
	'Segoe Fluent Icons',
	'Ink Free',
	'Bahnschrift',
	'Segoe MDL2 Assets',
	'HoloLens MDL2 Assets',
	'Leelawadee UI',
	'Javanese Text',
	'Segoe UI Emoji',
	'Aldhabi',
	'Gadugi',
	'Myanmar Text',
	'Nirmala UI',
	'Lucida Console',
	'Cambria Math',
	'Bai Jamjuree',
	'Chakra Petch',
	'Charmonman',
	'Fahkwang',
	'K2D',
	'Kodchasan',
	'KoHo',
	'Sarabun',
	'Srisakdi',
	'Galvji',
	'MuktaMahee Regular',
	'InaiMathi Bold',
	'American Typewriter Semibold',
	'Futura Bold',
	'SignPainter-HouseScript Semibold',
	'PingFang HK Light',
	'Kohinoor Devanagari Medium',
	'Luminari',
	'Geneva',
	'Helvetica Neue',
	'Droid Sans Mono',
	'Dancing Script',
	'Roboto',
	'Ubuntu',
	'Liberation Mono',
	'Source Code Pro',
	'DejaVu Sans',
	'OpenSymbol',
	'Chilanka',
	'Cousine',
	'Arimo',
	'Jomolhari',
	'MONO',
	'Noto Color Emoji',
	sans-serif !important
`;
function Lt(e) {
  var r;
  if (!e) return null;
  const t = /(adreno|amd|apple|intel|llvm|mali|microsoft|nvidia|parallels|powervr|samsung|swiftshader|virtualbox|vmware)/i;
  return /radeon/i.test(e) ? "AMD" : /geforce/i.test(e) ? "NVIDIA" : (((r = t.exec(e)) == null ? void 0 : r[0]) || "other").toLocaleUpperCase();
}
const ae = {}, re = {
  AUDIO: !1,
  CANVAS: !1,
  FONTS: !1,
  SCREEN: !1,
  TIME_ZONE: !1,
  WEBGL: !1
};
try {
  speechSynthesis.getVoices();
} catch {
}
function Ot() {
  const e = {};
  return {
    getRecords: () => e,
    documentLie: (t, n) => {
      const r = n instanceof Array;
      return e[t] ? r ? e[t] = [...e[t], ...n] : e[t].push(n) : r ? e[t] = n : e[t] = [n];
    }
  };
}
const tt = Ot(), { documentLie: H } = tt, nt = `
	height: 100vh;
	width: 100vw;
	position: absolute;
	left:-10000px;
	visibility: hidden;
`;
function ve() {
  return String.fromCharCode(Math.random() * 26 + 97) + Math.random().toString(36).slice(-7);
}
function Bt(e) {
  try {
    if (!K) return e;
    const t = e.document.createElement("div");
    t.setAttribute("id", ve()), t.setAttribute("style", nt), t.innerHTML = "<div><iframe></iframe></div>", e.document.body.appendChild(t);
    const n = [...[...t.childNodes][0].childNodes][0];
    if (!n) return null;
    const { contentWindow: r } = n || {};
    if (!r) return null;
    const i = r.document.createElement("div");
    return i.innerHTML = "<div><iframe></iframe></div>", r.document.body.appendChild(i), [...[...i.childNodes][0].childNodes][0].contentWindow;
  } catch (t) {
    return W(t, "client blocked behemoth iframe"), e;
  }
}
const He = ve(), fe = "Reflect" in self;
function Ft(e) {
  return e.constructor.name == "TypeError";
}
function te({ spawnErr: e, withStack: t, final: n }) {
  try {
    throw e(), Error();
  } catch (r) {
    return Ft(r) ? t ? t(r) : !1 : !0;
  } finally {
    n && n();
  }
}
function _t(e) {
  try {
    return e(), !1;
  } catch {
    return !0;
  }
}
function ze(e) {
  return {
    [`function ${e}() { [native code] }`]: !0,
    [`function get ${e}() { [native code] }`]: !0,
    "function () { [native code] }": !0,
    [`function ${e}() {
    [native code]
}`]: !0,
    [`function get ${e}() {
    [native code]
}`]: !0,
    "function () {\n    [native code]\n}": !0
  };
}
function ge(e, t, n = 1) {
  return n === 0 ? t.test(e.message) : t.test(e.stack.split(`
`)[n]);
}
const Gt = /at Function\.toString /, Vt = /at Object\.toString/, Wt = /at (Function\.)?\[Symbol.hasInstance\]/, Ht = /at (Proxy\.)?\[Symbol.hasInstance\]/, Ue = /strict mode/;
function je({
  scope: e,
  apiFunction: t,
  proto: n,
  obj: r,
  lieProps: i
}) {
  if (typeof t != "function")
    return {
      lied: 0,
      lieTypes: []
    };
  const c = t.name.replace(/get\s/, ""), a = r == null ? void 0 : r.name, s = Object.getPrototypeOf(t);
  let o = {
    // custom lie string names
    "failed illegal error": !!r && te({
      spawnErr: () => r.prototype[c]
    }),
    "failed undefined properties": !!r && /^(screen|navigator)$/i.test(a) && !!(Object.getOwnPropertyDescriptor(self[a.toLowerCase()], c) || fe && Reflect.getOwnPropertyDescriptor(self[a.toLowerCase()], c)),
    "failed call interface error": te({
      spawnErr: () => {
        new t(), t.call(n);
      }
    }),
    "failed apply interface error": te({
      spawnErr: () => {
        new t(), t.apply(n);
      }
    }),
    "failed new instance error": te({
      // @ts-expect-error
      spawnErr: () => new t()
    }),
    "failed class extends error": !pe && te({
      spawnErr: () => {
        class u extends t {
        }
      }
    }),
    "failed null conversion error": te({
      spawnErr: () => Object.setPrototypeOf(t, null).toString(),
      final: () => Object.setPrototypeOf(t, s)
    }),
    "failed toString": !ze(c)[e.Function.prototype.toString.call(t)] || !ze("toString")[e.Function.prototype.toString.call(t.toString)],
    'failed "prototype" in function': "prototype" in t,
    "failed descriptor": !!(Object.getOwnPropertyDescriptor(t, "arguments") || Reflect.getOwnPropertyDescriptor(t, "arguments") || Object.getOwnPropertyDescriptor(t, "caller") || Reflect.getOwnPropertyDescriptor(t, "caller") || Object.getOwnPropertyDescriptor(t, "prototype") || Reflect.getOwnPropertyDescriptor(t, "prototype") || Object.getOwnPropertyDescriptor(t, "toString") || Reflect.getOwnPropertyDescriptor(t, "toString")),
    "failed own property": !!(t.hasOwnProperty("arguments") || t.hasOwnProperty("caller") || t.hasOwnProperty("prototype") || t.hasOwnProperty("toString")),
    "failed descriptor keys": Object.keys(Object.getOwnPropertyDescriptors(t)).sort().toString() != "length,name",
    "failed own property names": Object.getOwnPropertyNames(t).sort().toString() != "length,name",
    "failed own keys names": fe && Reflect.ownKeys(t).sort().toString() != "length,name",
    // Proxy Detection
    "failed object toString error": te({
      spawnErr: () => Object.create(t).toString(),
      withStack: (u) => K && !ge(u, Gt)
    }) || te({
      spawnErr: () => Object.create(new Proxy(t, {})).toString(),
      withStack: (u) => K && !ge(u, Vt)
    }),
    "failed at incompatible proxy error": te({
      spawnErr: () => {
        t.arguments, t.caller;
      },
      withStack: (u) => de && !ge(u, Ue, 0)
    }),
    "failed at toString incompatible proxy error": te({
      spawnErr: () => {
        t.toString.arguments, t.toString.caller;
      },
      withStack: (u) => de && !ge(u, Ue, 0)
    }),
    "failed at too much recursion error": te({
      spawnErr: () => {
        Object.setPrototypeOf(t, Object.create(t)).toString();
      },
      final: () => Object.setPrototypeOf(t, s)
    })
  };
  if (c == "toString" || !!i["Function.toString"] || !!i["Permissions.query"]) {
    const u = new Proxy(t, {});
    new Proxy(t, {});
    const b = new Proxy(t, {});
    o = {
      ...o,
      // Advanced Proxy Detection
      "failed at too much recursion __proto__ error": !te({
        spawnErr: () => {
          t.__proto__ = proxy, t++;
        },
        final: () => Object.setPrototypeOf(t, s)
      }),
      "failed at chain cycle error": !te({
        spawnErr: () => {
          Object.setPrototypeOf(u, Object.create(u)).toString();
        },
        final: () => Object.setPrototypeOf(u, s)
      }),
      // ['failed at chain cycle __proto__ error']: !failsTypeError({
      // 	spawnErr: () => {
      // 		// @ts-expect-error
      // 		proxy2.__proto__ = proxy2; proxy2++
      // 	},
      // 	final: () => Object.setPrototypeOf(proxy2, nativeProto),
      // }),
      "failed at reflect set proto": fe && te({
        spawnErr: () => {
          throw Reflect.setPrototypeOf(t, Object.create(t)), He in t, new TypeError();
        },
        final: () => Object.setPrototypeOf(t, s)
      }),
      "failed at reflect set proto proxy": fe && !te({
        spawnErr: () => {
          Reflect.setPrototypeOf(b, Object.create(b)), He in b;
        },
        final: () => Object.setPrototypeOf(b, s)
      }),
      "failed at instanceof check error": K && (te({
        spawnErr: () => {
          t instanceof t;
        },
        withStack: (l) => !ge(l, Wt)
      }) || te({
        spawnErr: () => {
          const l = new Proxy(t, {});
          l instanceof l;
        },
        withStack: (l) => !ge(l, Ht)
      })),
      "failed at define properties": K && fe && _t(() => {
        Object.defineProperty(t, "", { configurable: !0 }).toString(), Reflect.deleteProperty(t, "");
      })
    };
  }
  const d = Object.keys(o).filter((u) => !!o[u]);
  return {
    lied: d.length,
    lieTypes: d
  };
}
function zt(e) {
  const t = (i) => typeof i < "u" && !!i, n = {}, r = [];
  return {
    getProps: () => n,
    getPropsSearched: () => r,
    searchLies: (i, c) => {
      const { target: a, ignore: s } = c || {};
      let o;
      try {
        if (o = i(), !t(o))
          return;
      } catch {
        return;
      }
      const m = o.prototype ? o.prototype : o;
      [.../* @__PURE__ */ new Set([
        ...Object.getOwnPropertyNames(m),
        ...Object.keys(m)
        // backup
      ])].sort().forEach((d) => {
        var S;
        if (d == "constructor" || a && !new Set(a).has(d) || s && new Set(s).has(d)) return;
        const b = /\s(.+)\]/, l = `${o.name ? o.name : b.test(o) ? (S = b.exec(o)) == null ? void 0 : S[1] : void 0}.${d}`;
        r.push(l);
        try {
          const h = o.prototype ? o.prototype : o;
          let g;
          try {
            if (typeof h[d] == "function")
              return g = je({
                scope: e,
                apiFunction: h[d],
                proto: h,
                obj: null,
                lieProps: n
              }), g.lied ? (H(l, g.lieTypes), n[l] = g.lieTypes) : void 0;
            if (d != "name" && d != "length" && d[0] !== d[0].toUpperCase()) {
              const k = ["failed descriptor.value undefined"];
              return H(l, k), n[l] = k;
            }
          } catch {
          }
          const y = Object.getOwnPropertyDescriptor(h, d).get;
          return g = je({
            scope: e,
            apiFunction: y,
            proto: h,
            obj: o,
            lieProps: n
          }), g.lied ? (H(l, g.lieTypes), n[l] = g.lieTypes) : void 0;
        } catch {
          const g = "failed prototype test execution";
          return H(l, g), n[l] = [g];
        }
      });
    }
  };
}
function Ut() {
  if (Qe) return { iframeWindow: self };
  try {
    const e = self.length, t = new DocumentFragment(), n = document.createElement("div"), r = ve();
    n.setAttribute("id", r), t.appendChild(n), n.innerHTML = `<div style="${nt}"><iframe></iframe></div>`, document.body.appendChild(t);
    const i = self[e];
    return { iframeWindow: Bt(i) || self, div: n };
  } catch (e) {
    return W(e, "client blocked phantom iframe"), { iframeWindow: self };
  }
}
const { iframeWindow: $, div: me } = Ut() || {};
function jt(e) {
  const t = zt(e), {
    searchLies: n
  } = t;
  n(() => Function, {
    target: [
      "toString"
    ],
    ignore: [
      "caller",
      "arguments"
    ]
  }), n(() => AnalyserNode), n(() => AudioBuffer, {
    target: [
      "copyFromChannel",
      "getChannelData"
    ]
  }), n(() => BiquadFilterNode, {
    target: [
      "getFrequencyResponse"
    ]
  }), n(() => CanvasRenderingContext2D, {
    target: [
      "getImageData",
      "getLineDash",
      "isPointInPath",
      "isPointInStroke",
      "measureText",
      "quadraticCurveTo",
      "fillText",
      "strokeText",
      "font"
    ]
  }), n(() => CSSStyleDeclaration, {
    target: [
      "setProperty"
    ]
  }), n(() => CSS2Properties, {
    // Gecko
    target: [
      "setProperty"
    ]
  }), n(() => Date, {
    target: [
      "getDate",
      "getDay",
      "getFullYear",
      "getHours",
      "getMinutes",
      "getMonth",
      "getTime",
      "getTimezoneOffset",
      "setDate",
      "setFullYear",
      "setHours",
      "setMilliseconds",
      "setMonth",
      "setSeconds",
      "setTime",
      "toDateString",
      "toJSON",
      "toLocaleDateString",
      "toLocaleString",
      "toLocaleTimeString",
      "toString",
      "toTimeString",
      "valueOf"
    ]
  }), n(() => GPU, {
    target: [
      "requestAdapter"
    ]
  }), n(() => GPUAdapter, {
    target: [
      "requestAdapterInfo"
    ]
  }), n(() => Intl.DateTimeFormat, {
    target: [
      "format",
      "formatRange",
      "formatToParts",
      "resolvedOptions"
    ]
  }), n(() => Document, {
    target: [
      "createElement",
      "createElementNS",
      "getElementById",
      "getElementsByClassName",
      "getElementsByName",
      "getElementsByTagName",
      "getElementsByTagNameNS",
      "referrer",
      "write",
      "writeln"
    ],
    ignore: [
      // Gecko
      "onreadystatechange",
      "onmouseenter",
      "onmouseleave"
    ]
  }), n(() => DOMRect), n(() => DOMRectReadOnly), n(() => Element, {
    target: [
      "append",
      "appendChild",
      "getBoundingClientRect",
      "getClientRects",
      "insertAdjacentElement",
      "insertAdjacentHTML",
      "insertAdjacentText",
      "insertBefore",
      "prepend",
      "replaceChild",
      "replaceWith",
      "setAttribute"
    ]
  }), n(() => FontFace, {
    target: [
      "family",
      "load",
      "status"
    ]
  }), n(() => HTMLCanvasElement), n(() => HTMLElement, {
    target: [
      "clientHeight",
      "clientWidth",
      "offsetHeight",
      "offsetWidth",
      "scrollHeight",
      "scrollWidth"
    ],
    ignore: [
      // Gecko
      "onmouseenter",
      "onmouseleave"
    ]
  }), n(() => HTMLIFrameElement, {
    target: [
      "contentDocument",
      "contentWindow"
    ]
  }), n(() => IntersectionObserverEntry, {
    target: [
      "boundingClientRect",
      "intersectionRect",
      "rootBounds"
    ]
  }), n(() => Math, {
    target: [
      "acos",
      "acosh",
      "asinh",
      "atan",
      "atan2",
      "atanh",
      "cbrt",
      "cos",
      "cosh",
      "exp",
      "expm1",
      "log",
      "log10",
      "log1p",
      "sin",
      "sinh",
      "sqrt",
      "tan",
      "tanh"
    ]
  }), n(() => MediaDevices, {
    target: [
      "enumerateDevices",
      "getDisplayMedia",
      "getUserMedia"
    ]
  }), n(() => Navigator, {
    target: [
      "appCodeName",
      "appName",
      "appVersion",
      "buildID",
      "connection",
      "deviceMemory",
      "getBattery",
      "getGamepads",
      "getVRDisplays",
      "hardwareConcurrency",
      "language",
      "languages",
      "maxTouchPoints",
      "mimeTypes",
      "oscpu",
      "platform",
      "plugins",
      "product",
      "productSub",
      "sendBeacon",
      "serviceWorker",
      "storage",
      "userAgent",
      "vendor",
      "vendorSub",
      "webdriver",
      "gpu"
    ]
  }), n(() => Node, {
    target: [
      "appendChild",
      "insertBefore",
      "replaceChild"
    ]
  }), n(() => OffscreenCanvas, {
    target: [
      "convertToBlob",
      "getContext"
    ]
  }), n(() => OffscreenCanvasRenderingContext2D, {
    target: [
      "getImageData",
      "getLineDash",
      "isPointInPath",
      "isPointInStroke",
      "measureText",
      "quadraticCurveTo",
      "font"
    ]
  }), n(() => Permissions, {
    target: [
      "query"
    ]
  }), n(() => Range, {
    target: [
      "getBoundingClientRect",
      "getClientRects"
    ]
  }), n(() => Intl.RelativeTimeFormat, {
    target: [
      "resolvedOptions"
    ]
  }), n(() => Screen), n(() => speechSynthesis, {
    target: [
      "getVoices"
    ]
  }), n(() => String, {
    target: [
      "fromCodePoint"
    ]
  }), n(() => StorageManager, {
    target: [
      "estimate"
    ]
  }), n(() => SVGRect), n(() => SVGRectElement, {
    target: [
      "getBBox"
    ]
  }), n(() => SVGTextContentElement, {
    target: [
      "getExtentOfChar",
      "getSubStringLength",
      "getComputedTextLength"
    ]
  }), n(() => TextMetrics), n(() => WebGLRenderingContext, {
    target: [
      "bufferData",
      "getParameter",
      "readPixels"
    ]
  }), n(() => WebGL2RenderingContext, {
    target: [
      "bufferData",
      "getParameter",
      "readPixels"
    ]
  });
  const r = t.getProps(), i = t.getPropsSearched();
  return {
    lieDetector: t,
    lieList: Object.keys(r).sort(),
    lieDetail: r,
    lieCount: Object.keys(r).reduce((c, a) => c + r[a].length, 0),
    propsSearched: i
  };
}
const Xt = performance.now(), {
  lieDetector: Kt,
  lieDetail: $t
} = jt($), qt = (e) => e && e.filter((t) => !/object toString|toString incompatible proxy/.test(t)).length;
let w;
Qe || (w = (() => {
  const t = Kt.getProps();
  return Object.keys(t).reduce((n, r) => (n[r] = qt(t[r]), n), {});
})(), JSON.parse(JSON.stringify($t)), +(performance.now() - Xt).toFixed(2));
const Yt = (e, t) => {
  const n = [], r = Object.getOwnPropertyNames(e).filter((g) => isNaN(+g)), i = Object.getOwnPropertyNames(t).filter((g) => isNaN(+g)), c = [...e], a = [...t], s = new Set(i), m = ((g) => [...new Set(g)])(
    a.map((g) => g.enabledPlugin)
  ), d = new Set(r), u = m.map((g) => g && g.name);
  return [...d].forEach((g) => {
    new Set(u).has(g) || d.delete(g);
  }), c.filter((g) => {
    try {
      const y = Object.getPrototypeOf(g[0]).constructor.name == "MimeType";
      return y || d.delete(g.name), !y;
    } catch {
      return d.delete(g.name), !0;
    }
  }).length && n.push("missing mimetype"), c.map((g) => Object.values(g)).flat().map((g) => g.type).forEach((g) => {
    s.has(g) || s.delete(g);
  }), c.forEach((g) => Object.values(g).map((p) => p.type).forEach((p) => {
    if (!s.has(p))
      return n.push("invalid mimetype"), d.delete(g.name);
  })), {
    validPlugins: c.filter((g) => d.has(g.name)),
    validMimeTypes: a.filter((g) => s.has(g.type)),
    lies: [...new Set(n)]
    // remove duplicates
  };
}, Jt = () => {
  const e = tt.getRecords(), t = Object.keys(e).reduce((n, r) => (n += e[r].length, n), 0);
  return { data: e, totalLies: t };
}, Qt = (e) => typeof e == "function", Zt = /[cC]f|[jJ][bcdfghlmprsty]|[qQ][bcdfghjklmnpsty]|[vV][bfhjkmpt]|[xX][dkrz]|[yY]y|[zZ][fr]|[cCxXzZ]j|[bBfFgGjJkKpPvVqQtTwWyYzZ]q|[cCfFgGjJpPqQwW]v|[jJqQvV]w|[bBcCdDfFgGhHjJkKmMpPqQsSvVwWxXzZ]x|[bBfFhHjJkKmMpPqQ]z/g, Ae = (e, { strict: t = !1 } = {}) => {
  if (!e) return [];
  const n = [];
  [
    /([A-Z]{3,}[a-z])/g,
    // ABCd
    /([a-z][A-Z]{3,})/g,
    // aBCD
    /([a-z][A-Z]{2,}[a-z])/g,
    // aBC...z
    /([a-z][\d]{2,}[a-z])/g,
    // a##...b
    /([A-Z][\d]{2,}[a-z])/g,
    // A##...b
    /([a-z][\d]{2,}[A-Z])/g
    // a##...B
  ].forEach((d) => {
    const u = e.match(d);
    if (u)
      return n.push(u.join(", "));
  });
  const i = [], c = e.replace(/\d|\W|_/g, " ").replace(/\s+/g, " ").trim().split(" ").join("_"), a = c.length, s = [...c];
  s.forEach((d, u) => {
    const b = u + 1, l = s[b];
    if (l !== "_" && d !== "_" && b !== a) {
      const h = d + l;
      Zt.test(h) && i.push(h);
    }
  });
  const o = [
    // ignore sequence if less than 3 exist
    ...!t && i.length < 3 ? [] : i,
    ...!t && n.length < 4 ? [] : n
  ], m = [
    // known gibbers
    "bz",
    "cf",
    "fx",
    "mx",
    "vb",
    "xd",
    "gx",
    "PCIe",
    "vm",
    "NVIDIAGa"
  ];
  return o.filter((d) => !m.includes(d));
};
function en(e) {
  if (e)
    return ("" + e).replace(/ANGLE \(|\sDirect3D.+|\sD3D.+|\svs_.+\)|\((DRM|POLARIS|LLVM).+|Mesa.+|(ATI|INTEL)-.+|Metal\s-\s.+|NVIDIA\s[\d|\.]+/ig, "").replace(/(\s(ti|\d{1,2}GB|super)$)/ig, "").replace(/\s{2,}/g, " ").trim().replace(/((r|g)(t|)(x|s|\d) |Graphics |GeForce |Radeon (HD |Pro |))(\d+)/i, (...t) => `${t[1]}${t[6][0]}${t[6].slice(1).replace(/\d/g, "0")}s`);
}
const tn = (e) => {
  const n = [...[
    "AMD",
    "ANGLE",
    "ASUS",
    "ATI",
    "ATI Radeon",
    "ATI Technologies Inc",
    "Adreno",
    "Android Emulator",
    "Apple",
    "Apple GPU",
    "Apple M1",
    "Chipset",
    "D3D11",
    "Direct3D",
    "Express Chipset",
    "GeForce",
    "Generation",
    "Generic Renderer",
    "Google",
    "Google SwiftShader",
    "Graphics",
    "Graphics Media Accelerator",
    "HD Graphics Family",
    "Intel",
    "Intel(R) HD Graphics",
    "Intel(R) UHD Graphics",
    "Iris",
    "KBL Graphics",
    "Mali",
    "Mesa",
    "Mesa DRI",
    "Metal",
    "Microsoft",
    "Microsoft Basic Render Driver",
    "Microsoft Corporation",
    "NVIDIA",
    "NVIDIA Corporation",
    "NVIDIAGameReadyD3D",
    "OpenGL",
    "OpenGL Engine",
    "Open Source Technology Center",
    "Parallels",
    "Parallels Display Adapter",
    "PCIe",
    "Plus Graphics",
    "PowerVR",
    "Pro Graphics",
    "Quadro",
    "Radeon",
    "Radeon Pro",
    "Radeon Pro Vega",
    "Samsung",
    "SSE2",
    "VMware",
    "VMware SVGA 3D",
    "Vega",
    "VirtualBox",
    "VirtualBox Graphics Adapter",
    "Vulkan",
    "Xe Graphics",
    "llvmpipe"
  ]].filter((r) => ("" + e).includes(r));
  return [...new Set(n)].sort().join(", ");
}, nn = (e) => {
  if (!e)
    return;
  const t = tn(e), n = t.length, r = /\s{2,}|^\s|\s$/.test(e), i = /^ANGLE/.test(e) && !(/^ANGLE \((.+)\)/.exec(e) || [])[1], c = Ae(e, { strict: !0 }).join(", "), a = n && !r && !i, s = a && !c.length ? "high" : a && c.length ? "moderate" : "low", o = s == "high" ? "A" : s == "moderate" ? "C" : "F", m = /* @__PURE__ */ new Set([
    r ? "found extra spaces" : void 0,
    i ? "broken angle structure" : void 0
  ]);
  return m.delete(void 0), {
    parts: t,
    warnings: [...m],
    gibbers: c,
    confidence: s,
    grade: o
  };
}, on = () => {
  const e = [];
  return {
    getBin: () => e,
    sendToTrash: (t, n, r = void 0) => {
      const c = Qt(n) ? "proxy behavior detected" : n;
      return e.push({ name: t, value: c }), r;
    }
  };
}, ot = on(), { sendToTrash: U } = ot, rn = () => ({ trashBin: ot.getBin() }), Xe = Math.random();
async function an() {
  const e = new OfflineAudioContext(1, 100, 44100), t = e.createOscillator();
  return t.frequency.value = 0, t.start(0), e.startRendering(), new Promise((n) => {
    e.oncomplete = (r) => {
      var c, a;
      const i = (a = (c = r.renderedBuffer).getChannelData) == null ? void 0 : a.call(c, 0);
      i || n(!1), n("" + [...new Set(i)] != "0");
    };
  }).finally(() => t.disconnect());
}
async function sn() {
  var e, t, n;
  try {
    try {
      window.OfflineAudioContext = OfflineAudioContext || webkitOfflineAudioContext;
    } catch {
    }
    if (!window.OfflineAudioContext) {
      Se({ test: "audio", passed: !1 });
      return;
    }
    const r = w["AudioBuffer.getChannelData"], i = w["AudioBuffer.copyFromChannel"];
    let c = r || i || !1;
    const a = 5e3, s = new OfflineAudioContext(1, a, 44100), o = s.createAnalyser(), m = s.createOscillator(), d = s.createDynamicsCompressor(), u = s.createBiquadFilter(), b = new Float32Array(o.frequencyBinCount);
    (e = o.getFloatFrequencyData) == null || e.call(o, b);
    const l = new Set(b).size;
    if (l > 1) {
      c = !0;
      const x = `expected -Infinity (silence) and got ${l} frequencies`;
      H("AnalyserNode.getFloatFrequencyData", x);
    }
    const S = {
      "AnalyserNode.channelCount": C(() => o.channelCount),
      "AnalyserNode.channelCountMode": C(() => o.channelCountMode),
      "AnalyserNode.channelInterpretation": C(() => o.channelInterpretation),
      "AnalyserNode.context.sampleRate": C(() => o.context.sampleRate),
      "AnalyserNode.fftSize": C(() => o.fftSize),
      "AnalyserNode.frequencyBinCount": C(() => o.frequencyBinCount),
      "AnalyserNode.maxDecibels": C(() => o.maxDecibels),
      "AnalyserNode.minDecibels": C(() => o.minDecibels),
      "AnalyserNode.numberOfInputs": C(() => o.numberOfInputs),
      "AnalyserNode.numberOfOutputs": C(() => o.numberOfOutputs),
      "AnalyserNode.smoothingTimeConstant": C(() => o.smoothingTimeConstant),
      "AnalyserNode.context.listener.forwardX.maxValue": C(() => se(() => o.context.listener.forwardX.maxValue)),
      "BiquadFilterNode.gain.maxValue": C(() => u.gain.maxValue),
      "BiquadFilterNode.frequency.defaultValue": C(() => u.frequency.defaultValue),
      "BiquadFilterNode.frequency.maxValue": C(() => u.frequency.maxValue),
      "DynamicsCompressorNode.attack.defaultValue": C(() => d.attack.defaultValue),
      "DynamicsCompressorNode.knee.defaultValue": C(() => d.knee.defaultValue),
      "DynamicsCompressorNode.knee.maxValue": C(() => d.knee.maxValue),
      "DynamicsCompressorNode.ratio.defaultValue": C(() => d.ratio.defaultValue),
      "DynamicsCompressorNode.ratio.maxValue": C(() => d.ratio.maxValue),
      "DynamicsCompressorNode.release.defaultValue": C(() => d.release.defaultValue),
      "DynamicsCompressorNode.release.maxValue": C(() => d.release.maxValue),
      "DynamicsCompressorNode.threshold.defaultValue": C(() => d.threshold.defaultValue),
      "DynamicsCompressorNode.threshold.minValue": C(() => d.threshold.minValue),
      "OscillatorNode.detune.maxValue": C(() => m.detune.maxValue),
      "OscillatorNode.detune.minValue": C(() => m.detune.minValue),
      "OscillatorNode.frequency.defaultValue": C(() => m.frequency.defaultValue),
      "OscillatorNode.frequency.maxValue": C(() => m.frequency.maxValue),
      "OscillatorNode.frequency.minValue": C(() => m.frequency.minValue)
    }, h = (x) => new Promise((P) => {
      const z = x.createAnalyser(), Z = x.createOscillator(), X = x.createDynamicsCompressor();
      try {
        Z.type = "triangle", Z.frequency.value = 1e4, X.threshold.value = -50, X.knee.value = 40, X.attack.value = 0;
      } catch {
      }
      return Z.connect(X), X.connect(z), X.connect(x.destination), Z.start(0), x.startRendering(), x.addEventListener("complete", (ne) => {
        var be;
        try {
          X.disconnect(), Z.disconnect();
          const ue = new Float32Array(z.frequencyBinCount);
          (be = z.getFloatFrequencyData) == null || be.call(z, ue);
          const we = new Float32Array(z.fftSize);
          return "getFloatTimeDomainData" in z && z.getFloatTimeDomainData(we), P({
            floatFrequencyData: ue,
            floatTimeDomainData: we,
            buffer: ne.renderedBuffer,
            compressorGainReduction: (
              // @ts-expect-error if unsupported
              X.reduction.value || // webkit
              X.reduction
            )
          });
        } catch {
          return P(null);
        }
      });
    }), [
      g,
      y
    ] = await Promise.all([
      h(new OfflineAudioContext(1, a, 44100)),
      an().catch(() => !1)
    ]), {
      floatFrequencyData: p,
      floatTimeDomainData: k,
      buffer: v,
      compressorGainReduction: I
    } = g || {}, E = (x, P, z) => {
      const Z = [];
      for (let X = P; X < z; X++)
        Z.push(x[X]);
      return Z;
    }, f = (x) => x ? [...x].reduce((P, z) => P += Math.abs(z), 0) : 0, D = f(p), A = f(k), T = new Float32Array(a);
    let N = new Float32Array();
    v && ((t = v.copyFromChannel) == null || t.call(v, T, 0), N = ((n = v.getChannelData) == null ? void 0 : n.call(v, 0)) || []);
    const F = E([...T], 4500, 4600), L = E([...N], 4500, 4600), _ = f(E([...N], 4500, a));
    y && (c = !0, H("AudioBuffer", "audio is fake"));
    const G = "" + L == "" + F, j = "copyFromChannel" in AudioBuffer.prototype;
    j && !G && (c = !0, H("AudioBuffer", "getChannelData and copyFromChannel samples mismatch"));
    const R = (/* @__PURE__ */ new Set([...N])).size;
    if (R == a) {
      const x = `${R} unique samples of ${a} is too high`;
      U("AudioBuffer", x);
    }
    const B = (x, P) => Math.floor(Math.random() * (P - x + 1)) + x, V = (x, P, z) => {
      const { length: Z } = P, X = 20, ne = B(275, Z - (X + 1)), be = ne + X / 2, ue = ne + X;
      P.getChannelData(0)[ne] = x, P.getChannelData(0)[be] = x, P.getChannelData(0)[ue] = x, P.copyFromChannel(z, 0);
      const we = [
        P.getChannelData(0)[ne] === 0 ? Math.random() : 0,
        P.getChannelData(0)[be] === 0 ? Math.random() : 0,
        P.getChannelData(0)[ue] === 0 ? Math.random() : 0
      ];
      return [.../* @__PURE__ */ new Set([...P.getChannelData(0), ...z, ...we])].filter((at) => at !== 0);
    }, Q = (x, P, z) => {
      P.copyToChannel(z.map(() => x), 0);
      const Z = P.getChannelData(0)[0];
      return [...P.getChannelData(0)].map((ne) => ne !== Z || !ne ? Math.random() : ne).filter((ne) => ne !== Z);
    }, M = (() => {
      try {
        const P = [.../* @__PURE__ */ new Set([
          ...V(
            Xe,
            new AudioBuffer({ length: 2e3, sampleRate: 44100 }),
            new Float32Array(2e3)
          ),
          ...Q(
            Xe,
            new AudioBuffer({ length: 2e3, sampleRate: 44100 }),
            new Float32Array(2e3)
          )
        ])];
        return +(P.length !== 1 && P.reduce((z, Z) => z += +Z, 0));
      } catch (P) {
        return console.error(P), 0;
      }
    })() || [...new Set(N.slice(0, 100))].reduce((x, P) => x += P, 0), O = {
      /* BLINK */
      // 124.04347527516074/124.04347518575378
      "-20.538286209106445,164537.64796829224,502.5999283068122": [124.04347527516074],
      "-20.538288116455078,164537.64796829224,502.5999283068122": [124.04347527516074],
      "-20.538288116455078,164537.64795303345,502.5999283068122": [
        124.04347527516074,
        124.04347518575378,
        // sus:
        124.04347519320436,
        124.04347523045726
      ],
      "-20.538286209106445,164537.64805984497,502.5999283068122": [124.04347527516074],
      "-20.538288116455078,164537.64805984497,502.5999283068122": [
        124.04347527516074,
        124.04347518575378,
        // sus
        124.04347520065494,
        124.04347523790784,
        124.043475252809,
        124.04347526025958,
        124.04347522300668,
        124.04347523045726,
        124.04347524535842
      ],
      // 124.04344884395687
      "-20.538288116455078,164881.9727935791,502.59990317908887": [124.04344884395687],
      "-20.538288116455078,164881.9729309082,502.59990317908887": [124.04344884395687],
      // 124.0434488439787
      "-20.538286209106445,164882.2082748413,502.59990317911434": [124.0434488439787],
      "-20.538288116455078,164882.20836639404,502.59990317911434": [124.0434488439787],
      // 124.04344968475198
      "-20.538286209106445,164863.45319366455,502.5999033495791": [124.04344968475198],
      "-20.538288116455078,164863.45319366455,502.5999033495791": [
        124.04344968475198,
        124.04375314689969,
        // rare
        // sus
        124.04341541208123
      ],
      // 124.04347503720783 (rare)
      "-20.538288116455078,164531.82670593262,502.59992767886797": [
        124.04347503720783,
        // sus
        124.04347494780086,
        124.04347495525144,
        124.04347499250434,
        124.0434750074055
      ],
      // 124.04347657808103
      "-20.538286209106445,164540.1567993164,502.59992209258417": [124.04347657808103],
      "-20.538288116455078,164540.1567993164,502.59992209258417": [
        124.04347657808103,
        124.0434765110258,
        // rare
        124.04347656317987,
        // rare
        // sus
        124.04347657063045,
        124.04378004022874
      ],
      "-20.538288116455078,164540.1580810547,502.59992209258417": [124.04347657808103],
      // 124.080722568091/124.04347730590962 (rare)
      "-20.535268783569336,164940.360786438,502.69695458233764": [124.080722568091],
      "-20.538288116455078,164538.55073928833,502.5999307175407": [124.04347730590962],
      // Android/Linux
      "-20.535268783569336,164948.14596557617,502.6969545823631": [124.08072256811283],
      "-20.535268783569336,164926.65912628174,502.6969610930064": [124.08072766105033],
      "-20.535268783569336,164932.96168518066,502.69696179985476": [124.08072787802666],
      "-20.535268783569336,164931.54252624512,502.6969617998802": [124.08072787804849],
      "-20.535268783569336,164591.9659729004,502.6969925059784": [124.08074500028306],
      "-20.535268783569336,164590.4111480713,502.6969947774742": [124.0807470110085],
      "-20.535268783569336,164590.41115570068,502.6969947774742": [124.0807470110085],
      "-20.535268783569336,164593.64263916016,502.69700490119067": [124.08075528279005],
      "-20.535268783569336,164595.0285797119,502.69700578315314": [124.08075643483608],
      // sus
      "-20.538288116455078,164860.96576690674,502.6075748118915": [124.0434496279413],
      "-20.538288116455078,164860.9938583374,502.6073723861407": [124.04344962817413],
      "-20.538288116455078,164862.14078521729,502.59991004130643": [124.04345734833623],
      "-20.538288116455078,164534.50047683716,502.61542110471055": [124.04347520368174],
      "-20.538288116455078,164535.1324043274,502.6079200572931": [124.04347521997988],
      "-20.538288116455078,164535.51135635376,502.60633126448374": [124.04347522952594],
      /* GECKO */
      "-31.509262084960938,167722.6894454956,148.42717787250876": [35.7383295930922],
      "-31.509262084960938,167728.72756958008,148.427184343338": [35.73833402246237],
      "-31.50218963623047,167721.27517700195,148.47537828609347": [35.74996031448245],
      "-31.502185821533203,167727.52931976318,148.47542023658752": [35.7499681673944],
      "-31.502185821533203,167700.7530517578,148.475412953645": [35.749968223273754],
      "-31.502187728881836,167697.23177337646,148.47541113197803": [35.74996626004577],
      /* WEBKIT */
      "-20.538288116455078,164873.80361557007,502.59989904452596": [124.0434485301812],
      "-20.538288116455078,164863.47760391235,502.5999033453372": [124.0434496849557],
      "-20.538288116455078,164876.62466049194,502.5998911961724": [124.043453265891],
      "-20.538288116455078,164862.14879989624,502.59991004130643": [124.04345734833623],
      "-20.538288116455078,164896.54167175293,502.5999054916465": [124.04345808873768],
      "-29.837873458862305,163206.43050384521,0": [35.10892717540264],
      "-29.837873458862305,163224.69785308838,0": [35.10892752557993],
      "-29.83786964416504,163209.17245483398,0": [35.10893232002854],
      "-29.83786964416504,163202.77336883545,0": [35.10893253237009]
    };
    M && (c = !0, H("AudioBuffer", "sample noise detected"));
    const q = "" + [
      I,
      D,
      A
    ], Y = O[q];
    return Y && !Y.includes(_) && (re.AUDIO = !0, U("AudioBuffer", "suspicious frequency data")), {
      totalUniqueSamples: R,
      compressorGainReduction: I,
      floatFrequencyDataSum: D,
      floatTimeDomainDataSum: A,
      sampleSum: _,
      binsSample: L,
      copySample: j ? F : [void 0],
      values: S,
      noise: M,
      lied: c
    };
  } catch (r) {
    W(r, "OfflineAudioContext failed or blocked by client");
    return;
  }
}
let cn = "";
const ln = () => {
  const e = [], t = [];
  try {
    const c = {
      willReadFrequently: !0,
      desynchronized: !0
    }, a = document.createElement("canvas"), s = document.createElement("canvas"), o = document.createElement("canvas"), m = document.createElement("canvas"), d = a.getContext("2d", c), u = s.getContext("2d", c), b = o.getContext("2d", c), l = m.getContext("2d", c);
    if (!d || !u || !b || !l)
      throw new Error("canvas context blocked");
    a.width = 8 * 5, a.height = 8 * 5, s.width = 8 * 5, s.height = 8 * 5, o.width = 8, o.height = 8, m.width = 8, m.height = 8, [...Array(8)].forEach((k, v) => [...Array(8)].forEach((I, E) => {
      const f = ~~(Math.random() * 256), D = ~~(Math.random() * 256), A = ~~(Math.random() * 256), T = `${f}, ${D}, ${A}, 255`;
      return b.fillStyle = `rgba(${T})`, b.fillRect(v, E, 1, 1), d.fillStyle = `rgba(${T})`, d.fillRect(
        v * 5,
        E * 5,
        1 * 5,
        1 * 5
      ), e.push(T);
    })), [...Array(8)].forEach((k, v) => [...Array(8)].forEach((I, E) => {
      const {
        data: [f, D, A, T]
      } = b.getImageData(v, E, 1, 1) || {}, N = `${f}, ${D}, ${A}, ${T}`;
      l.fillStyle = `rgba(${N})`, l.fillRect(v, E, 1, 1);
      const {
        data: [F, L, _, G]
      } = l.getImageData(v, E, 1, 1) || {}, j = `
				${f != F ? F : 255},
				${D != L ? L : 255},
				${A != _ ? _ : 255},
				${T != G ? G : 1}
			`;
      return u.fillStyle = `rgba(${j})`, u.fillRect(
        v * 5,
        E * 5,
        1 * 5,
        1 * 5
      ), t.push(N);
    }));
    const S = [], h = /* @__PURE__ */ new Set();
    [...Array(e.length)].forEach((k, v) => {
      const I = e[v], E = t[v];
      if (I != E) {
        const f = I.split(","), D = E.split(","), A = [
          f[0] != D[0] ? "r" : "",
          f[1] != D[1] ? "g" : "",
          f[2] != D[2] ? "b" : "",
          f[3] != D[3] ? "a" : ""
        ].join("");
        h.add(A), S.push([v, A]);
      }
    }), cn = a.toDataURL();
    const g = s.toDataURL(), y = h.size ? [...h].sort().join(", ") : void 0, p = S.length || void 0;
    return { rgba: y, pixels: p, pixelImage: g };
  } catch (c) {
    return console.error(c);
  }
}, Ce = ({
  canvas: e,
  context: t,
  strokeText: n = !1,
  cssFontFamily: r = "",
  area: i = { width: 50, height: 50 },
  rounds: c = 10,
  maxShadowBlur: a = 50,
  seed: s = 500,
  offset: o = 2001000001,
  multiplier: m = 15e3
}) => {
  if (!t)
    return;
  t.clearRect(0, 0, e.width, e.height), e.width = i.width, e.height = i.height, e.style && (e.style.display = "none");
  const u = (({ seed: E, offset: f, multiplier: D }) => {
    let A = Number(E) % Number(f);
    return {
      getNextSeed: () => (A = Number(D) * A % Number(f), A)
    };
  })({ seed: s, offset: o, multiplier: m }), { getNextSeed: b } = u, l = (E, f, D, A) => {
    const T = (E - 1) / f * (D || 1) || 0;
    return A ? T : Math.floor(T);
  }, S = (E, f, D, A, T) => {
    const { width: N, height: F } = D, L = E.createRadialGradient(
      l(T(), f, N),
      l(T(), f, F),
      l(T(), f, N),
      l(T(), f, N),
      l(T(), f, F),
      l(T(), f, N)
    );
    L.addColorStop(0, A[l(T(), f, A.length)]), L.addColorStop(1, A[l(T(), f, A.length)]), E.fillStyle = L;
  }, h = [
    "#FF6633",
    "#FFB399",
    "#FF33FF",
    "#FFFF99",
    "#00B3E6",
    "#E6B333",
    "#3366E6",
    "#999966",
    "#99FF99",
    "#B34D4D",
    "#80B300",
    "#809900",
    "#E6B3B3",
    "#6680B3",
    "#66991A",
    "#FF99E6",
    "#CCFF1A",
    "#FF1A66",
    "#E6331A",
    "#33FFCC",
    "#66994D",
    "#B366CC",
    "#4D8000",
    "#B33300",
    "#CC80CC",
    "#66664D",
    "#991AFF",
    "#E666FF",
    "#4DB3FF",
    "#1AB399",
    "#E666B3",
    "#33991A",
    "#CC9999",
    "#B3B31A",
    "#00E680",
    "#4D8066",
    "#809980",
    "#E6FF80",
    "#1AFF33",
    "#999933",
    "#FF3380",
    "#CCCC00",
    "#66E64D",
    "#4D80CC",
    "#9900B3",
    "#E64D66",
    "#4DB380",
    "#FF4D4D",
    "#99E6E6",
    "#6666FF"
  ], g = (E, f, D, A) => {
    const { width: T, height: N } = D, F = 2.99;
    E.font = `${N / F}px ${r.replace(/!important/gm, "")}`, E.strokeText(
      "👾A",
      l(A(), f, T),
      l(A(), f, N),
      l(A(), f, T)
    );
  }, y = (E, f, D, A) => {
    const { width: T, height: N } = D;
    E.beginPath(), E.arc(
      l(A(), f, T),
      l(A(), f, N),
      l(A(), f, Math.min(T, N)),
      l(A(), f, 2 * Math.PI, !0),
      l(A(), f, 2 * Math.PI, !0)
    ), E.stroke();
  }, p = (E, f, D, A) => {
    const { width: T, height: N } = D;
    E.beginPath(), E.moveTo(
      l(A(), f, T),
      l(A(), f, N)
    ), E.bezierCurveTo(
      l(A(), f, T),
      l(A(), f, N),
      l(A(), f, T),
      l(A(), f, N),
      l(A(), f, T),
      l(A(), f, N)
    ), E.stroke();
  }, k = (E, f, D, A) => {
    const { width: T, height: N } = D;
    E.beginPath(), E.moveTo(
      l(A(), f, T),
      l(A(), f, N)
    ), E.quadraticCurveTo(
      l(A(), f, T),
      l(A(), f, N),
      l(A(), f, T),
      l(A(), f, N)
    ), E.stroke();
  }, v = (E, f, D, A) => {
    if (!("ellipse" in E))
      return;
    const { width: T, height: N } = D;
    E.beginPath(), E.ellipse(
      l(A(), f, T),
      l(A(), f, N),
      l(A(), f, Math.floor(T / 2)),
      l(A(), f, Math.floor(N / 2)),
      l(A(), f, 2 * Math.PI, !0),
      l(A(), f, 2 * Math.PI, !0),
      l(A(), f, 2 * Math.PI, !0)
    ), E.stroke();
  }, I = [
    y,
    p,
    k
  ];
  pe || I.push(v), n && I.push(g), [...Array(c)].forEach((E) => {
    S(t, o, i, h, b), t.shadowBlur = l(b(), o, a, !0), t.shadowColor = h[l(b(), o, h.length)];
    const f = I[l(b(), o, I.length)];
    f(t, o, i, b), t.fill();
  });
};
async function mn() {
  try {
    const e = w["HTMLCanvasElement.toDataURL"], t = w["HTMLCanvasElement.getContext"], n = w["CanvasRenderingContext2D.fillText"] || w["CanvasRenderingContext2D.font"] || w["CanvasRenderingContext2D.getImageData"] || w["CanvasRenderingContext2D.strokeText"], r = w["String.fromCodePoint"];
    let i = w["CanvasRenderingContext2D.measureText"] || w["TextMetrics.actualBoundingBoxAscent"] || w["TextMetrics.actualBoundingBoxDescent"] || w["TextMetrics.actualBoundingBoxLeft"] || w["TextMetrics.actualBoundingBoxRight"] || w["TextMetrics.fontBoundingBoxAscent"] || w["TextMetrics.fontBoundingBoxDescent"] || w["TextMetrics.width"], c = e || t || n || i || r || !1, a = window;
    !Ze && $ && (a = $);
    const s = a.document, o = s.createElement("canvas"), m = o.getContext("2d"), d = s.createElement("canvas"), u = d.getContext("2d", {
      desynchronized: !0,
      willReadFrequently: !0
    });
    if (!m)
      throw new Error("canvas context blocked");
    const b = pe ? 50 : 75;
    Ce({
      canvas: o,
      context: m,
      strokeText: !0,
      cssFontFamily: ce,
      area: { width: b, height: b },
      rounds: 10
    });
    const l = o.toDataURL(), S = ln();
    m.font = `10px ${ce.replace(/!important/gm, "")}`;
    const h = /* @__PURE__ */ new Set(), g = le.reduce((T, N) => {
      const {
        actualBoundingBoxAscent: F,
        actualBoundingBoxDescent: L,
        actualBoundingBoxLeft: _,
        actualBoundingBoxRight: G,
        fontBoundingBoxAscent: j,
        fontBoundingBoxDescent: R,
        width: B
      } = m.measureText(N) || {}, V = [
        F,
        L,
        _,
        G,
        j,
        R,
        B
      ].join(",");
      return h.has(V) || (h.add(V), T.add(N)), T;
    }, /* @__PURE__ */ new Set()), y = 1e-5 * [...h].map((T) => T.split(",").reduce((N, F) => N += +F || 0, 0)).reduce((T, N) => T += N, 0), p = 75;
    Ce({
      canvas: o,
      context: m,
      area: { width: p, height: p }
    });
    const k = o.toDataURL();
    Ce({
      canvas: d,
      context: u,
      area: { width: p, height: p }
    });
    const v = d.toDataURL();
    m.restore(), m.clearRect(0, 0, o.width, o.height), o.width = 50, o.height = 50, m.font = `50px ${ce.replace(/!important/gm, "")}`, m.fillText("A", 7, 37);
    const I = o.toDataURL();
    m.restore(), m.clearRect(0, 0, o.width, o.height), o.width = 50, o.height = 50, m.font = `35px ${ce.replace(/!important/gm, "")}`, m.fillText("👾", 0, 37);
    const E = o.toDataURL();
    m.clearRect(0, 0, o.width, o.height), (S && S.pixels || Math.max(...m.getImageData(0, 0, 8, 8).data)) && (c = !0, H("CanvasRenderingContext2D.getImageData", "pixel data modified")), o.width = 2, o.height = 2, m.fillStyle = "#000", m.fillRect(0, 0, o.width, o.height), m.fillStyle = "#fff", m.fillRect(2, 2, 1, 1), m.beginPath(), m.arc(0, 0, 2, 0, 1, !0), m.closePath(), m.fill();
    const f = m.getImageData(0, 0, 2, 2).data.join(""), D = {
      BLINK: [
        "255255255255178178178255246246246255555555255",
        "255255255255192192192255240240240255484848255",
        "255255255255177177177255246246246255535353255",
        "255255255255128128128255191191191255646464255",
        "255255255255178178178255247247247255565656255",
        // ?
        "255255255255174174174255242242242255474747255",
        "255255255255229229229255127127127255686868255",
        "255255255255192192192255244244244255535353255"
      ],
      GECKO: [
        "255255255255191191191255207207207255646464255",
        "255255255255192192192255240240240255484848255",
        "255255255255191191191255239239239255646464255",
        "255255255255191191191255223223223255606060255",
        // ?
        "255255255255171171171255223223223255606060255"
        // ?
      ],
      WEBKIT: [
        "255255255255185185185255233233233255474747255",
        "255255255255185185185255229229229255474747255",
        "255255255255185185185255218218218255474747255",
        "255255255255192192192255240240240255484848255",
        "255255255255178178178255247247247255565656255",
        "255255255255178178178255247247247255565656255",
        "255255255255192192192255240240240255484848255",
        "255255255255186186186255218218218255464646255"
      ]
    };
    return ae.imageDataLowEntropy = f, (K && !D.BLINK.includes(f) || de && !D.GECKO.includes(f) || pe && !D.WEBKIT.includes(f)) && (re.CANVAS = !0), re.CANVAS && U("CanvasRenderingContext2D.getImageData", "suspicious pixel data"), ((T) => {
      const N = (V) => V % 1 !== 0, {
        actualBoundingBoxAscent: F,
        actualBoundingBoxDescent: L,
        actualBoundingBoxLeft: _,
        actualBoundingBoxRight: G,
        fontBoundingBoxAscent: j,
        fontBoundingBoxDescent: R
        // width: w,
      } = T.measureText("") || {};
      return [
        F,
        L,
        _,
        G,
        j,
        R
      ].find((V) => N(V || 0));
    })(m) && (i = !0, c = !0, H(
      "CanvasRenderingContext2D.measureText",
      "metric noise detected"
    )), {
      dataURI: l,
      paintURI: k,
      paintCpuURI: v,
      textURI: I,
      emojiURI: E,
      mods: S,
      textMetricsSystemSum: y,
      liedTextMetrics: i,
      emojiSet: [...g],
      lied: c
    };
  } catch (e) {
    W(e);
    return;
  }
}
function dn() {
  const e = (n, { require: [r] }) => {
    try {
      const i = n == "getComputedStyle" ? getComputedStyle(document.body) : n == "HTMLElement.style" ? document.body.style : (
        // @ts-ignore
        n == "CSSRuleList.style" ? document.styleSheets[0].cssRules[0].style : void 0
      );
      if (!i)
        throw new TypeError("invalid argument string");
      const c = Object.getPrototypeOf(i), a = Object.getOwnPropertyNames(c), s = [], o = /^--.*$/;
      Object.keys(i).forEach((g) => {
        const y = !isNaN(+g), p = i[g], k = o.test(g), v = o.test(p);
        if (y && !v)
          return s.push(p);
        if (!y && !k)
          return s.push(g);
      });
      const m = {}, d = (g) => g.charAt(0).toUpperCase() + g.slice(1), u = (g) => g.charAt(0).toLowerCase() + g.slice(1), b = (g) => g.slice(1), l = /[A-Z]/g;
      s.forEach((g) => {
        if (m[g])
          return;
        const y = g.indexOf("-") > -1, p = l.test(g), k = g.charAt(0), v = y && k == "-", I = p && k == k.toUpperCase();
        if (g = v ? b(g) : I ? u(g) : g, y) {
          const E = g.split("-").map((f, D) => D == 0 ? f : d(f)).join("");
          E in i ? m[E] = !0 : d(E) in i && (m[d(E)] = !0);
        } else if (p) {
          const E = g.replace(l, (f) => "-" + f.toLowerCase());
          E in i ? m[E] = !0 : `-${E}` in i && (m[`-${E}`] = !0);
        }
      });
      const S = [
        .../* @__PURE__ */ new Set([
          ...a,
          ...s,
          ...Object.keys(m)
        ])
      ], h = ("" + c).match(/\[object (.+)\]/)[1];
      return { keys: S, interfaceName: h };
    } catch (i) {
      r(i);
      return;
    }
  }, t = (n) => {
    try {
      const r = [
        "ActiveBorder",
        "ActiveCaption",
        "ActiveText",
        "AppWorkspace",
        "Background",
        "ButtonBorder",
        "ButtonFace",
        "ButtonHighlight",
        "ButtonShadow",
        "ButtonText",
        "Canvas",
        "CanvasText",
        "CaptionText",
        "Field",
        "FieldText",
        "GrayText",
        "Highlight",
        "HighlightText",
        "InactiveBorder",
        "InactiveCaption",
        "InactiveCaptionText",
        "InfoBackground",
        "InfoText",
        "LinkText",
        "Mark",
        "MarkText",
        "Menu",
        "MenuText",
        "Scrollbar",
        "ThreeDDarkShadow",
        "ThreeDFace",
        "ThreeDHighlight",
        "ThreeDLightShadow",
        "ThreeDShadow",
        "VisitedText",
        "Window",
        "WindowFrame",
        "WindowText"
      ], i = [
        "caption",
        "icon",
        "menu",
        "message-box",
        "small-caption",
        "status-bar"
      ], c = (a) => ({
        colors: r.map((s) => (a.setAttribute("style", `background-color: ${s} !important`), {
          [s]: getComputedStyle(a).backgroundColor
        })),
        fonts: i.map((s) => {
          a.setAttribute("style", `font: ${s} !important`);
          const o = getComputedStyle(a);
          return {
            [s]: `${o.fontSize} ${o.fontFamily}`
          };
        })
      });
      if (!n) {
        n = document.createElement("div"), document.body.append(n);
        const a = c(n);
        return n.parentNode.removeChild(n), a;
      }
      return c(n);
    } catch (r) {
      W(r);
      return;
    }
  };
  try {
    const n = e("getComputedStyle", { require: [W] }), r = t(me);
    return {
      computedStyle: n,
      system: r
    };
  } catch (n) {
    W(n);
    return;
  }
}
function un() {
  const e = (i, c) => c == 0 ? i : e(c, i % c), t = (i, c) => {
    const a = e(i, c);
    return `${i / a}/${c / a}`;
  }, n = ({ body: i, type: c, rangeStart: a, rangeLen: s }) => {
    const o = [...Array(s)].map((d, u) => (u += a, `@media(device-${c}:${u}px){body{--device-${c}:${u};}}`)).join("");
    return i.innerHTML = `<style>${o}</style>`, getComputedStyle(i).getPropertyValue(`--device-${c}`).trim();
  }, r = ({ body: i, width: c, height: a }) => {
    let s = n({ body: i, type: "width", rangeStart: c, rangeLen: 1 }), o = n({ body: i, type: "height", rangeStart: a, rangeLen: 1 });
    if (s && o)
      return { width: c, height: a };
    const m = 1e3;
    return [...Array(10)].find((d, u) => (s || (s = n({ body: i, type: "width", rangeStart: u * m, rangeLen: m })), o || (o = n({ body: i, type: "height", rangeStart: u * m, rangeLen: m })), s && o)), { width: +s, height: +o };
  };
  try {
    const i = $.window, { body: c } = i.document, { width: a, availWidth: s, height: o, availHeight: m } = i.screen, d = !(a - s || o - m);
    (screen.width !== a || a > 800 && d) && (re.IFRAME_SCREEN = !0);
    const u = t(a, o), b = {
      "prefers-reduced-motion": i.matchMedia("(prefers-reduced-motion: no-preference)").matches ? "no-preference" : i.matchMedia("(prefers-reduced-motion: reduce)").matches ? "reduce" : void 0,
      "prefers-color-scheme": i.matchMedia("(prefers-color-scheme: light)").matches ? "light" : i.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : void 0,
      monochrome: i.matchMedia("(monochrome)").matches ? "monochrome" : i.matchMedia("(monochrome: 0)").matches ? "non-monochrome" : void 0,
      "inverted-colors": i.matchMedia("(inverted-colors: inverted)").matches ? "inverted" : i.matchMedia("(inverted-colors: none)").matches ? "none" : void 0,
      "forced-colors": i.matchMedia("(forced-colors: none)").matches ? "none" : i.matchMedia("(forced-colors: active)").matches ? "active" : void 0,
      "any-hover": i.matchMedia("(any-hover: hover)").matches ? "hover" : i.matchMedia("(any-hover: none)").matches ? "none" : void 0,
      hover: i.matchMedia("(hover: hover)").matches ? "hover" : i.matchMedia("(hover: none)").matches ? "none" : void 0,
      "any-pointer": i.matchMedia("(any-pointer: fine)").matches ? "fine" : i.matchMedia("(any-pointer: coarse)").matches ? "coarse" : i.matchMedia("(any-pointer: none)").matches ? "none" : void 0,
      pointer: i.matchMedia("(pointer: fine)").matches ? "fine" : i.matchMedia("(pointer: coarse)").matches ? "coarse" : i.matchMedia("(pointer: none)").matches ? "none" : void 0,
      "device-aspect-ratio": i.matchMedia(`(device-aspect-ratio: ${u})`).matches ? u : void 0,
      "device-screen": i.matchMedia(`(device-width: ${a}px) and (device-height: ${o}px)`).matches ? `${a} x ${o}` : void 0,
      "display-mode": i.matchMedia("(display-mode: fullscreen)").matches ? "fullscreen" : i.matchMedia("(display-mode: standalone)").matches ? "standalone" : i.matchMedia("(display-mode: minimal-ui)").matches ? "minimal-ui" : i.matchMedia("(display-mode: browser)").matches ? "browser" : void 0,
      "color-gamut": i.matchMedia("(color-gamut: srgb)").matches ? "srgb" : i.matchMedia("(color-gamut: p3)").matches ? "p3" : i.matchMedia("(color-gamut: rec2020)").matches ? "rec2020" : void 0,
      orientation: i.matchMedia("(orientation: landscape)").matches ? "landscape" : i.matchMedia("(orientation: portrait)").matches ? "portrait" : void 0
    };
    c.innerHTML = `
		<style>
		@media (prefers-reduced-motion: no-preference) {body {--prefers-reduced-motion: no-preference}}
		@media (prefers-reduced-motion: reduce) {body {--prefers-reduced-motion: reduce}}
		@media (prefers-color-scheme: light) {body {--prefers-color-scheme: light}}
		@media (prefers-color-scheme: dark) {body {--prefers-color-scheme: dark}}
		@media (monochrome) {body {--monochrome: monochrome}}
		@media (monochrome: 0) {body {--monochrome: non-monochrome}}
		@media (inverted-colors: inverted) {body {--inverted-colors: inverted}}
		@media (inverted-colors: none) {body {--inverted-colors: none}}
		@media (forced-colors: none) {body {--forced-colors: none}}
		@media (forced-colors: active) {body {--forced-colors: active}}
		@media (any-hover: hover) {body {--any-hover: hover}}
		@media (any-hover: none) {body {--any-hover: none}}
		@media (hover: hover) {body {--hover: hover}}
		@media (hover: none) {body {--hover: none}}
		@media (any-pointer: fine) {body {--any-pointer: fine}}
		@media (any-pointer: coarse) {body {--any-pointer: coarse}}
		@media (any-pointer: none) {body {--any-pointer: none}}
		@media (pointer: fine) {body {--pointer: fine}}
		@media (pointer: coarse) {body {--pointer: coarse}}
		@media (pointer: none) {body {--pointer: none}}
		@media (device-aspect-ratio: ${u}) {body {--device-aspect-ratio: ${u}}}
		@media (device-width: ${a}px) and (device-height: ${o}px) {body {--device-screen: ${a} x ${o}}}
		@media (display-mode: fullscreen) {body {--display-mode: fullscreen}}
		@media (display-mode: standalone) {body {--display-mode: standalone}}
		@media (display-mode: minimal-ui) {body {--display-mode: minimal-ui}}
		@media (display-mode: browser) {body {--display-mode: browser}}
		@media (color-gamut: srgb) {body {--color-gamut: srgb}}
		@media (color-gamut: p3) {body {--color-gamut: p3}}
		@media (color-gamut: rec2020) {body {--color-gamut: rec2020}}
		@media (orientation: landscape) {body {--orientation: landscape}}
		@media (orientation: portrait) {body {--orientation: portrait}}
		</style>
		`;
    const l = getComputedStyle(c), S = {
      "prefers-reduced-motion": l.getPropertyValue("--prefers-reduced-motion").trim() || void 0,
      "prefers-color-scheme": l.getPropertyValue("--prefers-color-scheme").trim() || void 0,
      monochrome: l.getPropertyValue("--monochrome").trim() || void 0,
      "inverted-colors": l.getPropertyValue("--inverted-colors").trim() || void 0,
      "forced-colors": l.getPropertyValue("--forced-colors").trim() || void 0,
      "any-hover": l.getPropertyValue("--any-hover").trim() || void 0,
      hover: l.getPropertyValue("--hover").trim() || void 0,
      "any-pointer": l.getPropertyValue("--any-pointer").trim() || void 0,
      pointer: l.getPropertyValue("--pointer").trim() || void 0,
      "device-aspect-ratio": l.getPropertyValue("--device-aspect-ratio").trim() || void 0,
      "device-screen": l.getPropertyValue("--device-screen").trim() || void 0,
      "display-mode": l.getPropertyValue("--display-mode").trim() || void 0,
      "color-gamut": l.getPropertyValue("--color-gamut").trim() || void 0,
      orientation: l.getPropertyValue("--orientation").trim() || void 0
    }, h = r({ body: c, width: a, height: o });
    return { mediaCSS: S, matchMediaCSS: b, screenQuery: h };
  } catch (i) {
    W(i);
    return;
  }
}
function gn() {
  try {
    const e = [];
    for (const t in document.documentElement)
      e.push(t);
    return { keys: e };
  } catch (e) {
    W(e);
    return;
  }
}
function Be(e, t, n) {
  var r;
  return e ? ((r = e.parentNode) == null || r.replaceChild(t, e), !0) : null;
}
function Fe(e, ...t) {
  const n = document.createElement("template");
  return n.innerHTML = e.map((r, i) => `${r}${t[i] || ""}`).join(""), document.importNode(n.content, !0);
}
function pn(e, t) {
  if (!e || !t || !t.length) return !1;
  const n = t.reduce((a, s) => (a[s] = !0, a), {}), r = "Cambria Math" in n || "Nirmala UI" in n || "Leelawadee UI" in n || "HoloLens MDL2 Assets" in n || "Segoe Fluent Icons" in n, i = "Helvetica Neue" in n || "Luminari" in n || "PingFang HK Light" in n || "InaiMathi Bold" in n || "Galvji" in n || "Chakra Petch" in n, c = "Arimo" in n || "MONO" in n || "Ubuntu" in n || "Noto Color Emoji" in n || "Dancing Script" in n || "Droid Sans Mono" in n;
  return r && e != oe.WINDOWS || i && e != oe.APPLE ? !0 : !!(c && e != oe.LINUX);
}
const Ne = {
  // https://docs.microsoft.com/en-us/typography/fonts/windows_11_font_list
  7: [
    "Cambria Math",
    "Lucida Console"
  ],
  8: [
    "Aldhabi",
    "Gadugi",
    "Myanmar Text",
    "Nirmala UI"
  ],
  "8.1": [
    "Leelawadee UI",
    "Javanese Text",
    "Segoe UI Emoji"
  ],
  10: [
    "HoloLens MDL2 Assets",
    // 10 (v1507) +
    "Segoe MDL2 Assets",
    // 10 (v1507) +
    "Bahnschrift",
    // 10 (v1709) +-
    "Ink Free"
    // 10 (v1803) +-
  ],
  11: ["Segoe Fluent Icons"]
}, xe = {
  // Mavericks and below
  "10.9": [
    "Helvetica Neue",
    "Geneva"
    // mac (not iOS)
  ],
  // Yosemite
  "10.10": [
    "Kohinoor Devanagari Medium",
    "Luminari"
  ],
  // El Capitan
  "10.11": [
    "PingFang HK Light"
  ],
  // Sierra: https://support.apple.com/en-ie/HT206872
  "10.12": [
    "American Typewriter Semibold",
    "Futura Bold",
    "SignPainter-HouseScript Semibold"
  ],
  // High Sierra: https://support.apple.com/en-me/HT207962
  // Mojave: https://support.apple.com/en-us/HT208968
  "10.13-10.14": [
    "InaiMathi Bold"
  ],
  // Catalina: https://support.apple.com/en-us/HT210192
  // Big Sur: https://support.apple.com/en-sg/HT211240
  "10.15-11": [
    "Galvji",
    "MuktaMahee Regular"
  ],
  // Monterey: https://support.apple.com/en-us/HT212587
  12: [
    "Noto Sans Gunjala Gondi Regular",
    "Noto Sans Masaram Gondi Regular",
    "Noto Serif Yezidi Regular"
  ],
  // Ventura: https://support.apple.com/en-us/HT213266
  13: [
    "Apple SD Gothic Neo ExtraBold",
    "STIX Two Math Regular",
    "STIX Two Text Regular",
    "Noto Sans Canadian Aboriginal Regular"
  ]
}, Te = {
  // docs.microsoft.com/en-us/typography/font-list/ms-outlook
  "Microsoft Outlook": ["MS Outlook"],
  // https://community.adobe.com/t5/postscript-discussions/zwadobef-font/m-p/3730427#M785
  "Adobe Acrobat": ["ZWAdobeF"],
  // https://wiki.documentfoundation.org/Fonts
  LibreOffice: [
    "Amiri",
    "KACSTOffice",
    "Liberation Mono",
    "Source Code Pro"
  ],
  // https://superuser.com/a/611804
  OpenOffice: [
    "DejaVu Sans",
    "Gentium Book Basic",
    "OpenSymbol"
  ]
}, hn = Object.keys(xe).map((e) => xe[e]).flat(), bn = Object.keys(Ne).map((e) => Ne[e]).flat(), fn = Object.keys(Te).map((e) => Te[e]).flat(), Sn = [
  "Arimo",
  // ubuntu, chrome os
  "Chilanka",
  // ubuntu (not TB)
  "Cousine",
  // ubuntu, chrome os
  "Jomolhari",
  // chrome os
  "MONO",
  // ubuntu, chrome os (not TB)
  "Noto Color Emoji",
  // Linux
  "Ubuntu"
  // ubuntu (not TB)
], En = [
  "Dancing Script",
  // android
  "Droid Sans Mono",
  // Android
  "Roboto"
  // Android, Chrome OS
], yn = [
  ...hn,
  ...bn,
  ...Sn,
  ...En,
  ...fn
].sort();
async function wn() {
  const e = ({ doc: i, id: c, emojis: a }) => {
    try {
      Be(i.getElementById(c), Fe`
				<div id="pixel-emoji-container">
				<style>
					.pixel-emoji {
						font-family: ${ce};
						font-size: 200px !important;
						height: auto;
						position: absolute !important;
						transform: scale(1.000999);
					}
					</style>
					${a.map((l) => `<div class="pixel-emoji">${l}</div>`).join("")}
				</div>
			`);
      const s = (l) => ({
        width: l.inlineSize,
        height: l.blockSize
      }), o = /* @__PURE__ */ new Set(), d = [...i.getElementsByClassName("pixel-emoji")].reduce((l, S, h) => {
        const g = getComputedStyle(S), y = a[h], { height: p, width: k } = s(g), v = `${k},${p}`;
        return o.has(v) || (o.add(v), l.add(y)), l;
      }, /* @__PURE__ */ new Set()), u = (l) => +l.replace("px", ""), b = 1e-5 * [...o].map((l) => l.split(",").map((S) => u(S)).reduce((S, h) => S += +h || 0, 0)).reduce((l, S) => l += S, 0);
      return i.body.removeChild(i.getElementById("pixel-emoji-container")), {
        emojiSet: [...d],
        pixelSizeSystemSum: b
      };
    } catch (s) {
      return console.error(s), {
        emojiSet: [],
        pixelSizeSystemSum: 0
      };
    }
  }, t = async (i) => {
    try {
      let c = [];
      document.fonts.check(`0px "${ve()}"`) || (c = i.reduce((m, d) => (document.fonts.check(`0px "${d}"`) && m.push(d), m), []));
      const a = i.map((m) => new FontFace(m, `local("${m}")`)), o = (await Promise.allSettled(a.map((m) => m.load()))).reduce((m, d) => (d.status == "fulfilled" && m.push(d.value.family), m), []);
      return [.../* @__PURE__ */ new Set([...c, ...o])].sort();
    } catch (c) {
      return console.error(c), [];
    }
  }, n = (i) => {
    const c = ({ fonts: s, fontMap: o }) => {
      const m = {
        11: o[11].find((l) => s.includes(l)),
        10: o[10].find((l) => s.includes(l)),
        "8.1": o["8.1"].find((l) => s.includes(l)),
        8: o[8].find((l) => s.includes(l)),
        // require complete set of Windows 7 fonts
        7: o[7].filter((l) => s.includes(l)).length == o[7].length
      }, d = "" + Object.keys(m).sort().filter((l) => !!m[l]), b = {
        "10,11,7,8,8.1": "11",
        "10,7,8,8.1": "10",
        "7,8,8.1": "8.1",
        "11,7,8,8.1": "8.1",
        // missing 10
        "7,8": "8",
        "10,7,8": "8",
        // missing 8.1
        "10,11,7,8": "8",
        // missing 8.1
        7: "7",
        "7,8.1": "7",
        "10,7,8.1": "7",
        // missing 8
        "10,11,7,8.1": "7"
        // missing 8
      }[d];
      return b ? `Windows ${b}` : void 0;
    }, a = ({ fonts: s, fontMap: o }) => {
      const m = {
        13: o[13].find((l) => s.includes(l)),
        12: o[12].find((l) => s.includes(l)),
        "10.15-11": o["10.15-11"].find((l) => s.includes(l)),
        "10.13-10.14": o["10.13-10.14"].find((l) => s.includes(l)),
        "10.12": o["10.12"].find((l) => s.includes(l)),
        "10.11": o["10.11"].find((l) => s.includes(l)),
        "10.10": o["10.10"].find((l) => s.includes(l)),
        // require complete set of 10.9 fonts
        "10.9": o["10.9"].filter((l) => s.includes(l)).length == o["10.9"].length
      }, d = "" + Object.keys(m).sort().filter((l) => !!m[l]), b = {
        "10.10,10.11,10.12,10.13-10.14,10.15-11,10.9,12,13": "Ventura",
        "10.10,10.11,10.12,10.13-10.14,10.15-11,10.9,12": "Monterey",
        "10.10,10.11,10.12,10.13-10.14,10.15-11,10.9": "10.15-11",
        "10.10,10.11,10.12,10.13-10.14,10.9": "10.13-10.14",
        "10.10,10.11,10.12,10.9": "Sierra",
        // 10.12
        "10.10,10.11,10.9": "El Capitan",
        // 10.11
        "10.10,10.9": "Yosemite",
        // 10.10
        "10.9": "Mavericks"
        // 10.9
      }[d];
      return b ? `macOS ${b}` : void 0;
    };
    return c({ fonts: i, fontMap: Ne }) || a({ fonts: i, fontMap: xe });
  }, r = (i) => Object.keys(Te).reduce((a, s) => {
    const o = Te[s];
    return o.filter((d) => i.includes(d)).length == o.length ? [...a, s] : a;
  }, []);
  try {
    const i = $ && $.document && $.document.body ? $.document : document, c = "font-fp", a = i.createElement("div");
    a.setAttribute("id", c), i.body.appendChild(a);
    const {
      emojiSet: s,
      pixelSizeSystemSum: o
    } = e({
      doc: i,
      id: c,
      emojis: le
    }) || {}, d = await t(yn), u = n(d), b = r(d), l = w["FontFace.load"] || w["FontFace.family"] || w["FontFace.status"] || w["String.fromCodePoint"] || w["CSSStyleDeclaration.setProperty"] || w["CSS2Properties.setProperty"];
    return pn(ke, d) && (re.FONTS = !0, ae.FontOsIsBad = !0, U("platform", `${ke} system and fonts are uncommon`)), {
      fontFaceLoadFonts: d,
      platformVersion: u,
      apps: b,
      emojiSet: s,
      pixelSizeSystemSum: o,
      lied: l
    };
  } catch (i) {
    W(i);
    return;
  }
}
const Ee = (e) => {
  const t = `${JSON.stringify(e)}`;
  return ("0000000" + (t.split("").reduce((r, i, c) => Math.imul(31, r) + t.charCodeAt(c) | 0, 2166136261) >>> 0).toString(16)).substr(-8);
}, rt = String.fromCharCode(Math.random() * 26 + 97) + Math.random().toString(36).slice(-7);
async function Mn() {
  try {
    const e = (R) => ({
      bottom: R.bottom,
      height: R.height,
      left: R.left,
      right: R.right,
      width: R.width,
      top: R.top,
      x: R.x,
      y: R.y
    });
    let t = w["Element.getClientRects"] || w["Element.getBoundingClientRect"] || w["Range.getClientRects"] || w["Range.getBoundingClientRect"] || w["String.fromCodePoint"] || !1;
    const n = $ && $.document && $.document.body ? $.document : document, r = (R) => {
      let B;
      if (w["Element.getClientRects"])
        if (w["Element.getBoundingClientRect"]) {
          if (!w["Range.getClientRects"])
            return B = n.createRange(), B.selectNode(R), B.getClientRects()[0];
        } else return R.getBoundingClientRect();
      else return R.getClientRects()[0];
      return B = n.createRange(), B.selectNode(R), B.getBoundingClientRect();
    }, i = `${rt}-client-rects-div`, c = document.createElement("div");
    c.setAttribute("id", i), n.body.appendChild(c), Be(c, Fe`
		<div id="${i}">
			<style>
			.rect-ghost,
			.rect-known {
				top: 0;
				left: 0;
				position: absolute;
				visibility: hidden;
			}
			.rect-known {
				width: 100px;
				height: 100px;
				transform: rotate(45deg);
			}
			.rect-ghost {
				width: 0;
				height: 0;
			}
			</style>
			<div class="rect-known"></div>
			<div class="rect-ghost"></div>
			<div style="perspective:100px;width:1000.099%;" id="rect-container">
				<style>
				.rects {
					width: 1000%;
					height: 1000%;
					max-width: 1000%;
				}
				.absolute {
					position: absolute;
				}
				#cRect1 {
					border: solid 2.715px;
					border-color: #F72585;
					padding: 3.98px;
					margin-left: 12.12px;
				}
				#cRect2 {
					border: solid 2px;
					border-color: #7209B7;
					font-size: 30px;
					margin-top: 20px;
					padding: 3.98px;
					transform: skewY(23.1753218deg) rotate3d(10.00099, 90, 0.100000000000009, 60000000000008.00000009deg);
				}
				#cRect3 {
					border: solid 2.89px;
					border-color: #3A0CA3;
					font-size: 45px;
					transform: skewY(-23.1753218deg) scale(1099.0000000099, 1.89) matrix(1.11, 2.0001, -1.0001, 1.009, 150, 94.4);
					margin-top: 50px;
				}
				#cRect4 {
					border: solid 2px;
					border-color: #4361EE;
					transform: matrix(1.11, 2.0001, -1.0001, 1.009, 150, 94.4);
					margin-top: 11.1331px;
					margin-left: 12.1212px;
					padding: 4.4545px;
					left: 239.4141px;
					top: 8.5050px;
				}
				#cRect5 {
					border: solid 2px;
					border-color: #4CC9F0;
					margin-left: 42.395pt;
				}
				#cRect6 {
					border: solid 2px;
					border-color: #F72585;
					transform: perspective(12890px) translateZ(101.5px);
					padding: 12px;
				}
				#cRect7 {
					margin-top: -350.552px;
					margin-left: 0.9099rem;
					border: solid 2px;
					border-color: #4361EE;
				}
				#cRect8 {
					margin-top: -150.552px;
					margin-left: 15.9099rem;
					border: solid 2px;
					border-color: #3A0CA3;
				}
				#cRect9 {
					margin-top: -110.552px;
					margin-left: 15.9099rem;
					border: solid 2px;
					border-color: #7209B7;
				}
				#cRect10 {
					margin-top: -315.552px;
					margin-left: 15.9099rem;
					border: solid 2px;
					border-color: #F72585;
				}
				#cRect11 {
					width: 10px;
					height: 10px;
					margin-left: 15.0000009099rem;
					border: solid 2px;
					border-color: #F72585;
				}
				#cRect12 {
					width: 10px;
					height: 10px;
					margin-left: 15.0000009099rem;
					border: solid 2px;
					border-color: #F72585;
				}
				#rect-container .shift-dom-rect {
					top: 1px !important;
					left: 1px !important;
				}
				</style>
				<div id="cRect1" class="rects"></div>
				<div id="cRect2" class="rects"></div>
				<div id="cRect3" class="rects"></div>
				<div id="cRect4" class="rects absolute"></div>
				<div id="cRect5" class="rects"></div>
				<div id="cRect6" class="rects"></div>
				<div id="cRect7" class="rects absolute"></div>
				<div id="cRect8" class="rects absolute"></div>
				<div id="cRect9" class="rects absolute"></div>
				<div id="cRect10" class="rects absolute"></div>
				<div id="cRect11" class="rects"></div>
				<div id="cRect12" class="rects"></div>
				<div id="emoji" class="emojis"></div>
			</div>
			<div id="emoji-container">
				<style>
				.domrect-emoji {
					font-family: ${ce};
					font-size: 200px !important;
					height: auto;
					position: absolute !important;
					transform: scale(1.000999);
				}
				</style>
				${le.map((R) => `<div class="domrect-emoji">${R}</div>`).join("")}
			</div>
		</div>
		`);
    const a = /* @__PURE__ */ new Set(), o = [...n.getElementsByClassName("domrect-emoji")].reduce((R, B, V) => {
      const Q = le[V], { height: ie, width: ee } = r(B), M = `${ee},${ie}`;
      return a.has(M) || (a.add(M), R.add(Q)), R;
    }, /* @__PURE__ */ new Set()), m = 1e-5 * [...a].map((R) => R.split(",").reduce((B, V) => B += +V || 0, 0)).reduce((R, B) => R += B, 0), d = document.createRange(), u = n.getElementsByClassName("rects"), b = [...u].map((R) => e(R.getClientRects()[0])), l = [...u].map((R) => e(R.getBoundingClientRect())), S = [...u].map((R) => (d.selectNode(R), e(d.getClientRects()[0]))), h = [...u].map((R) => (d.selectNode(R), e(R.getBoundingClientRect()))), g = [...u][3], { top: y } = b[3];
    g.classList.add("shift-dom-rect");
    const { top: p } = e(g.getClientRects()[0]);
    g.classList.remove("shift-dom-rect");
    const { top: k } = e(g.getClientRects()[0]);
    y - p != k - p && (t = !0, H("Element.getClientRects", "failed unshift calculation"));
    let E = !1;
    b.forEach((R) => {
      const { right: B, left: V, width: Q, bottom: ie, top: ee, height: M, x: O, y: q } = R;
      (B - V != Q || ie - ee != M || B - O != Q || ie - q != M) && (t = !0, E = !0);
    }), E && H("Element.getClientRects", "failed math calculation");
    const { right: f, left: D } = b[10], { right: A, left: T } = b[11];
    (f != A || D != T) && (H("Element.getClientRects", "equal elements mismatch"), t = !0);
    const N = [...n.getElementsByClassName("rect-known")][0], F = e(N.getClientRects()[0]), L = Ee(F);
    K ? {
      "9d9215cc": !0,
      // 100, etc
      "47ded322": !0,
      // 33, 67
      d0eceaa8: !0
      // 90
    }[L] || (H("Element.getClientRects", "unknown rotate dimensions"), t = !0) : de && ({
      e38453f0: !0
      // 100, etc
    }[L] || (H("Element.getClientRects", "unknown rotate dimensions"), t = !0));
    const _ = [...n.getElementsByClassName("rect-ghost")][0], G = e(_.getClientRects()[0]);
    return Object.keys(G).some((R) => G[R] !== 0) && (H("Element.getClientRects", "unknown ghost dimensions"), t = !0), n.body.removeChild(n.getElementById(i)), {
      elementClientRects: b,
      elementBoundingClientRect: l,
      rangeClientRects: S,
      rangeBoundingClientRect: h,
      emojiSet: [...o],
      domrectSystemSum: m,
      lied: t
    };
  } catch (e) {
    W(e);
    return;
  }
}
function An(e) {
  const t = [];
  let n;
  const r = e.length;
  for (n = 0; n < r; n++)
    try {
      e[n]();
    } catch (i) {
      t.push(i.message);
    }
  return t;
}
function kn() {
  try {
    return { errors: An([
      () => new Function('alert(")')(),
      () => new Function("const foo;foo.bar")(),
      () => new Function("null.bar")(),
      () => new Function("abc.xyz = 123")(),
      () => new Function("const foo;foo.bar")(),
      () => new Function("(1).toString(1000)")(),
      () => new Function("[...undefined].length")(),
      () => new Function("var x = new Array(-1)")(),
      () => new Function("const a=1; const a=2;")()
    ]) };
  } catch (e) {
    W(e);
    return;
  }
}
const Tn = () => ({
  Chrome: {
    version: 115,
    windowKeys: "Object, Function, Array, Number, parseFloat, parseInt, Infinity, NaN, undefined, Boolean, String, Symbol, Date, Promise, RegExp, Error, AggregateError, EvalError, RangeError, ReferenceError, SyntaxError, TypeError, URIError, globalThis, JSON, Math, Intl, ArrayBuffer, Atomics, Uint8Array, Int8Array, Uint16Array, Int16Array, Uint32Array, Int32Array, Float32Array, Float64Array, Uint8ClampedArray, BigUint64Array, BigInt64Array, DataView, Map, BigInt, Set, WeakMap, WeakSet, Proxy, Reflect, FinalizationRegistry, WeakRef, decodeURI, decodeURIComponent, encodeURI, encodeURIComponent, escape, unescape, eval, isFinite, isNaN, console, Option, Image, Audio, webkitURL, webkitRTCPeerConnection, webkitMediaStream, WebKitMutationObserver, WebKitCSSMatrix, XSLTProcessor, XPathResult, XPathExpression, XPathEvaluator, XMLSerializer, XMLHttpRequestUpload, XMLHttpRequestEventTarget, XMLHttpRequest, XMLDocument, WritableStreamDefaultWriter, WritableStreamDefaultController, WritableStream, Worker, Window, WheelEvent, WebSocket, WebGLVertexArrayObject, WebGLUniformLocation, WebGLTransformFeedback, WebGLTexture, WebGLSync, WebGLShaderPrecisionFormat, WebGLShader, WebGLSampler, WebGLRenderingContext, WebGLRenderbuffer, WebGLQuery, WebGLProgram, WebGLFramebuffer, WebGLContextEvent, WebGLBuffer, WebGLActiveInfo, WebGL2RenderingContext, WaveShaperNode, VisualViewport, VirtualKeyboardGeometryChangeEvent, ValidityState, VTTCue, UserActivation, URLSearchParams, URLPattern, URL, UIEvent, TrustedTypePolicyFactory, TrustedTypePolicy, TrustedScriptURL, TrustedScript, TrustedHTML, TreeWalker, TransitionEvent, TransformStreamDefaultController, TransformStream, TrackEvent, TouchList, TouchEvent, Touch, TimeRanges, TextTrackList, TextTrackCueList, TextTrackCue, TextTrack, TextMetrics, TextEvent, TextEncoderStream, TextEncoder, TextDecoderStream, TextDecoder, Text, TaskSignal, TaskPriorityChangeEvent, TaskController, TaskAttributionTiming, SyncManager, SubmitEvent, StyleSheetList, StyleSheet, StylePropertyMapReadOnly, StylePropertyMap, StorageEvent, Storage, StereoPannerNode, StaticRange, SourceBufferList, SourceBuffer, ShadowRoot, Selection, SecurityPolicyViolationEvent, ScriptProcessorNode, ScreenOrientation, Screen, Scheduling, Scheduler, SVGViewElement, SVGUseElement, SVGUnitTypes, SVGTransformList, SVGTransform, SVGTitleElement, SVGTextPositioningElement, SVGTextPathElement, SVGTextElement, SVGTextContentElement, SVGTSpanElement, SVGSymbolElement, SVGSwitchElement, SVGStyleElement, SVGStringList, SVGStopElement, SVGSetElement, SVGScriptElement, SVGSVGElement, SVGRectElement, SVGRect, SVGRadialGradientElement, SVGPreserveAspectRatio, SVGPolylineElement, SVGPolygonElement, SVGPointList, SVGPoint, SVGPatternElement, SVGPathElement, SVGNumberList, SVGNumber, SVGMetadataElement, SVGMatrix, SVGMaskElement, SVGMarkerElement, SVGMPathElement, SVGLinearGradientElement, SVGLineElement, SVGLengthList, SVGLength, SVGImageElement, SVGGraphicsElement, SVGGradientElement, SVGGeometryElement, SVGGElement, SVGForeignObjectElement, SVGFilterElement, SVGFETurbulenceElement, SVGFETileElement, SVGFESpotLightElement, SVGFESpecularLightingElement, SVGFEPointLightElement, SVGFEOffsetElement, SVGFEMorphologyElement, SVGFEMergeNodeElement, SVGFEMergeElement, SVGFEImageElement, SVGFEGaussianBlurElement, SVGFEFuncRElement, SVGFEFuncGElement, SVGFEFuncBElement, SVGFEFuncAElement, SVGFEFloodElement, SVGFEDropShadowElement, SVGFEDistantLightElement, SVGFEDisplacementMapElement, SVGFEDiffuseLightingElement, SVGFEConvolveMatrixElement, SVGFECompositeElement, SVGFEComponentTransferElement, SVGFEColorMatrixElement, SVGFEBlendElement, SVGEllipseElement, SVGElement, SVGDescElement, SVGDefsElement, SVGComponentTransferFunctionElement, SVGClipPathElement, SVGCircleElement, SVGAnimationElement, SVGAnimatedTransformList, SVGAnimatedString, SVGAnimatedRect, SVGAnimatedPreserveAspectRatio, SVGAnimatedNumberList, SVGAnimatedNumber, SVGAnimatedLengthList, SVGAnimatedLength, SVGAnimatedInteger, SVGAnimatedEnumeration, SVGAnimatedBoolean, SVGAnimatedAngle, SVGAnimateTransformElement, SVGAnimateMotionElement, SVGAnimateElement, SVGAngle, SVGAElement, Response, ResizeObserverSize, ResizeObserverEntry, ResizeObserver, Request, ReportingObserver, ReadableStreamDefaultReader, ReadableStreamDefaultController, ReadableStreamBYOBRequest, ReadableStreamBYOBReader, ReadableStream, ReadableByteStreamController, Range, RadioNodeList, RTCTrackEvent, RTCStatsReport, RTCSessionDescription, RTCSctpTransport, RTCRtpTransceiver, RTCRtpSender, RTCRtpReceiver, RTCPeerConnectionIceEvent, RTCPeerConnectionIceErrorEvent, RTCPeerConnection, RTCIceTransport, RTCIceCandidate, RTCErrorEvent, RTCError, RTCEncodedVideoFrame, RTCEncodedAudioFrame, RTCDtlsTransport, RTCDataChannelEvent, RTCDataChannel, RTCDTMFToneChangeEvent, RTCDTMFSender, RTCCertificate, PromiseRejectionEvent, ProgressEvent, Profiler, ProcessingInstruction, PopStateEvent, PointerEvent, PluginArray, Plugin, PictureInPictureWindow, PictureInPictureEvent, PeriodicWave, PerformanceTiming, PerformanceServerTiming, PerformanceResourceTiming, PerformancePaintTiming, PerformanceObserverEntryList, PerformanceObserver, PerformanceNavigationTiming, PerformanceNavigation, PerformanceMeasure, PerformanceMark, PerformanceLongTaskTiming, PerformanceEventTiming, PerformanceEntry, PerformanceElementTiming, Performance, Path2D, PannerNode, PageTransitionEvent, OverconstrainedError, OscillatorNode, OffscreenCanvasRenderingContext2D, OffscreenCanvas, OfflineAudioContext, OfflineAudioCompletionEvent, NodeList, NodeIterator, NodeFilter, Node, NetworkInformation, Navigator, NavigationTransition, NavigationHistoryEntry, NavigationDestination, NavigationCurrentEntryChangeEvent, Navigation, NavigateEvent, NamedNodeMap, MutationRecord, MutationObserver, MutationEvent, MouseEvent, MimeTypeArray, MimeType, MessagePort, MessageEvent, MessageChannel, MediaStreamTrackProcessor, MediaStreamTrackGenerator, MediaStreamTrackEvent, MediaStreamTrack, MediaStreamEvent, MediaStreamAudioSourceNode, MediaStreamAudioDestinationNode, MediaStream, MediaSourceHandle, MediaSource, MediaRecorder, MediaQueryListEvent, MediaQueryList, MediaList, MediaError, MediaEncryptedEvent, MediaElementAudioSourceNode, MediaCapabilities, Location, LayoutShiftAttribution, LayoutShift, LargestContentfulPaint, KeyframeEffect, KeyboardEvent, IntersectionObserverEntry, IntersectionObserver, InputEvent, InputDeviceInfo, InputDeviceCapabilities, ImageData, ImageCapture, ImageBitmapRenderingContext, ImageBitmap, IdleDeadline, IIRFilterNode, IDBVersionChangeEvent, IDBTransaction, IDBRequest, IDBOpenDBRequest, IDBObjectStore, IDBKeyRange, IDBIndex, IDBFactory, IDBDatabase, IDBCursorWithValue, IDBCursor, History, Headers, HashChangeEvent, HTMLVideoElement, HTMLUnknownElement, HTMLUListElement, HTMLTrackElement, HTMLTitleElement, HTMLTimeElement, HTMLTextAreaElement, HTMLTemplateElement, HTMLTableSectionElement, HTMLTableRowElement, HTMLTableElement, HTMLTableColElement, HTMLTableCellElement, HTMLTableCaptionElement, HTMLStyleElement, HTMLSpanElement, HTMLSourceElement, HTMLSlotElement, HTMLSelectElement, HTMLScriptElement, HTMLQuoteElement, HTMLProgressElement, HTMLPreElement, HTMLPictureElement, HTMLParamElement, HTMLParagraphElement, HTMLOutputElement, HTMLOptionsCollection, HTMLOptionElement, HTMLOptGroupElement, HTMLObjectElement, HTMLOListElement, HTMLModElement, HTMLMeterElement, HTMLMetaElement, HTMLMenuElement, HTMLMediaElement, HTMLMarqueeElement, HTMLMapElement, HTMLLinkElement, HTMLLegendElement, HTMLLabelElement, HTMLLIElement, HTMLInputElement, HTMLImageElement, HTMLIFrameElement, HTMLHtmlElement, HTMLHeadingElement, HTMLHeadElement, HTMLHRElement, HTMLFrameSetElement, HTMLFrameElement, HTMLFormElement, HTMLFormControlsCollection, HTMLFontElement, HTMLFieldSetElement, HTMLEmbedElement, HTMLElement, HTMLDocument, HTMLDivElement, HTMLDirectoryElement, HTMLDialogElement, HTMLDetailsElement, HTMLDataListElement, HTMLDataElement, HTMLDListElement, HTMLCollection, HTMLCanvasElement, HTMLButtonElement, HTMLBodyElement, HTMLBaseElement, HTMLBRElement, HTMLAudioElement, HTMLAreaElement, HTMLAnchorElement, HTMLAllCollection, GeolocationPositionError, GeolocationPosition, GeolocationCoordinates, Geolocation, GamepadHapticActuator, GamepadEvent, GamepadButton, Gamepad, GainNode, FormDataEvent, FormData, FontFaceSetLoadEvent, FontFace, FocusEvent, FileReader, FileList, File, FeaturePolicy, External, EventTarget, EventSource, EventCounts, Event, ErrorEvent, ElementInternals, Element, DynamicsCompressorNode, DragEvent, DocumentType, DocumentFragment, Document, DelayNode, DecompressionStream, DataTransferItemList, DataTransferItem, DataTransfer, DOMTokenList, DOMStringMap, DOMStringList, DOMRectReadOnly, DOMRectList, DOMRect, DOMQuad, DOMPointReadOnly, DOMPoint, DOMParser, DOMMatrixReadOnly, DOMMatrix, DOMImplementation, DOMException, DOMError, CustomStateSet, CustomEvent, CustomElementRegistry, Crypto, CountQueuingStrategy, ConvolverNode, ConstantSourceNode, CompressionStream, CompositionEvent, Comment, CloseEvent, ClipboardEvent, CharacterData, ChannelSplitterNode, ChannelMergerNode, CanvasRenderingContext2D, CanvasPattern, CanvasGradient, CanvasCaptureMediaStreamTrack, CSSVariableReferenceValue, CSSUnparsedValue, CSSUnitValue, CSSTranslate, CSSTransformValue, CSSTransformComponent, CSSSupportsRule, CSSStyleValue, CSSStyleSheet, CSSStyleRule, CSSStyleDeclaration, CSSSkewY, CSSSkewX, CSSSkew, CSSScale, CSSRuleList, CSSRule, CSSRotate, CSSPropertyRule, CSSPositionValue, CSSPerspective, CSSPageRule, CSSNumericValue, CSSNumericArray, CSSNamespaceRule, CSSMediaRule, CSSMatrixComponent, CSSMathValue, CSSMathSum, CSSMathProduct, CSSMathNegate, CSSMathMin, CSSMathMax, CSSMathInvert, CSSMathClamp, CSSLayerStatementRule, CSSLayerBlockRule, CSSKeywordValue, CSSKeyframesRule, CSSKeyframeRule, CSSImportRule, CSSImageValue, CSSGroupingRule, CSSFontPaletteValuesRule, CSSFontFaceRule, CSSCounterStyleRule, CSSContainerRule, CSSConditionRule, CSS, CDATASection, ByteLengthQueuingStrategy, BroadcastChannel, BlobEvent, Blob, BiquadFilterNode, BeforeUnloadEvent, BeforeInstallPromptEvent, BaseAudioContext, BarProp, AudioWorkletNode, AudioSinkInfo, AudioScheduledSourceNode, AudioProcessingEvent, AudioParamMap, AudioParam, AudioNode, AudioListener, AudioDestinationNode, AudioContext, AudioBufferSourceNode, AudioBuffer, Attr, AnimationEvent, AnimationEffect, Animation, AnalyserNode, AbstractRange, AbortSignal, AbortController, window, self, document, name, location, customElements, history, navigation, locationbar, menubar, personalbar, scrollbars, statusbar, toolbar, status, closed, frames, length, top, opener, parent, frameElement, navigator, origin, external, screen, innerWidth, innerHeight, scrollX, pageXOffset, scrollY, pageYOffset, visualViewport, screenX, screenY, outerWidth, outerHeight, devicePixelRatio, event, clientInformation, offscreenBuffering, screenLeft, screenTop, styleMedia, onsearch, isSecureContext, trustedTypes, performance, onappinstalled, onbeforeinstallprompt, crypto, indexedDB, sessionStorage, localStorage, onbeforexrselect, onabort, onbeforeinput, onblur, oncancel, oncanplay, oncanplaythrough, onchange, onclick, onclose, oncontextlost, oncontextmenu, oncontextrestored, oncuechange, ondblclick, ondrag, ondragend, ondragenter, ondragleave, ondragover, ondragstart, ondrop, ondurationchange, onemptied, onended, onerror, onfocus, onformdata, oninput, oninvalid, onkeydown, onkeypress, onkeyup, onload, onloadeddata, onloadedmetadata, onloadstart, onmousedown, onmouseenter, onmouseleave, onmousemove, onmouseout, onmouseover, onmouseup, onmousewheel, onpause, onplay, onplaying, onprogress, onratechange, onreset, onresize, onscroll, onsecuritypolicyviolation, onseeked, onseeking, onselect, onslotchange, onstalled, onsubmit, onsuspend, ontimeupdate, ontoggle, onvolumechange, onwaiting, onwebkitanimationend, onwebkitanimationiteration, onwebkitanimationstart, onwebkittransitionend, onwheel, onauxclick, ongotpointercapture, onlostpointercapture, onpointerdown, onpointermove, onpointerrawupdate, onpointerup, onpointercancel, onpointerover, onpointerout, onpointerenter, onpointerleave, onselectstart, onselectionchange, onanimationend, onanimationiteration, onanimationstart, ontransitionrun, ontransitionstart, ontransitionend, ontransitioncancel, onafterprint, onbeforeprint, onbeforeunload, onhashchange, onlanguagechange, onmessage, onmessageerror, onoffline, ononline, onpagehide, onpageshow, onpopstate, onrejectionhandled, onstorage, onunhandledrejection, onunload, crossOriginIsolated, scheduler, alert, atob, blur, btoa, cancelAnimationFrame, cancelIdleCallback, captureEvents, clearInterval, clearTimeout, close, confirm, createImageBitmap, fetch, find, focus, getComputedStyle, getSelection, matchMedia, moveBy, moveTo, open, postMessage, print, prompt, queueMicrotask, releaseEvents, reportError, requestAnimationFrame, requestIdleCallback, resizeBy, resizeTo, scroll, scrollBy, scrollTo, setInterval, setTimeout, stop, structuredClone, webkitCancelAnimationFrame, webkitRequestAnimationFrame, chrome, WebAssembly, credentialless, caches, cookieStore, ondevicemotion, ondeviceorientation, ondeviceorientationabsolute, launchQueue, onbeforematch, onbeforetoggle, AbsoluteOrientationSensor, Accelerometer, AudioWorklet, BatteryManager, Cache, CacheStorage, Clipboard, ClipboardItem, CookieChangeEvent, CookieStore, CookieStoreManager, Credential, CredentialsContainer, CryptoKey, DeviceMotionEvent, DeviceMotionEventAcceleration, DeviceMotionEventRotationRate, DeviceOrientationEvent, FederatedCredential, GravitySensor, Gyroscope, Keyboard, KeyboardLayoutMap, LinearAccelerationSensor, Lock, LockManager, MIDIAccess, MIDIConnectionEvent, MIDIInput, MIDIInputMap, MIDIMessageEvent, MIDIOutput, MIDIOutputMap, MIDIPort, MediaDeviceInfo, MediaDevices, MediaKeyMessageEvent, MediaKeySession, MediaKeyStatusMap, MediaKeySystemAccess, MediaKeys, NavigationPreloadManager, NavigatorManagedData, OrientationSensor, PasswordCredential, RelativeOrientationSensor, Sanitizer, ScreenDetailed, ScreenDetails, Sensor, SensorErrorEvent, ServiceWorker, ServiceWorkerContainer, ServiceWorkerRegistration, StorageManager, SubtleCrypto, VirtualKeyboard, WebTransport, WebTransportBidirectionalStream, WebTransportDatagramDuplexStream, WebTransportError, Worklet, XRDOMOverlayState, XRLayer, XRWebGLBinding, AudioData, EncodedAudioChunk, EncodedVideoChunk, ImageTrack, ImageTrackList, VideoColorSpace, VideoFrame, AudioDecoder, AudioEncoder, ImageDecoder, VideoDecoder, VideoEncoder, AuthenticatorAssertionResponse, AuthenticatorAttestationResponse, AuthenticatorResponse, PublicKeyCredential, Bluetooth, BluetoothCharacteristicProperties, BluetoothDevice, BluetoothRemoteGATTCharacteristic, BluetoothRemoteGATTDescriptor, BluetoothRemoteGATTServer, BluetoothRemoteGATTService, CaptureController, EyeDropper, FileSystemDirectoryHandle, FileSystemFileHandle, FileSystemHandle, FileSystemWritableFileStream, FontData, FragmentDirective, GPU, GPUAdapter, GPUAdapterInfo, GPUBindGroup, GPUBindGroupLayout, GPUBuffer, GPUBufferUsage, GPUCanvasContext, GPUColorWrite, GPUCommandBuffer, GPUCommandEncoder, GPUCompilationInfo, GPUCompilationMessage, GPUComputePassEncoder, GPUComputePipeline, GPUDevice, GPUDeviceLostInfo, GPUError, GPUExternalTexture, GPUInternalError, GPUMapMode, GPUOutOfMemoryError, GPUPipelineError, GPUPipelineLayout, GPUQuerySet, GPUQueue, GPURenderBundle, GPURenderBundleEncoder, GPURenderPassEncoder, GPURenderPipeline, GPUSampler, GPUShaderModule, GPUShaderStage, GPUSupportedFeatures, GPUSupportedLimits, GPUTexture, GPUTextureUsage, GPUTextureView, GPUUncapturedErrorEvent, GPUValidationError, HID, HIDConnectionEvent, HIDDevice, HIDInputReportEvent, IdentityCredential, IdleDetector, LaunchParams, LaunchQueue, OTPCredential, PaymentAddress, PaymentRequest, PaymentResponse, PaymentMethodChangeEvent, Presentation, PresentationAvailability, PresentationConnection, PresentationConnectionAvailableEvent, PresentationConnectionCloseEvent, PresentationConnectionList, PresentationReceiver, PresentationRequest, Serial, SerialPort, ToggleEvent, USB, USBAlternateInterface, USBConfiguration, USBConnectionEvent, USBDevice, USBEndpoint, USBInTransferResult, USBInterface, USBIsochronousInTransferPacket, USBIsochronousInTransferResult, USBIsochronousOutTransferPacket, USBIsochronousOutTransferResult, USBOutTransferResult, WakeLock, WakeLockSentinel, WindowControlsOverlay, WindowControlsOverlayGeometryChangeEvent, XRAnchor, XRAnchorSet, XRBoundedReferenceSpace, XRCPUDepthInformation, XRCamera, XRDepthInformation, XRFrame, XRHitTestResult, XRHitTestSource, XRInputSource, XRInputSourceArray, XRInputSourceEvent, XRInputSourcesChangeEvent, XRLightEstimate, XRLightProbe, XRPose, XRRay, XRReferenceSpace, XRReferenceSpaceEvent, XRRenderState, XRRigidTransform, XRSession, XRSessionEvent, XRSpace, XRSystem, XRTransientInputHitTestResult, XRTransientInputHitTestSource, XRView, XRViewerPose, XRViewport, XRWebGLDepthInformation, XRWebGLLayer, getScreenDetails, queryLocalFonts, showDirectoryPicker, showOpenFilePicker, showSaveFilePicker, originAgentCluster, speechSynthesis, oncontentvisibilityautostatechange, onscrollend, AnimationPlaybackEvent, AnimationTimeline, CSSAnimation, CSSTransition, DocumentTimeline, BackgroundFetchManager, BackgroundFetchRecord, BackgroundFetchRegistration, BluetoothUUID, BrowserCaptureMediaStreamTrack, CropTarget, ContentVisibilityAutoStateChangeEvent, DelegatedInkTrailPresenter, Ink, Highlight, HighlightRegistry, MathMLElement, MediaMetadata, MediaSession, NavigatorUAData, Notification, PaymentManager, PaymentRequestUpdateEvent, PeriodicSyncManager, PermissionStatus, Permissions, PushManager, PushSubscription, PushSubscriptionOptions, RemotePlayback, SharedWorker, SpeechSynthesisErrorEvent, SpeechSynthesisEvent, SpeechSynthesisUtterance, VideoPlaybackQuality, ViewTransition, webkitSpeechGrammar, webkitSpeechGrammarList, webkitSpeechRecognition, webkitSpeechRecognitionError, webkitSpeechRecognitionEvent, openDatabase, webkitRequestFileSystem, webkitResolveLocalFileSystemURL",
    cssKeys: "cssText, length, parentRule, cssFloat, getPropertyPriority, getPropertyValue, item, removeProperty, setProperty, constructor, accent-color, align-content, align-items, align-self, alignment-baseline, animation-composition, animation-delay, animation-direction, animation-duration, animation-fill-mode, animation-iteration-count, animation-name, animation-play-state, animation-timing-function, app-region, appearance, backdrop-filter, backface-visibility, background-attachment, background-blend-mode, background-clip, background-color, background-image, background-origin, background-position, background-repeat, background-size, baseline-shift, baseline-source, block-size, border-block-end-color, border-block-end-style, border-block-end-width, border-block-start-color, border-block-start-style, border-block-start-width, border-bottom-color, border-bottom-left-radius, border-bottom-right-radius, border-bottom-style, border-bottom-width, border-collapse, border-end-end-radius, border-end-start-radius, border-image-outset, border-image-repeat, border-image-slice, border-image-source, border-image-width, border-inline-end-color, border-inline-end-style, border-inline-end-width, border-inline-start-color, border-inline-start-style, border-inline-start-width, border-left-color, border-left-style, border-left-width, border-right-color, border-right-style, border-right-width, border-start-end-radius, border-start-start-radius, border-top-color, border-top-left-radius, border-top-right-radius, border-top-style, border-top-width, bottom, box-shadow, box-sizing, break-after, break-before, break-inside, buffered-rendering, caption-side, caret-color, clear, clip, clip-path, clip-rule, color, color-interpolation, color-interpolation-filters, color-rendering, column-count, column-gap, column-rule-color, column-rule-style, column-rule-width, column-span, column-width, contain-intrinsic-block-size, contain-intrinsic-height, contain-intrinsic-inline-size, contain-intrinsic-size, contain-intrinsic-width, container-name, container-type, content, cursor, cx, cy, d, direction, display, dominant-baseline, empty-cells, fill, fill-opacity, fill-rule, filter, flex-basis, flex-direction, flex-grow, flex-shrink, flex-wrap, float, flood-color, flood-opacity, font-family, font-kerning, font-optical-sizing, font-palette, font-size, font-stretch, font-style, font-synthesis-small-caps, font-synthesis-style, font-synthesis-weight, font-variant, font-variant-alternates, font-variant-caps, font-variant-east-asian, font-variant-ligatures, font-variant-numeric, font-weight, grid-auto-columns, grid-auto-flow, grid-auto-rows, grid-column-end, grid-column-start, grid-row-end, grid-row-start, grid-template-areas, grid-template-columns, grid-template-rows, height, hyphenate-character, hyphenate-limit-chars, hyphens, image-orientation, image-rendering, initial-letter, inline-size, inset-block-end, inset-block-start, inset-inline-end, inset-inline-start, isolation, justify-content, justify-items, justify-self, left, letter-spacing, lighting-color, line-break, line-height, list-style-image, list-style-position, list-style-type, margin-block-end, margin-block-start, margin-bottom, margin-inline-end, margin-inline-start, margin-left, margin-right, margin-top, marker-end, marker-mid, marker-start, mask-type, math-depth, math-shift, math-style, max-block-size, max-height, max-inline-size, max-width, min-block-size, min-height, min-inline-size, min-width, mix-blend-mode, object-fit, object-position, object-view-box, offset-distance, offset-path, offset-rotate, opacity, order, orphans, outline-color, outline-offset, outline-style, outline-width, overflow-anchor, overflow-clip-margin, overflow-wrap, overflow-x, overflow-y, overscroll-behavior-block, overscroll-behavior-inline, padding-block-end, padding-block-start, padding-bottom, padding-inline-end, padding-inline-start, padding-left, padding-right, padding-top, paint-order, perspective, perspective-origin, pointer-events, position, r, resize, right, rotate, row-gap, ruby-position, rx, ry, scale, scroll-behavior, scroll-margin-block-end, scroll-margin-block-start, scroll-margin-inline-end, scroll-margin-inline-start, scroll-padding-block-end, scroll-padding-block-start, scroll-padding-inline-end, scroll-padding-inline-start, scrollbar-gutter, shape-image-threshold, shape-margin, shape-outside, shape-rendering, speak, stop-color, stop-opacity, stroke, stroke-dasharray, stroke-dashoffset, stroke-linecap, stroke-linejoin, stroke-miterlimit, stroke-opacity, stroke-width, tab-size, table-layout, text-align, text-align-last, text-anchor, text-decoration, text-decoration-color, text-decoration-line, text-decoration-skip-ink, text-decoration-style, text-emphasis-color, text-emphasis-position, text-emphasis-style, text-indent, text-overflow, text-rendering, text-shadow, text-size-adjust, text-transform, text-underline-position, text-wrap, top, touch-action, transform, transform-origin, transform-style, transition-delay, transition-duration, transition-property, transition-timing-function, translate, unicode-bidi, user-select, vector-effect, vertical-align, view-transition-name, visibility, white-space-collapse, widows, width, will-change, word-break, word-spacing, writing-mode, x, y, z-index, zoom, -webkit-border-horizontal-spacing, -webkit-border-image, -webkit-border-vertical-spacing, -webkit-box-align, -webkit-box-decoration-break, -webkit-box-direction, -webkit-box-flex, -webkit-box-ordinal-group, -webkit-box-orient, -webkit-box-pack, -webkit-box-reflect, -webkit-font-smoothing, -webkit-highlight, -webkit-line-break, -webkit-line-clamp, -webkit-locale, -webkit-mask-box-image, -webkit-mask-box-image-outset, -webkit-mask-box-image-repeat, -webkit-mask-box-image-slice, -webkit-mask-box-image-source, -webkit-mask-box-image-width, -webkit-mask-clip, -webkit-mask-composite, -webkit-mask-image, -webkit-mask-origin, -webkit-mask-position, -webkit-mask-repeat, -webkit-mask-size, -webkit-print-color-adjust, -webkit-rtl-ordering, -webkit-tap-highlight-color, -webkit-text-combine, -webkit-text-decorations-in-effect, -webkit-text-fill-color, -webkit-text-orientation, -webkit-text-security, -webkit-text-stroke-color, -webkit-text-stroke-width, -webkit-user-drag, -webkit-user-modify, -webkit-writing-mode, accentColor, additiveSymbols, alignContent, alignItems, alignSelf, alignmentBaseline, all, animation, animationComposition, animationDelay, animationDirection, animationDuration, animationFillMode, animationIterationCount, animationName, animationPlayState, animationTimingFunction, appRegion, ascentOverride, aspectRatio, backdropFilter, backfaceVisibility, background, backgroundAttachment, backgroundBlendMode, backgroundClip, backgroundColor, backgroundImage, backgroundOrigin, backgroundPosition, backgroundPositionX, backgroundPositionY, backgroundRepeat, backgroundRepeatX, backgroundRepeatY, backgroundSize, basePalette, baselineShift, baselineSource, blockSize, border, borderBlock, borderBlockColor, borderBlockEnd, borderBlockEndColor, borderBlockEndStyle, borderBlockEndWidth, borderBlockStart, borderBlockStartColor, borderBlockStartStyle, borderBlockStartWidth, borderBlockStyle, borderBlockWidth, borderBottom, borderBottomColor, borderBottomLeftRadius, borderBottomRightRadius, borderBottomStyle, borderBottomWidth, borderCollapse, borderColor, borderEndEndRadius, borderEndStartRadius, borderImage, borderImageOutset, borderImageRepeat, borderImageSlice, borderImageSource, borderImageWidth, borderInline, borderInlineColor, borderInlineEnd, borderInlineEndColor, borderInlineEndStyle, borderInlineEndWidth, borderInlineStart, borderInlineStartColor, borderInlineStartStyle, borderInlineStartWidth, borderInlineStyle, borderInlineWidth, borderLeft, borderLeftColor, borderLeftStyle, borderLeftWidth, borderRadius, borderRight, borderRightColor, borderRightStyle, borderRightWidth, borderSpacing, borderStartEndRadius, borderStartStartRadius, borderStyle, borderTop, borderTopColor, borderTopLeftRadius, borderTopRightRadius, borderTopStyle, borderTopWidth, borderWidth, boxShadow, boxSizing, breakAfter, breakBefore, breakInside, bufferedRendering, captionSide, caretColor, clipPath, clipRule, colorInterpolation, colorInterpolationFilters, colorRendering, colorScheme, columnCount, columnFill, columnGap, columnRule, columnRuleColor, columnRuleStyle, columnRuleWidth, columnSpan, columnWidth, columns, contain, containIntrinsicBlockSize, containIntrinsicHeight, containIntrinsicInlineSize, containIntrinsicSize, containIntrinsicWidth, container, containerName, containerType, contentVisibility, counterIncrement, counterReset, counterSet, descentOverride, dominantBaseline, emptyCells, fallback, fillOpacity, fillRule, flex, flexBasis, flexDirection, flexFlow, flexGrow, flexShrink, flexWrap, floodColor, floodOpacity, font, fontDisplay, fontFamily, fontFeatureSettings, fontKerning, fontOpticalSizing, fontPalette, fontSize, fontStretch, fontStyle, fontSynthesis, fontSynthesisSmallCaps, fontSynthesisStyle, fontSynthesisWeight, fontVariant, fontVariantAlternates, fontVariantCaps, fontVariantEastAsian, fontVariantLigatures, fontVariantNumeric, fontVariationSettings, fontWeight, forcedColorAdjust, gap, grid, gridArea, gridAutoColumns, gridAutoFlow, gridAutoRows, gridColumn, gridColumnEnd, gridColumnGap, gridColumnStart, gridGap, gridRow, gridRowEnd, gridRowGap, gridRowStart, gridTemplate, gridTemplateAreas, gridTemplateColumns, gridTemplateRows, hyphenateCharacter, hyphenateLimitChars, imageOrientation, imageRendering, inherits, initialLetter, initialValue, inlineSize, inset, insetBlock, insetBlockEnd, insetBlockStart, insetInline, insetInlineEnd, insetInlineStart, justifyContent, justifyItems, justifySelf, letterSpacing, lightingColor, lineBreak, lineGapOverride, lineHeight, listStyle, listStyleImage, listStylePosition, listStyleType, margin, marginBlock, marginBlockEnd, marginBlockStart, marginBottom, marginInline, marginInlineEnd, marginInlineStart, marginLeft, marginRight, marginTop, marker, markerEnd, markerMid, markerStart, mask, maskType, mathDepth, mathShift, mathStyle, maxBlockSize, maxHeight, maxInlineSize, maxWidth, minBlockSize, minHeight, minInlineSize, minWidth, mixBlendMode, negative, objectFit, objectPosition, objectViewBox, offset, offsetDistance, offsetPath, offsetRotate, outline, outlineColor, outlineOffset, outlineStyle, outlineWidth, overflow, overflowAnchor, overflowClipMargin, overflowWrap, overflowX, overflowY, overrideColors, overscrollBehavior, overscrollBehaviorBlock, overscrollBehaviorInline, overscrollBehaviorX, overscrollBehaviorY, pad, padding, paddingBlock, paddingBlockEnd, paddingBlockStart, paddingBottom, paddingInline, paddingInlineEnd, paddingInlineStart, paddingLeft, paddingRight, paddingTop, page, pageBreakAfter, pageBreakBefore, pageBreakInside, pageOrientation, paintOrder, perspectiveOrigin, placeContent, placeItems, placeSelf, pointerEvents, prefix, quotes, range, rowGap, rubyPosition, scrollBehavior, scrollMargin, scrollMarginBlock, scrollMarginBlockEnd, scrollMarginBlockStart, scrollMarginBottom, scrollMarginInline, scrollMarginInlineEnd, scrollMarginInlineStart, scrollMarginLeft, scrollMarginRight, scrollMarginTop, scrollPadding, scrollPaddingBlock, scrollPaddingBlockEnd, scrollPaddingBlockStart, scrollPaddingBottom, scrollPaddingInline, scrollPaddingInlineEnd, scrollPaddingInlineStart, scrollPaddingLeft, scrollPaddingRight, scrollPaddingTop, scrollSnapAlign, scrollSnapStop, scrollSnapType, scrollbarGutter, shapeImageThreshold, shapeMargin, shapeOutside, shapeRendering, size, sizeAdjust, speakAs, src, stopColor, stopOpacity, strokeDasharray, strokeDashoffset, strokeLinecap, strokeLinejoin, strokeMiterlimit, strokeOpacity, strokeWidth, suffix, symbols, syntax, system, tabSize, tableLayout, textAlign, textAlignLast, textAnchor, textCombineUpright, textDecoration, textDecorationColor, textDecorationLine, textDecorationSkipInk, textDecorationStyle, textDecorationThickness, textEmphasis, textEmphasisColor, textEmphasisPosition, textEmphasisStyle, textIndent, textOrientation, textOverflow, textRendering, textShadow, textSizeAdjust, textTransform, textUnderlineOffset, textUnderlinePosition, textWrap, touchAction, transformBox, transformOrigin, transformStyle, transition, transitionDelay, transitionDuration, transitionProperty, transitionTimingFunction, unicodeBidi, unicodeRange, userSelect, vectorEffect, verticalAlign, viewTransitionName, webkitAlignContent, webkitAlignItems, webkitAlignSelf, webkitAnimation, webkitAnimationDelay, webkitAnimationDirection, webkitAnimationDuration, webkitAnimationFillMode, webkitAnimationIterationCount, webkitAnimationName, webkitAnimationPlayState, webkitAnimationTimingFunction, webkitAppRegion, webkitAppearance, webkitBackfaceVisibility, webkitBackgroundClip, webkitBackgroundOrigin, webkitBackgroundSize, webkitBorderAfter, webkitBorderAfterColor, webkitBorderAfterStyle, webkitBorderAfterWidth, webkitBorderBefore, webkitBorderBeforeColor, webkitBorderBeforeStyle, webkitBorderBeforeWidth, webkitBorderBottomLeftRadius, webkitBorderBottomRightRadius, webkitBorderEnd, webkitBorderEndColor, webkitBorderEndStyle, webkitBorderEndWidth, webkitBorderHorizontalSpacing, webkitBorderImage, webkitBorderRadius, webkitBorderStart, webkitBorderStartColor, webkitBorderStartStyle, webkitBorderStartWidth, webkitBorderTopLeftRadius, webkitBorderTopRightRadius, webkitBorderVerticalSpacing, webkitBoxAlign, webkitBoxDecorationBreak, webkitBoxDirection, webkitBoxFlex, webkitBoxOrdinalGroup, webkitBoxOrient, webkitBoxPack, webkitBoxReflect, webkitBoxShadow, webkitBoxSizing, webkitClipPath, webkitColumnBreakAfter, webkitColumnBreakBefore, webkitColumnBreakInside, webkitColumnCount, webkitColumnGap, webkitColumnRule, webkitColumnRuleColor, webkitColumnRuleStyle, webkitColumnRuleWidth, webkitColumnSpan, webkitColumnWidth, webkitColumns, webkitFilter, webkitFlex, webkitFlexBasis, webkitFlexDirection, webkitFlexFlow, webkitFlexGrow, webkitFlexShrink, webkitFlexWrap, webkitFontFeatureSettings, webkitFontSmoothing, webkitHighlight, webkitHyphenateCharacter, webkitJustifyContent, webkitLineBreak, webkitLineClamp, webkitLocale, webkitLogicalHeight, webkitLogicalWidth, webkitMarginAfter, webkitMarginBefore, webkitMarginEnd, webkitMarginStart, webkitMask, webkitMaskBoxImage, webkitMaskBoxImageOutset, webkitMaskBoxImageRepeat, webkitMaskBoxImageSlice, webkitMaskBoxImageSource, webkitMaskBoxImageWidth, webkitMaskClip, webkitMaskComposite, webkitMaskImage, webkitMaskOrigin, webkitMaskPosition, webkitMaskPositionX, webkitMaskPositionY, webkitMaskRepeat, webkitMaskRepeatX, webkitMaskRepeatY, webkitMaskSize, webkitMaxLogicalHeight, webkitMaxLogicalWidth, webkitMinLogicalHeight, webkitMinLogicalWidth, webkitOpacity, webkitOrder, webkitPaddingAfter, webkitPaddingBefore, webkitPaddingEnd, webkitPaddingStart, webkitPerspective, webkitPerspectiveOrigin, webkitPerspectiveOriginX, webkitPerspectiveOriginY, webkitPrintColorAdjust, webkitRtlOrdering, webkitRubyPosition, webkitShapeImageThreshold, webkitShapeMargin, webkitShapeOutside, webkitTapHighlightColor, webkitTextCombine, webkitTextDecorationsInEffect, webkitTextEmphasis, webkitTextEmphasisColor, webkitTextEmphasisPosition, webkitTextEmphasisStyle, webkitTextFillColor, webkitTextOrientation, webkitTextSecurity, webkitTextSizeAdjust, webkitTextStroke, webkitTextStrokeColor, webkitTextStrokeWidth, webkitTransform, webkitTransformOrigin, webkitTransformOriginX, webkitTransformOriginY, webkitTransformOriginZ, webkitTransformStyle, webkitTransition, webkitTransitionDelay, webkitTransitionDuration, webkitTransitionProperty, webkitTransitionTimingFunction, webkitUserDrag, webkitUserModify, webkitUserSelect, webkitWritingMode, whiteSpace, whiteSpaceCollapse, willChange, wordBreak, wordSpacing, wordWrap, writingMode, zIndex, additive-symbols, ascent-override, aspect-ratio, background-position-x, background-position-y, background-repeat-x, background-repeat-y, base-palette, border-block, border-block-color, border-block-end, border-block-start, border-block-style, border-block-width, border-bottom, border-color, border-image, border-inline, border-inline-color, border-inline-end, border-inline-start, border-inline-style, border-inline-width, border-left, border-radius, border-right, border-spacing, border-style, border-top, border-width, color-scheme, column-fill, column-rule, content-visibility, counter-increment, counter-reset, counter-set, descent-override, flex-flow, font-display, font-feature-settings, font-synthesis, font-variation-settings, forced-color-adjust, grid-area, grid-column, grid-column-gap, grid-gap, grid-row, grid-row-gap, grid-template, initial-value, inset-block, inset-inline, line-gap-override, list-style, margin-block, margin-inline, override-colors, overscroll-behavior, overscroll-behavior-x, overscroll-behavior-y, padding-block, padding-inline, page-break-after, page-break-before, page-break-inside, page-orientation, place-content, place-items, place-self, scroll-margin, scroll-margin-block, scroll-margin-bottom, scroll-margin-inline, scroll-margin-left, scroll-margin-right, scroll-margin-top, scroll-padding, scroll-padding-block, scroll-padding-bottom, scroll-padding-inline, scroll-padding-left, scroll-padding-right, scroll-padding-top, scroll-snap-align, scroll-snap-stop, scroll-snap-type, size-adjust, speak-as, text-combine-upright, text-decoration-thickness, text-emphasis, text-orientation, text-underline-offset, transform-box, unicode-range, -webkit-align-content, -webkit-align-items, -webkit-align-self, -webkit-animation, -webkit-animation-delay, -webkit-animation-direction, -webkit-animation-duration, -webkit-animation-fill-mode, -webkit-animation-iteration-count, -webkit-animation-name, -webkit-animation-play-state, -webkit-animation-timing-function, -webkit-app-region, -webkit-appearance, -webkit-backface-visibility, -webkit-background-clip, -webkit-background-origin, -webkit-background-size, -webkit-border-after, -webkit-border-after-color, -webkit-border-after-style, -webkit-border-after-width, -webkit-border-before, -webkit-border-before-color, -webkit-border-before-style, -webkit-border-before-width, -webkit-border-bottom-left-radius, -webkit-border-bottom-right-radius, -webkit-border-end, -webkit-border-end-color, -webkit-border-end-style, -webkit-border-end-width, -webkit-border-radius, -webkit-border-start, -webkit-border-start-color, -webkit-border-start-style, -webkit-border-start-width, -webkit-border-top-left-radius, -webkit-border-top-right-radius, -webkit-box-shadow, -webkit-box-sizing, -webkit-clip-path, -webkit-column-break-after, -webkit-column-break-before, -webkit-column-break-inside, -webkit-column-count, -webkit-column-gap, -webkit-column-rule, -webkit-column-rule-color, -webkit-column-rule-style, -webkit-column-rule-width, -webkit-column-span, -webkit-column-width, -webkit-columns, -webkit-filter, -webkit-flex, -webkit-flex-basis, -webkit-flex-direction, -webkit-flex-flow, -webkit-flex-grow, -webkit-flex-shrink, -webkit-flex-wrap, -webkit-font-feature-settings, -webkit-hyphenate-character, -webkit-justify-content, -webkit-logical-height, -webkit-logical-width, -webkit-margin-after, -webkit-margin-before, -webkit-margin-end, -webkit-margin-start, -webkit-mask, -webkit-mask-position-x, -webkit-mask-position-y, -webkit-mask-repeat-x, -webkit-mask-repeat-y, -webkit-max-logical-height, -webkit-max-logical-width, -webkit-min-logical-height, -webkit-min-logical-width, -webkit-opacity, -webkit-order, -webkit-padding-after, -webkit-padding-before, -webkit-padding-end, -webkit-padding-start, -webkit-perspective, -webkit-perspective-origin, -webkit-perspective-origin-x, -webkit-perspective-origin-y, -webkit-ruby-position, -webkit-shape-image-threshold, -webkit-shape-margin, -webkit-shape-outside, -webkit-text-emphasis, -webkit-text-emphasis-color, -webkit-text-emphasis-position, -webkit-text-emphasis-style, -webkit-text-size-adjust, -webkit-text-stroke, -webkit-transform, -webkit-transform-origin, -webkit-transform-origin-x, -webkit-transform-origin-y, -webkit-transform-origin-z, -webkit-transform-style, -webkit-transition, -webkit-transition-delay, -webkit-transition-duration, -webkit-transition-property, -webkit-transition-timing-function, -webkit-user-select, white-space, word-wrap",
    jsKeys: "Object.assign, Object.getOwnPropertyDescriptor, Object.getOwnPropertyDescriptors, Object.getOwnPropertyNames, Object.getOwnPropertySymbols, Object.hasOwn, Object.is, Object.preventExtensions, Object.seal, Object.create, Object.defineProperties, Object.defineProperty, Object.freeze, Object.getPrototypeOf, Object.setPrototypeOf, Object.isExtensible, Object.isFrozen, Object.isSealed, Object.keys, Object.entries, Object.fromEntries, Object.values, Object.__defineGetter__, Object.__defineSetter__, Object.hasOwnProperty, Object.__lookupGetter__, Object.__lookupSetter__, Object.isPrototypeOf, Object.propertyIsEnumerable, Object.toString, Object.valueOf, Object.__proto__, Object.toLocaleString, Function.apply, Function.bind, Function.call, Function.toString, Boolean.toString, Boolean.valueOf, Symbol.for, Symbol.keyFor, Symbol.asyncIterator, Symbol.hasInstance, Symbol.isConcatSpreadable, Symbol.iterator, Symbol.match, Symbol.matchAll, Symbol.replace, Symbol.search, Symbol.species, Symbol.split, Symbol.toPrimitive, Symbol.toStringTag, Symbol.unscopables, Symbol.toString, Symbol.valueOf, Symbol.description, Error.captureStackTrace, Error.stackTraceLimit, Error.message, Error.toString, Number.isFinite, Number.isInteger, Number.isNaN, Number.isSafeInteger, Number.parseFloat, Number.parseInt, Number.MAX_VALUE, Number.MIN_VALUE, Number.NaN, Number.NEGATIVE_INFINITY, Number.POSITIVE_INFINITY, Number.MAX_SAFE_INTEGER, Number.MIN_SAFE_INTEGER, Number.EPSILON, Number.toExponential, Number.toFixed, Number.toPrecision, Number.toString, Number.valueOf, Number.toLocaleString, BigInt.asUintN, BigInt.asIntN, BigInt.toLocaleString, BigInt.toString, BigInt.valueOf, Math.abs, Math.acos, Math.acosh, Math.asin, Math.asinh, Math.atan, Math.atanh, Math.atan2, Math.ceil, Math.cbrt, Math.expm1, Math.clz32, Math.cos, Math.cosh, Math.exp, Math.floor, Math.fround, Math.hypot, Math.imul, Math.log, Math.log1p, Math.log2, Math.log10, Math.max, Math.min, Math.pow, Math.random, Math.round, Math.sign, Math.sin, Math.sinh, Math.sqrt, Math.tan, Math.tanh, Math.trunc, Math.E, Math.LN10, Math.LN2, Math.LOG10E, Math.LOG2E, Math.PI, Math.SQRT1_2, Math.SQRT2, Date.now, Date.parse, Date.UTC, Date.toString, Date.toDateString, Date.toTimeString, Date.toISOString, Date.toUTCString, Date.toGMTString, Date.getDate, Date.setDate, Date.getDay, Date.getFullYear, Date.setFullYear, Date.getHours, Date.setHours, Date.getMilliseconds, Date.setMilliseconds, Date.getMinutes, Date.setMinutes, Date.getMonth, Date.setMonth, Date.getSeconds, Date.setSeconds, Date.getTime, Date.setTime, Date.getTimezoneOffset, Date.getUTCDate, Date.setUTCDate, Date.getUTCDay, Date.getUTCFullYear, Date.setUTCFullYear, Date.getUTCHours, Date.setUTCHours, Date.getUTCMilliseconds, Date.setUTCMilliseconds, Date.getUTCMinutes, Date.setUTCMinutes, Date.getUTCMonth, Date.setUTCMonth, Date.getUTCSeconds, Date.setUTCSeconds, Date.valueOf, Date.getYear, Date.setYear, Date.toJSON, Date.toLocaleString, Date.toLocaleDateString, Date.toLocaleTimeString, String.fromCharCode, String.fromCodePoint, String.raw, String.anchor, String.at, String.big, String.blink, String.bold, String.charAt, String.charCodeAt, String.codePointAt, String.concat, String.endsWith, String.fontcolor, String.fontsize, String.fixed, String.includes, String.indexOf, String.italics, String.lastIndexOf, String.link, String.localeCompare, String.match, String.matchAll, String.normalize, String.padEnd, String.padStart, String.repeat, String.replace, String.replaceAll, String.search, String.slice, String.small, String.split, String.strike, String.sub, String.substr, String.substring, String.sup, String.startsWith, String.toString, String.trim, String.trimStart, String.trimLeft, String.trimEnd, String.trimRight, String.toLocaleLowerCase, String.toLocaleUpperCase, String.toLowerCase, String.toUpperCase, String.valueOf, String.isWellFormed, String.toWellFormed, RegExp.input, RegExp.$_, RegExp.lastMatch, RegExp.$&, RegExp.lastParen, RegExp.$+, RegExp.leftContext, RegExp.$`, RegExp.rightContext, RegExp.$', RegExp.$1, RegExp.$2, RegExp.$3, RegExp.$4, RegExp.$5, RegExp.$6, RegExp.$7, RegExp.$8, RegExp.$9, RegExp.exec, RegExp.dotAll, RegExp.flags, RegExp.global, RegExp.hasIndices, RegExp.ignoreCase, RegExp.multiline, RegExp.source, RegExp.sticky, RegExp.unicode, RegExp.compile, RegExp.toString, RegExp.test, RegExp.unicodeSets, Array.isArray, Array.from, Array.of, Array.at, Array.concat, Array.copyWithin, Array.fill, Array.find, Array.findIndex, Array.findLast, Array.findLastIndex, Array.lastIndexOf, Array.pop, Array.push, Array.reverse, Array.shift, Array.unshift, Array.slice, Array.sort, Array.splice, Array.includes, Array.indexOf, Array.join, Array.keys, Array.entries, Array.values, Array.forEach, Array.filter, Array.flat, Array.flatMap, Array.map, Array.every, Array.some, Array.reduce, Array.reduceRight, Array.toLocaleString, Array.toString, Array.toReversed, Array.toSorted, Array.toSpliced, Array.with, Map.get, Map.set, Map.has, Map.delete, Map.clear, Map.entries, Map.forEach, Map.keys, Map.size, Map.values, Set.has, Set.add, Set.delete, Set.clear, Set.entries, Set.forEach, Set.size, Set.values, Set.keys, WeakMap.delete, WeakMap.get, WeakMap.set, WeakMap.has, WeakSet.delete, WeakSet.has, WeakSet.add, Atomics.load, Atomics.store, Atomics.add, Atomics.sub, Atomics.and, Atomics.or, Atomics.xor, Atomics.exchange, Atomics.compareExchange, Atomics.isLockFree, Atomics.wait, Atomics.waitAsync, Atomics.notify, JSON.parse, JSON.stringify, JSON.rawJSON, JSON.isRawJSON, Promise.all, Promise.allSettled, Promise.any, Promise.race, Promise.resolve, Promise.reject, Promise.then, Promise.catch, Promise.finally, Reflect.defineProperty, Reflect.deleteProperty, Reflect.apply, Reflect.construct, Reflect.get, Reflect.getOwnPropertyDescriptor, Reflect.getPrototypeOf, Reflect.has, Reflect.isExtensible, Reflect.ownKeys, Reflect.preventExtensions, Reflect.set, Reflect.setPrototypeOf, Proxy.revocable, Intl.getCanonicalLocales, Intl.supportedValuesOf, Intl.DateTimeFormat, Intl.NumberFormat, Intl.Collator, Intl.v8BreakIterator, Intl.PluralRules, Intl.RelativeTimeFormat, Intl.ListFormat, Intl.Locale, Intl.DisplayNames, Intl.Segmenter, WebAssembly.compile, WebAssembly.validate, WebAssembly.instantiate, WebAssembly.compileStreaming, WebAssembly.instantiateStreaming, WebAssembly.Module, WebAssembly.Instance, WebAssembly.Table, WebAssembly.Memory, WebAssembly.Global, WebAssembly.Tag, WebAssembly.Exception, WebAssembly.CompileError, WebAssembly.LinkError, WebAssembly.RuntimeError, Document.implementation, Document.URL, Document.documentURI, Document.compatMode, Document.characterSet, Document.charset, Document.inputEncoding, Document.contentType, Document.doctype, Document.documentElement, Document.xmlEncoding, Document.xmlVersion, Document.xmlStandalone, Document.domain, Document.referrer, Document.cookie, Document.lastModified, Document.readyState, Document.title, Document.dir, Document.body, Document.head, Document.images, Document.embeds, Document.plugins, Document.links, Document.forms, Document.scripts, Document.currentScript, Document.defaultView, Document.designMode, Document.onreadystatechange, Document.anchors, Document.applets, Document.fgColor, Document.linkColor, Document.vlinkColor, Document.alinkColor, Document.bgColor, Document.all, Document.scrollingElement, Document.onpointerlockchange, Document.onpointerlockerror, Document.hidden, Document.visibilityState, Document.wasDiscarded, Document.prerendering, Document.featurePolicy, Document.webkitVisibilityState, Document.webkitHidden, Document.onbeforecopy, Document.onbeforecut, Document.onbeforepaste, Document.onfreeze, Document.onprerenderingchange, Document.onresume, Document.onsearch, Document.onvisibilitychange, Document.fullscreenEnabled, Document.fullscreen, Document.onfullscreenchange, Document.onfullscreenerror, Document.webkitIsFullScreen, Document.webkitCurrentFullScreenElement, Document.webkitFullscreenEnabled, Document.webkitFullscreenElement, Document.onwebkitfullscreenchange, Document.onwebkitfullscreenerror, Document.rootElement, Document.pictureInPictureEnabled, Document.pictureInPictureElement, Document.onbeforexrselect, Document.onabort, Document.onbeforeinput, Document.onblur, Document.oncancel, Document.oncanplay, Document.oncanplaythrough, Document.onchange, Document.onclick, Document.onclose, Document.oncontextlost, Document.oncontextmenu, Document.oncontextrestored, Document.oncuechange, Document.ondblclick, Document.ondrag, Document.ondragend, Document.ondragenter, Document.ondragleave, Document.ondragover, Document.ondragstart, Document.ondrop, Document.ondurationchange, Document.onemptied, Document.onended, Document.onerror, Document.onfocus, Document.onformdata, Document.oninput, Document.oninvalid, Document.onkeydown, Document.onkeypress, Document.onkeyup, Document.onload, Document.onloadeddata, Document.onloadedmetadata, Document.onloadstart, Document.onmousedown, Document.onmouseenter, Document.onmouseleave, Document.onmousemove, Document.onmouseout, Document.onmouseover, Document.onmouseup, Document.onmousewheel, Document.onpause, Document.onplay, Document.onplaying, Document.onprogress, Document.onratechange, Document.onreset, Document.onresize, Document.onscroll, Document.onsecuritypolicyviolation, Document.onseeked, Document.onseeking, Document.onselect, Document.onslotchange, Document.onstalled, Document.onsubmit, Document.onsuspend, Document.ontimeupdate, Document.ontoggle, Document.onvolumechange, Document.onwaiting, Document.onwebkitanimationend, Document.onwebkitanimationiteration, Document.onwebkitanimationstart, Document.onwebkittransitionend, Document.onwheel, Document.onauxclick, Document.ongotpointercapture, Document.onlostpointercapture, Document.onpointerdown, Document.onpointermove, Document.onpointerrawupdate, Document.onpointerup, Document.onpointercancel, Document.onpointerover, Document.onpointerout, Document.onpointerenter, Document.onpointerleave, Document.onselectstart, Document.onselectionchange, Document.onanimationend, Document.onanimationiteration, Document.onanimationstart, Document.ontransitionrun, Document.ontransitionstart, Document.ontransitionend, Document.ontransitioncancel, Document.oncopy, Document.oncut, Document.onpaste, Document.children, Document.firstElementChild, Document.lastElementChild, Document.childElementCount, Document.activeElement, Document.styleSheets, Document.pointerLockElement, Document.fullscreenElement, Document.adoptedStyleSheets, Document.fonts, Document.adoptNode, Document.append, Document.captureEvents, Document.caretRangeFromPoint, Document.clear, Document.close, Document.createAttribute, Document.createAttributeNS, Document.createCDATASection, Document.createComment, Document.createDocumentFragment, Document.createElement, Document.createElementNS, Document.createEvent, Document.createExpression, Document.createNSResolver, Document.createNodeIterator, Document.createProcessingInstruction, Document.createRange, Document.createTextNode, Document.createTreeWalker, Document.elementFromPoint, Document.elementsFromPoint, Document.evaluate, Document.execCommand, Document.exitFullscreen, Document.exitPictureInPicture, Document.exitPointerLock, Document.getElementById, Document.getElementsByClassName, Document.getElementsByName, Document.getElementsByTagName, Document.getElementsByTagNameNS, Document.getSelection, Document.hasFocus, Document.importNode, Document.open, Document.prepend, Document.queryCommandEnabled, Document.queryCommandIndeterm, Document.queryCommandState, Document.queryCommandSupported, Document.queryCommandValue, Document.querySelector, Document.querySelectorAll, Document.releaseEvents, Document.replaceChildren, Document.webkitCancelFullScreen, Document.webkitExitFullscreen, Document.write, Document.writeln, Document.fragmentDirective, Document.onbeforematch, Document.onbeforetoggle, Document.timeline, Document.oncontentvisibilityautostatechange, Document.onscrollend, Document.getAnimations, Document.startViewTransition, Element.namespaceURI, Element.prefix, Element.localName, Element.tagName, Element.id, Element.className, Element.classList, Element.slot, Element.attributes, Element.shadowRoot, Element.part, Element.assignedSlot, Element.innerHTML, Element.outerHTML, Element.scrollTop, Element.scrollLeft, Element.scrollWidth, Element.scrollHeight, Element.clientTop, Element.clientLeft, Element.clientWidth, Element.clientHeight, Element.onbeforecopy, Element.onbeforecut, Element.onbeforepaste, Element.onsearch, Element.elementTiming, Element.onfullscreenchange, Element.onfullscreenerror, Element.onwebkitfullscreenchange, Element.onwebkitfullscreenerror, Element.role, Element.ariaAtomic, Element.ariaAutoComplete, Element.ariaBusy, Element.ariaBrailleLabel, Element.ariaBrailleRoleDescription, Element.ariaChecked, Element.ariaColCount, Element.ariaColIndex, Element.ariaColSpan, Element.ariaCurrent, Element.ariaDescription, Element.ariaDisabled, Element.ariaExpanded, Element.ariaHasPopup, Element.ariaHidden, Element.ariaInvalid, Element.ariaKeyShortcuts, Element.ariaLabel, Element.ariaLevel, Element.ariaLive, Element.ariaModal, Element.ariaMultiLine, Element.ariaMultiSelectable, Element.ariaOrientation, Element.ariaPlaceholder, Element.ariaPosInSet, Element.ariaPressed, Element.ariaReadOnly, Element.ariaRelevant, Element.ariaRequired, Element.ariaRoleDescription, Element.ariaRowCount, Element.ariaRowIndex, Element.ariaRowSpan, Element.ariaSelected, Element.ariaSetSize, Element.ariaSort, Element.ariaValueMax, Element.ariaValueMin, Element.ariaValueNow, Element.ariaValueText, Element.children, Element.firstElementChild, Element.lastElementChild, Element.childElementCount, Element.previousElementSibling, Element.nextElementSibling, Element.after, Element.animate, Element.append, Element.attachShadow, Element.before, Element.closest, Element.computedStyleMap, Element.getAttribute, Element.getAttributeNS, Element.getAttributeNames, Element.getAttributeNode, Element.getAttributeNodeNS, Element.getBoundingClientRect, Element.getClientRects, Element.getElementsByClassName, Element.getElementsByTagName, Element.getElementsByTagNameNS, Element.getInnerHTML, Element.hasAttribute, Element.hasAttributeNS, Element.hasAttributes, Element.hasPointerCapture, Element.insertAdjacentElement, Element.insertAdjacentHTML, Element.insertAdjacentText, Element.matches, Element.prepend, Element.querySelector, Element.querySelectorAll, Element.releasePointerCapture, Element.remove, Element.removeAttribute, Element.removeAttributeNS, Element.removeAttributeNode, Element.replaceChildren, Element.replaceWith, Element.requestFullscreen, Element.requestPointerLock, Element.scroll, Element.scrollBy, Element.scrollIntoView, Element.scrollIntoViewIfNeeded, Element.scrollTo, Element.setAttribute, Element.setAttributeNS, Element.setAttributeNode, Element.setAttributeNodeNS, Element.setPointerCapture, Element.toggleAttribute, Element.webkitMatchesSelector, Element.webkitRequestFullScreen, Element.webkitRequestFullscreen, Element.checkVisibility, Element.getAnimations, Element.setHTML"
  },
  Firefox: {
    version: 112,
    windowKeys: "undefined, globalThis, Array, Boolean, JSON, Date, Math, Number, String, RegExp, Error, InternalError, AggregateError, EvalError, RangeError, ReferenceError, SyntaxError, TypeError, URIError, ArrayBuffer, Int8Array, Uint8Array, Int16Array, Uint16Array, Int32Array, Uint32Array, Float32Array, Float64Array, Uint8ClampedArray, BigInt64Array, BigUint64Array, BigInt, Proxy, WeakMap, Set, DataView, Symbol, Intl, Reflect, WeakSet, Atomics, WebAssembly, FinalizationRegistry, WeakRef, NaN, Infinity, isNaN, isFinite, parseFloat, parseInt, escape, unescape, decodeURI, encodeURI, decodeURIComponent, encodeURIComponent, CryptoKey, FocusEvent, CSSRuleList, MediaStreamTrackAudioSourceNode, SVGGeometryElement, SVGElement, SVGPatternElement, WebSocket, HTMLAllCollection, UIEvent, PageTransitionEvent, AuthenticatorAssertionResponse, ScreenOrientation, MediaCapabilitiesInfo, SVGImageElement, NodeIterator, SVGFEOffsetElement, AnimationPlaybackEvent, MessageChannel, TextDecoderStream, ShadowRoot, SVGAnimatedNumberList, SVGEllipseElement, DOMStringMap, AudioWorkletNode, TextMetrics, SVGPointList, SVGSymbolElement, DocumentType, StorageEvent, SVGAnimatedLength, PerformanceObserver, WebGLSampler, PushSubscription, CustomElementRegistry, SVGUnitTypes, SVGFEMorphologyElement, NodeFilter, File, Geolocation, ProcessingInstruction, AudioScheduledSourceNode, FileReader, IDBObjectStore, SVGStringList, HTMLParagraphElement, IDBDatabase, SVGLinearGradientElement, Animation, HTMLIFrameElement, HTMLTableSectionElement, Worker, TimeRanges, Navigator, InputEvent, GamepadHapticActuator, SVGMatrix, Worklet, SVGFEMergeNodeElement, DOMTokenList, MediaQueryListEvent, HTMLParamElement, MessagePort, SVGLengthList, ResizeObserverSize, TextEncoderStream, PromiseRejectionEvent, SVGTransformList, DOMPoint, SVGTextElement, WebGL2RenderingContext, PluginArray, IDBVersionChangeEvent, FontFaceSetLoadEvent, CSSStyleDeclaration, SVGGraphicsElement, HTMLOListElement, HTMLTextAreaElement, Storage, XPathEvaluator, MouseScrollEvent, HTMLCanvasElement, HTMLBodyElement, HTMLCollection, HTMLHtmlElement, MediaList, HTMLAudioElement, IDBFactory, SVGAnimatedTransformList, MimeType, SVGAnimatedPreserveAspectRatio, HTMLFrameElement, HTMLLegendElement, HTMLMapElement, SVGAnimateMotionElement, HTMLFrameSetElement, CSSGroupingRule, Clipboard, IIRFilterNode, ReadableStreamDefaultController, FileSystemFileHandle, HTMLElement, CSSConditionRule, CSS, SVGFEComponentTransferElement, DOMRectList, AudioWorklet, SourceBuffer, HTMLStyleElement, DocumentTimeline, IDBKeyRange, DOMRequest, PerformanceTiming, GeolocationPosition, SVGTextPositioningElement, OfflineResourceList, IDBOpenDBRequest, SVGFEFuncGElement, MouseEvent, FontFaceSet, OffscreenCanvasRenderingContext2D, OscillatorNode, SpeechSynthesisUtterance, AudioContext, FileSystemEntry, PaintRequest, SVGFEConvolveMatrixElement, ChannelSplitterNode, AudioBufferSourceNode, CaretPosition, AbortSignal, HTMLBRElement, XSLTProcessor, SVGFESpecularLightingElement, mozRTCPeerConnection, XMLSerializer, StorageManager, HTMLImageElement, WebGLQuery, FileSystemHandle, Permissions, BaseAudioContext, MediaStream, History, DOMStringList, StereoPannerNode, ReadableStreamDefaultReader, HTMLDListElement, MutationEvent, SVGComponentTransferFunctionElement, Notification, DynamicsCompressorNode, LockManager, Option, HTMLMeterElement, RTCPeerConnection, CloseEvent, AudioBuffer, ByteLengthQueuingStrategy, SVGFECompositeElement, HTMLTrackElement, ServiceWorkerContainer, MediaStreamTrack, WebGLContextEvent, WritableStreamDefaultController, SVGPathElement, BarProp, PerformanceObserverEntryList, RTCRtpReceiver, StyleSheet, WebGLUniformLocation, HTMLMetaElement, CanvasPattern, OffscreenCanvas, SVGTransform, SVGTextContentElement, PerformanceServerTiming, TrackEvent, XPathExpression, AnimationTimeline, MediaError, HTMLAnchorElement, XMLHttpRequest, SecurityPolicyViolationEvent, CSSMozDocumentRule, CSSImportRule, SVGLength, WaveShaperNode, RTCTrackEvent, RTCRtpSender, CSSAnimation, CSSFontPaletteValuesRule, AnimationEffect, CSSContainerRule, RTCStatsReport, SourceBufferList, HTMLHeadingElement, CanvasCaptureMediaStream, HTMLOptionElement, SVGSVGElement, WebGLActiveInfo, MIDIPort, HTMLUListElement, XPathResult, SVGUseElement, Credential, PublicKeyCredential, DOMQuad, Selection, HTMLDataElement, CSSLayerStatementRule, WebGLShader, Location, MIDIAccess, MediaRecorderErrorEvent, SVGFEGaussianBlurElement, MediaStreamEvent, CSSFontFeatureValuesRule, AbortController, RTCIceCandidate, HTMLLabelElement, PerformanceMeasure, HTMLDirectoryElement, SVGStopElement, PermissionStatus, PerformancePaintTiming, FileSystemFileEntry, SVGMarkerElement, console, SharedWorker, WebGLVertexArrayObject, HTMLOptionsCollection, HTMLTitleElement, TreeWalker, CompositionEvent, IDBCursor, TransformStream, PerformanceNavigation, Blob, SpeechSynthesisErrorEvent, CSSStyleSheet, HTMLUnknownElement, KeyEvent, HTMLOptGroupElement, CanvasGradient, AnalyserNode, Element, AnimationEvent, HTMLFieldSetElement, MediaSession, MutationObserver, SVGAnimateTransformElement, OfflineAudioContext, CacheStorage, MediaKeyStatusMap, GamepadEvent, RTCPeerConnectionIceEvent, AudioParam, AbstractRange, TextEncoder, FileSystemDirectoryHandle, CSSSupportsRule, SVGPreserveAspectRatio, PerformanceEntry, mozRTCSessionDescription, VideoPlaybackQuality, HTMLTableRowElement, HTMLFontElement, MediaKeys, DataTransfer, CSSPageRule, SVGAngle, WebGLFramebuffer, WebGLRenderbuffer, Directory, HTMLAreaElement, MimeTypeArray, NamedNodeMap, CSSKeyframeRule, XMLDocument, HTMLSlotElement, MediaDevices, IDBTransaction, HTMLModElement, MediaKeyError, SVGFEFloodElement, DOMParser, HTMLScriptElement, ReadableStreamBYOBReader, HTMLDataListElement, MediaElementAudioSourceNode, PeriodicWave, DragEvent, SVGStyleElement, SubtleCrypto, TransformStreamDefaultController, MessageEvent, WebGLProgram, SVGSetElement, WebGLShaderPrecisionFormat, ErrorEvent, NodeList, GamepadButton, MediaDeviceInfo, HTMLMediaElement, DeviceMotionEvent, ImageData, Range, PushSubscriptionOptions, OfflineAudioCompletionEvent, DOMPointReadOnly, DocumentFragment, Attr, BroadcastChannel, HTMLLinkElement, DOMMatrixReadOnly, AuthenticatorAttestationResponse, IdleDeadline, ImageBitmapRenderingContext, MediaKeySystemAccess, SVGPoint, SVGFEDropShadowElement, SVGFEDiffuseLightingElement, SVGRadialGradientElement, RTCDataChannelEvent, Headers, FileSystemDirectoryReader, SVGFEDisplacementMapElement, SVGDefsElement, SVGFEDistantLightElement, HTMLFormControlsCollection, WebGLRenderingContext, HTMLTableElement, SVGNumber, SVGAnimatedInteger, VisualViewport, SpeechSynthesisVoice, WheelEvent, SVGAnimatedNumber, GamepadPose, ResizeObserver, TextDecoder, FormDataEvent, FileSystem, IntersectionObserverEntry, SVGPolylineElement, Text, CanvasRenderingContext2D, CSSFontFaceRule, SVGGradientElement, WritableStream, SVGNumberList, SpeechSynthesisEvent, WritableStreamDefaultWriter, SVGFilterElement, URL, SVGRect, SVGFEImageElement, AudioDestinationNode, IDBRequest, MathMLElement, HTMLTimeElement, TextTrackCue, RadioNodeList, SVGTSpanElement, SVGAnimatedLengthList, SVGAnimatedString, HTMLSourceElement, Lock, ProgressEvent, PopupBlockedEvent, ValidityState, WebKitCSSMatrix, AudioListener, HTMLFormElement, PerformanceEventTiming, HTMLProgressElement, Gamepad, MediaKeySession, MediaStreamAudioSourceNode, CSSRule, HTMLPreElement, webkitURL, AuthenticatorResponse, HTMLEmbedElement, HTMLDivElement, MediaStreamAudioDestinationNode, CredentialsContainer, SVGScriptElement, MutationRecord, ConvolverNode, SVGFEPointLightElement, Screen, ClipboardEvent, SVGFETurbulenceElement, SVGFEBlendElement, GeolocationCoordinates, TextTrackList, FontFace, HTMLInputElement, Request, SVGGElement, SVGClipPathElement, TimeEvent, TextTrackCueList, BiquadFilterNode, SVGTitleElement, SVGFETileElement, SVGFEFuncRElement, HTMLButtonElement, Path2D, HTMLTableCellElement, StaticRange, SVGLineElement, CSSCounterStyleRule, HTMLQuoteElement, AudioParamMap, DeviceOrientationEvent, IDBCursorWithValue, MediaKeyMessageEvent, SVGAnimatedEnumeration, MIDIOutput, HTMLHRElement, ImageBitmap, CSSStyleRule, MIDIOutputMap, SVGAElement, ElementInternals, VTTCue, MediaMetadata, PannerNode, SVGForeignObjectElement, SVGSwitchElement, HTMLVideoElement, MediaEncryptedEvent, EventSource, SVGAnimateElement, DOMException, CSSTransition, Image, VTTRegion, CharacterData, SVGFEFuncAElement, SVGDescElement, SubmitEvent, RTCSessionDescription, SVGAnimatedBoolean, StyleSheetList, HTMLTableColElement, HTMLMarqueeElement, CSSKeyframesRule, SVGMetadataElement, MIDIInputMap, PushManager, GainNode, DOMRect, SVGMaskElement, HTMLMenuElement, RTCDTMFToneChangeEvent, IDBIndex, CSSMediaRule, HashChangeEvent, ServiceWorker, SVGFEFuncBElement, BlobEvent, DOMImplementation, GeolocationPositionError, SVGMPathElement, SVGFEColorMatrixElement, KeyboardEvent, HTMLLIElement, RTCCertificate, SpeechSynthesis, ReadableStreamBYOBRequest, DelayNode, XMLHttpRequestEventTarget, PopStateEvent, Cache, ScrollAreaEvent, RTCDtlsTransport, SVGTextPathElement, XMLHttpRequestUpload, HTMLOutputElement, MediaRecorder, PaintRequestList, SVGRectElement, AudioNode, DOMMatrix, MediaSource, FormData, NavigationPreloadManager, HTMLTableCaptionElement, CustomEvent, MediaCapabilities, SVGFEMergeElement, MediaStreamTrackEvent, Audio, CSS2Properties, FileList, SVGAnimatedRect, FileSystemWritableFileStream, ReadableStream, HTMLPictureElement, HTMLSelectElement, AudioProcessingEvent, PerformanceResourceTiming, Plugin, Crypto, CSSLayerBlockRule, ConstantSourceNode, HTMLSpanElement, DataTransferItem, ServiceWorkerRegistration, WebGLTransformFeedback, SVGViewElement, CSSNamespaceRule, URLSearchParams, WebGLBuffer, MediaQueryList, PointerEvent, SVGPolygonElement, KeyframeEffect, RTCDTMFSender, ResizeObserverEntry, SVGCircleElement, SVGAnimationElement, WebGLTexture, DOMRectReadOnly, WebGLSync, IntersectionObserver, MIDIMessageEvent, ReadableByteStreamController, HTMLBaseElement, CountQueuingStrategy, mozRTCIceCandidate, DataTransferItemList, HTMLHeadElement, CDATASection, HTMLDialogElement, HTMLTemplateElement, RTCDataChannel, PerformanceMark, SVGFESpotLightElement, BeforeUnloadEvent, MIDIConnectionEvent, RTCRtpTransceiver, TextTrack, TransitionEvent, HTMLDetailsElement, Comment, HTMLObjectElement, ChannelMergerNode, SVGAnimatedAngle, Response, FileSystemDirectoryEntry, MIDIInput, ScriptProcessorNode, Function, Object, eval, EventTarget, Window, close, stop, focus, blur, open, alert, confirm, prompt, print, postMessage, captureEvents, releaseEvents, getSelection, getComputedStyle, matchMedia, moveTo, moveBy, resizeTo, resizeBy, scroll, scrollTo, scrollBy, getDefaultComputedStyle, scrollByLines, scrollByPages, sizeToContent, updateCommands, find, dump, setResizable, requestIdleCallback, cancelIdleCallback, requestAnimationFrame, cancelAnimationFrame, reportError, btoa, atob, setTimeout, clearTimeout, setInterval, clearInterval, queueMicrotask, createImageBitmap, structuredClone, fetch, self, name, history, customElements, locationbar, menubar, personalbar, scrollbars, statusbar, toolbar, status, closed, event, frames, length, opener, parent, frameElement, navigator, clientInformation, external, applicationCache, screen, innerWidth, innerHeight, scrollX, pageXOffset, scrollY, pageYOffset, screenLeft, screenTop, screenX, screenY, outerWidth, outerHeight, performance, mozInnerScreenX, mozInnerScreenY, devicePixelRatio, scrollMaxX, scrollMaxY, fullScreen, ondevicemotion, ondeviceorientation, ondeviceorientationabsolute, InstallTrigger, visualViewport, crypto, onabort, onblur, onfocus, onauxclick, onbeforeinput, oncanplay, oncanplaythrough, onchange, onclick, onclose, oncontextmenu, oncopy, oncuechange, oncut, ondblclick, ondrag, ondragend, ondragenter, ondragexit, ondragleave, ondragover, ondragstart, ondrop, ondurationchange, onemptied, onended, onformdata, oninput, oninvalid, onkeydown, onkeypress, onkeyup, onload, onloadeddata, onloadedmetadata, onloadstart, onmousedown, onmouseenter, onmouseleave, onmousemove, onmouseout, onmouseover, onmouseup, onwheel, onpaste, onpause, onplay, onplaying, onprogress, onratechange, onreset, onresize, onscroll, onscrollend, onsecuritypolicyviolation, onseeked, onseeking, onselect, onslotchange, onstalled, onsubmit, onsuspend, ontimeupdate, onvolumechange, onwaiting, onselectstart, onselectionchange, ontoggle, onpointercancel, onpointerdown, onpointerup, onpointermove, onpointerout, onpointerover, onpointerenter, onpointerleave, ongotpointercapture, onlostpointercapture, onmozfullscreenchange, onmozfullscreenerror, onanimationcancel, onanimationend, onanimationiteration, onanimationstart, ontransitioncancel, ontransitionend, ontransitionrun, ontransitionstart, onwebkitanimationend, onwebkitanimationiteration, onwebkitanimationstart, onwebkittransitionend, onerror, speechSynthesis, onafterprint, onbeforeprint, onbeforeunload, onhashchange, onlanguagechange, onmessage, onmessageerror, onoffline, ononline, onpagehide, onpageshow, onpopstate, onrejectionhandled, onstorage, onunhandledrejection, onunload, ongamepadconnected, ongamepaddisconnected, localStorage, origin, crossOriginIsolated, isSecureContext, indexedDB, caches, sessionStorage, window, document, location, top, netscape, Node, Document, HTMLDocument, EventCounts, Map, Promise, Event",
    cssKeys: "alignContent, align-content, alignItems, align-items, alignSelf, align-self, aspectRatio, aspect-ratio, backfaceVisibility, backface-visibility, borderCollapse, border-collapse, borderImageRepeat, border-image-repeat, boxDecorationBreak, box-decoration-break, boxSizing, box-sizing, breakInside, break-inside, captionSide, caption-side, clear, colorInterpolation, color-interpolation, colorInterpolationFilters, color-interpolation-filters, columnCount, column-count, columnFill, column-fill, columnSpan, column-span, contain, containerType, container-type, direction, display, dominantBaseline, dominant-baseline, emptyCells, empty-cells, flexDirection, flex-direction, flexWrap, flex-wrap, cssFloat, float, fontKerning, font-kerning, fontLanguageOverride, font-language-override, fontOpticalSizing, font-optical-sizing, fontSizeAdjust, font-size-adjust, fontStretch, font-stretch, fontStyle, font-style, fontVariantCaps, font-variant-caps, fontVariantEastAsian, font-variant-east-asian, fontVariantLigatures, font-variant-ligatures, fontVariantNumeric, font-variant-numeric, fontVariantPosition, font-variant-position, fontWeight, font-weight, gridAutoFlow, grid-auto-flow, hyphens, imageOrientation, image-orientation, imageRendering, image-rendering, imeMode, ime-mode, isolation, justifyContent, justify-content, justifyItems, justify-items, justifySelf, justify-self, lineBreak, line-break, listStylePosition, list-style-position, maskType, mask-type, mixBlendMode, mix-blend-mode, MozBoxAlign, -moz-box-align, MozBoxDirection, -moz-box-direction, MozBoxOrient, -moz-box-orient, MozBoxPack, -moz-box-pack, MozFloatEdge, -moz-float-edge, MozOrient, -moz-orient, MozTextSizeAdjust, -moz-text-size-adjust, MozUserFocus, -moz-user-focus, MozUserInput, -moz-user-input, MozUserModify, -moz-user-modify, MozWindowDragging, -moz-window-dragging, objectFit, object-fit, offsetRotate, offset-rotate, outlineStyle, outline-style, overflowAnchor, overflow-anchor, overflowWrap, overflow-wrap, paintOrder, paint-order, pointerEvents, pointer-events, position, printColorAdjust, print-color-adjust, resize, rubyAlign, ruby-align, rubyPosition, ruby-position, scrollBehavior, scroll-behavior, scrollSnapAlign, scroll-snap-align, scrollSnapStop, scroll-snap-stop, scrollSnapType, scroll-snap-type, scrollbarGutter, scrollbar-gutter, scrollbarWidth, scrollbar-width, shapeRendering, shape-rendering, strokeLinecap, stroke-linecap, strokeLinejoin, stroke-linejoin, tableLayout, table-layout, textAlign, text-align, textAlignLast, text-align-last, textAnchor, text-anchor, textCombineUpright, text-combine-upright, textDecorationLine, text-decoration-line, textDecorationSkipInk, text-decoration-skip-ink, textDecorationStyle, text-decoration-style, textEmphasisPosition, text-emphasis-position, textJustify, text-justify, textOrientation, text-orientation, textRendering, text-rendering, textTransform, text-transform, textUnderlinePosition, text-underline-position, touchAction, touch-action, transformBox, transform-box, transformStyle, transform-style, unicodeBidi, unicode-bidi, userSelect, user-select, vectorEffect, vector-effect, visibility, webkitLineClamp, WebkitLineClamp, -webkit-line-clamp, whiteSpace, white-space, wordBreak, word-break, writingMode, writing-mode, zIndex, z-index, appearance, MozForceBrokenImageIcon, -moz-force-broken-image-icon, breakAfter, break-after, breakBefore, break-before, clipRule, clip-rule, fillRule, fill-rule, fillOpacity, fill-opacity, strokeOpacity, stroke-opacity, fontSynthesisSmallCaps, font-synthesis-small-caps, fontSynthesisStyle, font-synthesis-style, fontSynthesisWeight, font-synthesis-weight, MozBoxOrdinalGroup, -moz-box-ordinal-group, order, flexGrow, flex-grow, flexShrink, flex-shrink, MozBoxFlex, -moz-box-flex, strokeMiterlimit, stroke-miterlimit, overflowBlock, overflow-block, overflowInline, overflow-inline, overflowX, overflow-x, overflowY, overflow-y, overscrollBehaviorBlock, overscroll-behavior-block, overscrollBehaviorInline, overscroll-behavior-inline, overscrollBehaviorX, overscroll-behavior-x, overscrollBehaviorY, overscroll-behavior-y, floodOpacity, flood-opacity, opacity, shapeImageThreshold, shape-image-threshold, stopOpacity, stop-opacity, borderBlockEndStyle, border-block-end-style, borderBlockStartStyle, border-block-start-style, borderBottomStyle, border-bottom-style, borderInlineEndStyle, border-inline-end-style, borderInlineStartStyle, border-inline-start-style, borderLeftStyle, border-left-style, borderRightStyle, border-right-style, borderTopStyle, border-top-style, columnRuleStyle, column-rule-style, accentColor, accent-color, animationDelay, animation-delay, animationDirection, animation-direction, animationDuration, animation-duration, animationFillMode, animation-fill-mode, animationIterationCount, animation-iteration-count, animationName, animation-name, animationPlayState, animation-play-state, animationTimingFunction, animation-timing-function, backdropFilter, backdrop-filter, backgroundAttachment, background-attachment, backgroundBlendMode, background-blend-mode, backgroundClip, background-clip, backgroundImage, background-image, backgroundOrigin, background-origin, backgroundPositionX, background-position-x, backgroundPositionY, background-position-y, backgroundRepeat, background-repeat, backgroundSize, background-size, borderImageOutset, border-image-outset, borderImageSlice, border-image-slice, borderImageWidth, border-image-width, borderSpacing, border-spacing, boxShadow, box-shadow, caretColor, caret-color, clip, clipPath, clip-path, color, colorScheme, color-scheme, columnWidth, column-width, containerName, container-name, content, counterIncrement, counter-increment, counterReset, counter-reset, counterSet, counter-set, cursor, d, filter, flexBasis, flex-basis, fontFamily, font-family, fontFeatureSettings, font-feature-settings, fontPalette, font-palette, fontSize, font-size, fontVariantAlternates, font-variant-alternates, fontVariationSettings, font-variation-settings, gridTemplateAreas, grid-template-areas, hyphenateCharacter, hyphenate-character, letterSpacing, letter-spacing, lineHeight, line-height, listStyleType, list-style-type, maskClip, mask-clip, maskComposite, mask-composite, maskImage, mask-image, maskMode, mask-mode, maskOrigin, mask-origin, maskPositionX, mask-position-x, maskPositionY, mask-position-y, maskRepeat, mask-repeat, maskSize, mask-size, offsetPath, offset-path, page, perspective, quotes, rotate, scale, scrollbarColor, scrollbar-color, shapeOutside, shape-outside, strokeDasharray, stroke-dasharray, strokeDashoffset, stroke-dashoffset, strokeWidth, stroke-width, tabSize, tab-size, textDecorationThickness, text-decoration-thickness, textEmphasisStyle, text-emphasis-style, textOverflow, text-overflow, textShadow, text-shadow, transitionDelay, transition-delay, transitionDuration, transition-duration, transitionProperty, transition-property, transitionTimingFunction, transition-timing-function, translate, verticalAlign, vertical-align, willChange, will-change, wordSpacing, word-spacing, objectPosition, object-position, perspectiveOrigin, perspective-origin, offsetAnchor, offset-anchor, fill, stroke, transformOrigin, transform-origin, gridTemplateColumns, grid-template-columns, gridTemplateRows, grid-template-rows, borderImageSource, border-image-source, listStyleImage, list-style-image, gridAutoColumns, grid-auto-columns, gridAutoRows, grid-auto-rows, transform, columnGap, column-gap, rowGap, row-gap, markerEnd, marker-end, markerMid, marker-mid, markerStart, marker-start, containIntrinsicBlockSize, contain-intrinsic-block-size, containIntrinsicHeight, contain-intrinsic-height, containIntrinsicInlineSize, contain-intrinsic-inline-size, containIntrinsicWidth, contain-intrinsic-width, gridColumnEnd, grid-column-end, gridColumnStart, grid-column-start, gridRowEnd, grid-row-end, gridRowStart, grid-row-start, maxBlockSize, max-block-size, maxHeight, max-height, maxInlineSize, max-inline-size, maxWidth, max-width, cx, cy, offsetDistance, offset-distance, textIndent, text-indent, x, y, borderBottomLeftRadius, border-bottom-left-radius, borderBottomRightRadius, border-bottom-right-radius, borderEndEndRadius, border-end-end-radius, borderEndStartRadius, border-end-start-radius, borderStartEndRadius, border-start-end-radius, borderStartStartRadius, border-start-start-radius, borderTopLeftRadius, border-top-left-radius, borderTopRightRadius, border-top-right-radius, blockSize, block-size, height, inlineSize, inline-size, minBlockSize, min-block-size, minHeight, min-height, minInlineSize, min-inline-size, minWidth, min-width, width, paddingBlockEnd, padding-block-end, paddingBlockStart, padding-block-start, paddingBottom, padding-bottom, paddingInlineEnd, padding-inline-end, paddingInlineStart, padding-inline-start, paddingLeft, padding-left, paddingRight, padding-right, paddingTop, padding-top, r, shapeMargin, shape-margin, rx, ry, scrollPaddingBlockEnd, scroll-padding-block-end, scrollPaddingBlockStart, scroll-padding-block-start, scrollPaddingBottom, scroll-padding-bottom, scrollPaddingInlineEnd, scroll-padding-inline-end, scrollPaddingInlineStart, scroll-padding-inline-start, scrollPaddingLeft, scroll-padding-left, scrollPaddingRight, scroll-padding-right, scrollPaddingTop, scroll-padding-top, borderBlockEndWidth, border-block-end-width, borderBlockStartWidth, border-block-start-width, borderBottomWidth, border-bottom-width, borderInlineEndWidth, border-inline-end-width, borderInlineStartWidth, border-inline-start-width, borderLeftWidth, border-left-width, borderRightWidth, border-right-width, borderTopWidth, border-top-width, columnRuleWidth, column-rule-width, outlineWidth, outline-width, webkitTextStrokeWidth, WebkitTextStrokeWidth, -webkit-text-stroke-width, outlineOffset, outline-offset, overflowClipMargin, overflow-clip-margin, scrollMarginBlockEnd, scroll-margin-block-end, scrollMarginBlockStart, scroll-margin-block-start, scrollMarginBottom, scroll-margin-bottom, scrollMarginInlineEnd, scroll-margin-inline-end, scrollMarginInlineStart, scroll-margin-inline-start, scrollMarginLeft, scroll-margin-left, scrollMarginRight, scroll-margin-right, scrollMarginTop, scroll-margin-top, bottom, insetBlockEnd, inset-block-end, insetBlockStart, inset-block-start, insetInlineEnd, inset-inline-end, insetInlineStart, inset-inline-start, left, marginBlockEnd, margin-block-end, marginBlockStart, margin-block-start, marginBottom, margin-bottom, marginInlineEnd, margin-inline-end, marginInlineStart, margin-inline-start, marginLeft, margin-left, marginRight, margin-right, marginTop, margin-top, right, textUnderlineOffset, text-underline-offset, top, backgroundColor, background-color, borderBlockEndColor, border-block-end-color, borderBlockStartColor, border-block-start-color, borderBottomColor, border-bottom-color, borderInlineEndColor, border-inline-end-color, borderInlineStartColor, border-inline-start-color, borderLeftColor, border-left-color, borderRightColor, border-right-color, borderTopColor, border-top-color, columnRuleColor, column-rule-color, floodColor, flood-color, lightingColor, lighting-color, outlineColor, outline-color, stopColor, stop-color, textDecorationColor, text-decoration-color, textEmphasisColor, text-emphasis-color, webkitTextFillColor, WebkitTextFillColor, -webkit-text-fill-color, webkitTextStrokeColor, WebkitTextStrokeColor, -webkit-text-stroke-color, background, backgroundPosition, background-position, borderColor, border-color, borderStyle, border-style, borderWidth, border-width, borderTop, border-top, borderRight, border-right, borderBottom, border-bottom, borderLeft, border-left, borderBlockStart, border-block-start, borderBlockEnd, border-block-end, borderInlineStart, border-inline-start, borderInlineEnd, border-inline-end, border, borderRadius, border-radius, borderImage, border-image, borderBlockWidth, border-block-width, borderBlockStyle, border-block-style, borderBlockColor, border-block-color, borderInlineWidth, border-inline-width, borderInlineStyle, border-inline-style, borderInlineColor, border-inline-color, borderBlock, border-block, borderInline, border-inline, overflow, overscrollBehavior, overscroll-behavior, container, pageBreakBefore, page-break-before, pageBreakAfter, page-break-after, pageBreakInside, page-break-inside, offset, columns, columnRule, column-rule, font, fontVariant, font-variant, fontSynthesis, font-synthesis, marker, textEmphasis, text-emphasis, webkitTextStroke, WebkitTextStroke, -webkit-text-stroke, listStyle, list-style, margin, marginBlock, margin-block, marginInline, margin-inline, scrollMargin, scroll-margin, scrollMarginBlock, scroll-margin-block, scrollMarginInline, scroll-margin-inline, outline, padding, paddingBlock, padding-block, paddingInline, padding-inline, scrollPadding, scroll-padding, scrollPaddingBlock, scroll-padding-block, scrollPaddingInline, scroll-padding-inline, flexFlow, flex-flow, flex, gap, gridRow, grid-row, gridColumn, grid-column, gridArea, grid-area, gridTemplate, grid-template, grid, placeContent, place-content, placeSelf, place-self, placeItems, place-items, inset, insetBlock, inset-block, insetInline, inset-inline, containIntrinsicSize, contain-intrinsic-size, mask, maskPosition, mask-position, textDecoration, text-decoration, transition, animation, all, webkitBackgroundClip, WebkitBackgroundClip, -webkit-background-clip, webkitBackgroundOrigin, WebkitBackgroundOrigin, -webkit-background-origin, webkitBackgroundSize, WebkitBackgroundSize, -webkit-background-size, MozBorderStartColor, -moz-border-start-color, MozBorderStartStyle, -moz-border-start-style, MozBorderStartWidth, -moz-border-start-width, MozBorderEndColor, -moz-border-end-color, MozBorderEndStyle, -moz-border-end-style, MozBorderEndWidth, -moz-border-end-width, webkitBorderTopLeftRadius, WebkitBorderTopLeftRadius, -webkit-border-top-left-radius, webkitBorderTopRightRadius, WebkitBorderTopRightRadius, -webkit-border-top-right-radius, webkitBorderBottomRightRadius, WebkitBorderBottomRightRadius, -webkit-border-bottom-right-radius, webkitBorderBottomLeftRadius, WebkitBorderBottomLeftRadius, -webkit-border-bottom-left-radius, MozTransform, -moz-transform, webkitTransform, WebkitTransform, -webkit-transform, MozPerspective, -moz-perspective, webkitPerspective, WebkitPerspective, -webkit-perspective, MozPerspectiveOrigin, -moz-perspective-origin, webkitPerspectiveOrigin, WebkitPerspectiveOrigin, -webkit-perspective-origin, MozBackfaceVisibility, -moz-backface-visibility, webkitBackfaceVisibility, WebkitBackfaceVisibility, -webkit-backface-visibility, MozTransformStyle, -moz-transform-style, webkitTransformStyle, WebkitTransformStyle, -webkit-transform-style, MozTransformOrigin, -moz-transform-origin, webkitTransformOrigin, WebkitTransformOrigin, -webkit-transform-origin, MozAppearance, -moz-appearance, webkitAppearance, WebkitAppearance, -webkit-appearance, webkitBoxShadow, WebkitBoxShadow, -webkit-box-shadow, webkitFilter, WebkitFilter, -webkit-filter, MozFontFeatureSettings, -moz-font-feature-settings, MozFontLanguageOverride, -moz-font-language-override, colorAdjust, color-adjust, MozHyphens, -moz-hyphens, webkitTextSizeAdjust, WebkitTextSizeAdjust, -webkit-text-size-adjust, wordWrap, word-wrap, MozTabSize, -moz-tab-size, MozMarginStart, -moz-margin-start, MozMarginEnd, -moz-margin-end, MozPaddingStart, -moz-padding-start, MozPaddingEnd, -moz-padding-end, webkitFlexDirection, WebkitFlexDirection, -webkit-flex-direction, webkitFlexWrap, WebkitFlexWrap, -webkit-flex-wrap, webkitJustifyContent, WebkitJustifyContent, -webkit-justify-content, webkitAlignContent, WebkitAlignContent, -webkit-align-content, webkitAlignItems, WebkitAlignItems, -webkit-align-items, webkitFlexGrow, WebkitFlexGrow, -webkit-flex-grow, webkitFlexShrink, WebkitFlexShrink, -webkit-flex-shrink, webkitAlignSelf, WebkitAlignSelf, -webkit-align-self, webkitOrder, WebkitOrder, -webkit-order, webkitFlexBasis, WebkitFlexBasis, -webkit-flex-basis, MozBoxSizing, -moz-box-sizing, webkitBoxSizing, WebkitBoxSizing, -webkit-box-sizing, gridColumnGap, grid-column-gap, gridRowGap, grid-row-gap, webkitClipPath, WebkitClipPath, -webkit-clip-path, webkitMaskRepeat, WebkitMaskRepeat, -webkit-mask-repeat, webkitMaskPositionX, WebkitMaskPositionX, -webkit-mask-position-x, webkitMaskPositionY, WebkitMaskPositionY, -webkit-mask-position-y, webkitMaskClip, WebkitMaskClip, -webkit-mask-clip, webkitMaskOrigin, WebkitMaskOrigin, -webkit-mask-origin, webkitMaskSize, WebkitMaskSize, -webkit-mask-size, webkitMaskComposite, WebkitMaskComposite, -webkit-mask-composite, webkitMaskImage, WebkitMaskImage, -webkit-mask-image, MozUserSelect, -moz-user-select, webkitUserSelect, WebkitUserSelect, -webkit-user-select, MozTransitionDuration, -moz-transition-duration, webkitTransitionDuration, WebkitTransitionDuration, -webkit-transition-duration, MozTransitionTimingFunction, -moz-transition-timing-function, webkitTransitionTimingFunction, WebkitTransitionTimingFunction, -webkit-transition-timing-function, MozTransitionProperty, -moz-transition-property, webkitTransitionProperty, WebkitTransitionProperty, -webkit-transition-property, MozTransitionDelay, -moz-transition-delay, webkitTransitionDelay, WebkitTransitionDelay, -webkit-transition-delay, MozAnimationName, -moz-animation-name, webkitAnimationName, WebkitAnimationName, -webkit-animation-name, MozAnimationDuration, -moz-animation-duration, webkitAnimationDuration, WebkitAnimationDuration, -webkit-animation-duration, MozAnimationTimingFunction, -moz-animation-timing-function, webkitAnimationTimingFunction, WebkitAnimationTimingFunction, -webkit-animation-timing-function, MozAnimationIterationCount, -moz-animation-iteration-count, webkitAnimationIterationCount, WebkitAnimationIterationCount, -webkit-animation-iteration-count, MozAnimationDirection, -moz-animation-direction, webkitAnimationDirection, WebkitAnimationDirection, -webkit-animation-direction, MozAnimationPlayState, -moz-animation-play-state, webkitAnimationPlayState, WebkitAnimationPlayState, -webkit-animation-play-state, MozAnimationFillMode, -moz-animation-fill-mode, webkitAnimationFillMode, WebkitAnimationFillMode, -webkit-animation-fill-mode, MozAnimationDelay, -moz-animation-delay, webkitAnimationDelay, WebkitAnimationDelay, -webkit-animation-delay, webkitBoxAlign, WebkitBoxAlign, -webkit-box-align, webkitBoxDirection, WebkitBoxDirection, -webkit-box-direction, webkitBoxFlex, WebkitBoxFlex, -webkit-box-flex, webkitBoxOrient, WebkitBoxOrient, -webkit-box-orient, webkitBoxPack, WebkitBoxPack, -webkit-box-pack, webkitBoxOrdinalGroup, WebkitBoxOrdinalGroup, -webkit-box-ordinal-group, MozBorderStart, -moz-border-start, MozBorderEnd, -moz-border-end, webkitBorderRadius, WebkitBorderRadius, -webkit-border-radius, MozBorderImage, -moz-border-image, webkitBorderImage, WebkitBorderImage, -webkit-border-image, webkitFlexFlow, WebkitFlexFlow, -webkit-flex-flow, webkitFlex, WebkitFlex, -webkit-flex, gridGap, grid-gap, webkitMask, WebkitMask, -webkit-mask, webkitMaskPosition, WebkitMaskPosition, -webkit-mask-position, MozTransition, -moz-transition, webkitTransition, WebkitTransition, -webkit-transition, MozAnimation, -moz-animation, webkitAnimation, WebkitAnimation, -webkit-animation, constructor",
    jsKeys: "Object.assign, Object.getPrototypeOf, Object.setPrototypeOf, Object.getOwnPropertyDescriptor, Object.getOwnPropertyDescriptors, Object.keys, Object.values, Object.entries, Object.is, Object.defineProperty, Object.defineProperties, Object.create, Object.getOwnPropertyNames, Object.getOwnPropertySymbols, Object.isExtensible, Object.preventExtensions, Object.freeze, Object.isFrozen, Object.seal, Object.isSealed, Object.fromEntries, Object.hasOwn, Object.toString, Object.toLocaleString, Object.valueOf, Object.hasOwnProperty, Object.isPrototypeOf, Object.propertyIsEnumerable, Object.__defineGetter__, Object.__defineSetter__, Object.__lookupGetter__, Object.__lookupSetter__, Object.__proto__, Function.toString, Function.apply, Function.call, Function.bind, Boolean.toString, Boolean.valueOf, Symbol.for, Symbol.keyFor, Symbol.isConcatSpreadable, Symbol.iterator, Symbol.match, Symbol.replace, Symbol.search, Symbol.species, Symbol.hasInstance, Symbol.split, Symbol.toPrimitive, Symbol.toStringTag, Symbol.unscopables, Symbol.asyncIterator, Symbol.matchAll, Symbol.toString, Symbol.valueOf, Symbol.description, Error.toString, Error.message, Error.stack, Number.isFinite, Number.isInteger, Number.isNaN, Number.isSafeInteger, Number.POSITIVE_INFINITY, Number.NEGATIVE_INFINITY, Number.MAX_VALUE, Number.MIN_VALUE, Number.MAX_SAFE_INTEGER, Number.MIN_SAFE_INTEGER, Number.EPSILON, Number.parseInt, Number.parseFloat, Number.NaN, Number.toString, Number.toLocaleString, Number.valueOf, Number.toFixed, Number.toExponential, Number.toPrecision, BigInt.asUintN, BigInt.asIntN, BigInt.valueOf, BigInt.toString, BigInt.toLocaleString, Math.abs, Math.acos, Math.asin, Math.atan, Math.atan2, Math.ceil, Math.clz32, Math.cos, Math.exp, Math.floor, Math.imul, Math.fround, Math.log, Math.max, Math.min, Math.pow, Math.random, Math.round, Math.sin, Math.sqrt, Math.tan, Math.log10, Math.log2, Math.log1p, Math.expm1, Math.cosh, Math.sinh, Math.tanh, Math.acosh, Math.asinh, Math.atanh, Math.hypot, Math.trunc, Math.sign, Math.cbrt, Math.E, Math.LOG2E, Math.LOG10E, Math.LN2, Math.LN10, Math.PI, Math.SQRT2, Math.SQRT1_2, Date.UTC, Date.parse, Date.now, Date.getTime, Date.getTimezoneOffset, Date.getYear, Date.getFullYear, Date.getUTCFullYear, Date.getMonth, Date.getUTCMonth, Date.getDate, Date.getUTCDate, Date.getDay, Date.getUTCDay, Date.getHours, Date.getUTCHours, Date.getMinutes, Date.getUTCMinutes, Date.getSeconds, Date.getUTCSeconds, Date.getMilliseconds, Date.getUTCMilliseconds, Date.setTime, Date.setYear, Date.setFullYear, Date.setUTCFullYear, Date.setMonth, Date.setUTCMonth, Date.setDate, Date.setUTCDate, Date.setHours, Date.setUTCHours, Date.setMinutes, Date.setUTCMinutes, Date.setSeconds, Date.setUTCSeconds, Date.setMilliseconds, Date.setUTCMilliseconds, Date.toUTCString, Date.toLocaleString, Date.toLocaleDateString, Date.toLocaleTimeString, Date.toDateString, Date.toTimeString, Date.toISOString, Date.toJSON, Date.toString, Date.valueOf, Date.toGMTString, String.fromCharCode, String.fromCodePoint, String.raw, String.toString, String.valueOf, String.toLowerCase, String.toUpperCase, String.charAt, String.charCodeAt, String.substring, String.padStart, String.padEnd, String.codePointAt, String.includes, String.indexOf, String.lastIndexOf, String.startsWith, String.endsWith, String.trim, String.trimStart, String.trimEnd, String.toLocaleLowerCase, String.toLocaleUpperCase, String.localeCompare, String.repeat, String.normalize, String.match, String.matchAll, String.search, String.replace, String.replaceAll, String.split, String.substr, String.concat, String.slice, String.at, String.bold, String.italics, String.fixed, String.strike, String.small, String.big, String.blink, String.sup, String.sub, String.anchor, String.link, String.fontcolor, String.fontsize, String.trimLeft, String.trimRight, RegExp.input, RegExp.lastMatch, RegExp.lastParen, RegExp.leftContext, RegExp.rightContext, RegExp.$1, RegExp.$2, RegExp.$3, RegExp.$4, RegExp.$5, RegExp.$6, RegExp.$7, RegExp.$8, RegExp.$9, RegExp.$_, RegExp.$&, RegExp.$+, RegExp.$`, RegExp.$', RegExp.toString, RegExp.compile, RegExp.exec, RegExp.test, RegExp.flags, RegExp.hasIndices, RegExp.global, RegExp.ignoreCase, RegExp.multiline, RegExp.dotAll, RegExp.source, RegExp.sticky, RegExp.unicode, Array.isArray, Array.from, Array.of, Array.toString, Array.toLocaleString, Array.join, Array.reverse, Array.sort, Array.push, Array.pop, Array.shift, Array.unshift, Array.splice, Array.concat, Array.slice, Array.lastIndexOf, Array.indexOf, Array.forEach, Array.map, Array.filter, Array.reduce, Array.reduceRight, Array.some, Array.every, Array.find, Array.findIndex, Array.copyWithin, Array.fill, Array.entries, Array.keys, Array.values, Array.includes, Array.flatMap, Array.flat, Array.at, Array.findLast, Array.findLastIndex, Map.get, Map.has, Map.set, Map.delete, Map.keys, Map.values, Map.clear, Map.forEach, Map.entries, Map.size, Set.has, Set.add, Set.delete, Set.entries, Set.clear, Set.forEach, Set.values, Set.keys, Set.size, WeakMap.has, WeakMap.get, WeakMap.delete, WeakMap.set, WeakSet.add, WeakSet.delete, WeakSet.has, Atomics.compareExchange, Atomics.load, Atomics.store, Atomics.exchange, Atomics.add, Atomics.sub, Atomics.and, Atomics.or, Atomics.xor, Atomics.isLockFree, Atomics.wait, Atomics.notify, Atomics.wake, JSON.parse, JSON.stringify, Promise.all, Promise.allSettled, Promise.any, Promise.race, Promise.reject, Promise.resolve, Promise.then, Promise.catch, Promise.finally, Reflect.apply, Reflect.construct, Reflect.defineProperty, Reflect.deleteProperty, Reflect.get, Reflect.getOwnPropertyDescriptor, Reflect.getPrototypeOf, Reflect.has, Reflect.isExtensible, Reflect.ownKeys, Reflect.preventExtensions, Reflect.set, Reflect.setPrototypeOf, Proxy.revocable, Intl.getCanonicalLocales, Intl.supportedValuesOf, Intl.Collator, Intl.DateTimeFormat, Intl.DisplayNames, Intl.ListFormat, Intl.Locale, Intl.NumberFormat, Intl.PluralRules, Intl.RelativeTimeFormat, WebAssembly.compile, WebAssembly.instantiate, WebAssembly.validate, WebAssembly.compileStreaming, WebAssembly.instantiateStreaming, WebAssembly.Module, WebAssembly.Instance, WebAssembly.Memory, WebAssembly.Table, WebAssembly.Global, WebAssembly.CompileError, WebAssembly.LinkError, WebAssembly.RuntimeError, WebAssembly.Tag, WebAssembly.Exception, Document.getElementsByTagName, Document.getElementsByTagNameNS, Document.getElementsByClassName, Document.getElementById, Document.createElement, Document.createElementNS, Document.createDocumentFragment, Document.createTextNode, Document.createComment, Document.createProcessingInstruction, Document.importNode, Document.adoptNode, Document.createEvent, Document.createRange, Document.createNodeIterator, Document.createTreeWalker, Document.createCDATASection, Document.createAttribute, Document.createAttributeNS, Document.getElementsByName, Document.open, Document.close, Document.write, Document.writeln, Document.hasFocus, Document.execCommand, Document.queryCommandEnabled, Document.queryCommandIndeterm, Document.queryCommandState, Document.queryCommandSupported, Document.queryCommandValue, Document.releaseCapture, Document.mozSetImageElement, Document.clear, Document.captureEvents, Document.releaseEvents, Document.exitFullscreen, Document.mozCancelFullScreen, Document.exitPointerLock, Document.enableStyleSheetsForSet, Document.caretPositionFromPoint, Document.querySelector, Document.querySelectorAll, Document.getSelection, Document.hasStorageAccess, Document.requestStorageAccess, Document.elementFromPoint, Document.elementsFromPoint, Document.getAnimations, Document.prepend, Document.append, Document.replaceChildren, Document.createExpression, Document.createNSResolver, Document.evaluate, Document.implementation, Document.URL, Document.documentURI, Document.compatMode, Document.characterSet, Document.charset, Document.inputEncoding, Document.contentType, Document.doctype, Document.documentElement, Document.domain, Document.referrer, Document.cookie, Document.lastModified, Document.readyState, Document.title, Document.dir, Document.body, Document.head, Document.images, Document.embeds, Document.plugins, Document.links, Document.forms, Document.scripts, Document.defaultView, Document.designMode, Document.onreadystatechange, Document.onbeforescriptexecute, Document.onafterscriptexecute, Document.currentScript, Document.fgColor, Document.linkColor, Document.vlinkColor, Document.alinkColor, Document.bgColor, Document.anchors, Document.applets, Document.all, Document.fullscreen, Document.mozFullScreen, Document.fullscreenEnabled, Document.mozFullScreenEnabled, Document.onfullscreenchange, Document.onfullscreenerror, Document.onpointerlockchange, Document.onpointerlockerror, Document.hidden, Document.visibilityState, Document.onvisibilitychange, Document.selectedStyleSheetSet, Document.lastStyleSheetSet, Document.preferredStyleSheetSet, Document.styleSheetSets, Document.scrollingElement, Document.timeline, Document.rootElement, Document.activeElement, Document.styleSheets, Document.pointerLockElement, Document.fullscreenElement, Document.mozFullScreenElement, Document.adoptedStyleSheets, Document.fonts, Document.onabort, Document.onblur, Document.onfocus, Document.onauxclick, Document.onbeforeinput, Document.oncanplay, Document.oncanplaythrough, Document.onchange, Document.onclick, Document.onclose, Document.oncontextmenu, Document.oncopy, Document.oncuechange, Document.oncut, Document.ondblclick, Document.ondrag, Document.ondragend, Document.ondragenter, Document.ondragexit, Document.ondragleave, Document.ondragover, Document.ondragstart, Document.ondrop, Document.ondurationchange, Document.onemptied, Document.onended, Document.onformdata, Document.oninput, Document.oninvalid, Document.onkeydown, Document.onkeypress, Document.onkeyup, Document.onload, Document.onloadeddata, Document.onloadedmetadata, Document.onloadstart, Document.onmousedown, Document.onmouseenter, Document.onmouseleave, Document.onmousemove, Document.onmouseout, Document.onmouseover, Document.onmouseup, Document.onwheel, Document.onpaste, Document.onpause, Document.onplay, Document.onplaying, Document.onprogress, Document.onratechange, Document.onreset, Document.onresize, Document.onscroll, Document.onscrollend, Document.onsecuritypolicyviolation, Document.onseeked, Document.onseeking, Document.onselect, Document.onslotchange, Document.onstalled, Document.onsubmit, Document.onsuspend, Document.ontimeupdate, Document.onvolumechange, Document.onwaiting, Document.onselectstart, Document.onselectionchange, Document.ontoggle, Document.onpointercancel, Document.onpointerdown, Document.onpointerup, Document.onpointermove, Document.onpointerout, Document.onpointerover, Document.onpointerenter, Document.onpointerleave, Document.ongotpointercapture, Document.onlostpointercapture, Document.onmozfullscreenchange, Document.onmozfullscreenerror, Document.onanimationcancel, Document.onanimationend, Document.onanimationiteration, Document.onanimationstart, Document.ontransitioncancel, Document.ontransitionend, Document.ontransitionrun, Document.ontransitionstart, Document.onwebkitanimationend, Document.onwebkitanimationiteration, Document.onwebkitanimationstart, Document.onwebkittransitionend, Document.onerror, Document.children, Document.firstElementChild, Document.lastElementChild, Document.childElementCount, Element.getAttributeNames, Element.getAttribute, Element.getAttributeNS, Element.toggleAttribute, Element.setAttribute, Element.setAttributeNS, Element.removeAttribute, Element.removeAttributeNS, Element.hasAttribute, Element.hasAttributeNS, Element.hasAttributes, Element.closest, Element.matches, Element.webkitMatchesSelector, Element.getElementsByTagName, Element.getElementsByTagNameNS, Element.getElementsByClassName, Element.insertAdjacentElement, Element.insertAdjacentText, Element.mozMatchesSelector, Element.setPointerCapture, Element.releasePointerCapture, Element.hasPointerCapture, Element.setCapture, Element.releaseCapture, Element.getAttributeNode, Element.setAttributeNode, Element.removeAttributeNode, Element.getAttributeNodeNS, Element.setAttributeNodeNS, Element.getClientRects, Element.getBoundingClientRect, Element.checkVisibility, Element.scrollIntoView, Element.scroll, Element.scrollTo, Element.scrollBy, Element.insertAdjacentHTML, Element.querySelector, Element.querySelectorAll, Element.attachShadow, Element.requestFullscreen, Element.mozRequestFullScreen, Element.requestPointerLock, Element.animate, Element.getAnimations, Element.before, Element.after, Element.replaceWith, Element.remove, Element.prepend, Element.append, Element.replaceChildren, Element.namespaceURI, Element.prefix, Element.localName, Element.tagName, Element.id, Element.className, Element.classList, Element.part, Element.attributes, Element.scrollTop, Element.scrollLeft, Element.scrollWidth, Element.scrollHeight, Element.clientTop, Element.clientLeft, Element.clientWidth, Element.clientHeight, Element.scrollTopMax, Element.scrollLeftMax, Element.innerHTML, Element.outerHTML, Element.shadowRoot, Element.assignedSlot, Element.slot, Element.onfullscreenchange, Element.onfullscreenerror, Element.previousElementSibling, Element.nextElementSibling, Element.children, Element.firstElementChild, Element.lastElementChild, Element.childElementCount"
  }
}), it = K ? "Chrome" : de ? "Firefox" : "", vn = (e) => {
  const t = {
    76: ["Document.onsecuritypolicyviolation", "Promise.allSettled"],
    77: ["Document.onformdata", "Document.onpointerrawupdate"],
    78: ["Element.elementTiming"],
    79: ["Document.onanimationend", "Document.onanimationiteration", "Document.onanimationstart", "Document.ontransitionend"],
    80: ["!Document.registerElement", "!Element.createShadowRoot", "!Element.getDestinationInsertionPoints"],
    81: ["Document.onwebkitanimationend", "Document.onwebkitanimationiteration", "Document.onwebkitanimationstart", "Document.onwebkittransitionend", "Element.ariaAtomic", "Element.ariaAutoComplete", "Element.ariaBusy", "Element.ariaChecked", "Element.ariaColCount", "Element.ariaColIndex", "Element.ariaColSpan", "Element.ariaCurrent", "Element.ariaDisabled", "Element.ariaExpanded", "Element.ariaHasPopup", "Element.ariaHidden", "Element.ariaKeyShortcuts", "Element.ariaLabel", "Element.ariaLevel", "Element.ariaLive", "Element.ariaModal", "Element.ariaMultiLine", "Element.ariaMultiSelectable", "Element.ariaOrientation", "Element.ariaPlaceholder", "Element.ariaPosInSet", "Element.ariaPressed", "Element.ariaReadOnly", "Element.ariaRelevant", "Element.ariaRequired", "Element.ariaRoleDescription", "Element.ariaRowCount", "Element.ariaRowIndex", "Element.ariaRowSpan", "Element.ariaSelected", "Element.ariaSort", "Element.ariaValueMax", "Element.ariaValueMin", "Element.ariaValueNow", "Element.ariaValueText", "Intl.DisplayNames"],
    83: ["Element.ariaDescription", "Element.onbeforexrselect"],
    84: ["Document.getAnimations", "Document.timeline", "Element.ariaSetSize", "Element.getAnimations"],
    85: ["Promise.any", "String.replaceAll"],
    86: ["Document.fragmentDirective", "Document.replaceChildren", "Element.replaceChildren", "!Atomics.wake"],
    "87-89": ["Atomics.waitAsync", "Document.ontransitioncancel", "Document.ontransitionrun", "Document.ontransitionstart", "Intl.Segmenter"],
    90: ["Document.onbeforexrselect", "RegExp.hasIndices", "!Element.onbeforexrselect"],
    91: ["Element.getInnerHTML"],
    92: ["Array.at", "String.at"],
    93: ["Error.cause", "Object.hasOwn"],
    94: ["!Error.cause", "Object.hasOwn"],
    "95-96": ["WebAssembly.Exception", "WebAssembly.Tag"],
    "97-98": ["Array.findLast", "Array.findLastIndex", "Document.onslotchange"],
    "99-101": ["Intl.supportedValuesOf", "Document.oncontextlost", "Document.oncontextrestored"],
    102: ["Element.ariaInvalid", "Document.onbeforematch"],
    "103-106": ["Element.role"],
    "107-109": ["Element.ariaBrailleLabel", "Element.ariaBrailleRoleDescription"],
    110: ["Array.toReversed", "Array.toSorted", "Array.toSpliced", "Array.with"],
    111: ["String.isWellFormed", "String.toWellFormed", "Document.startViewTransition"],
    "112-113": ["RegExp.unicodeSets"],
    "114-115": ["JSON.rawJSON", "JSON.isRawJSON"]
  }, n = {
    76: ["backdrop-filter"],
    "77-80": ["overscroll-behavior-block", "overscroll-behavior-inline"],
    81: ["color-scheme", "image-orientation"],
    83: ["contain-intrinsic-size"],
    84: ["appearance", "ruby-position"],
    "85-86": ["content-visibility", "counter-set", "inherits", "initial-value", "page-orientation", "syntax"],
    87: ["ascent-override", "border-block", "border-block-color", "border-block-style", "border-block-width", "border-inline", "border-inline-color", "border-inline-style", "border-inline-width", "descent-override", "inset", "inset-block", "inset-block-end", "inset-block-start", "inset-inline", "inset-inline-end", "inset-inline-start", "line-gap-override", "margin-block", "margin-inline", "padding-block", "padding-inline", "text-decoration-thickness", "text-underline-offset"],
    88: ["aspect-ratio"],
    89: ["border-end-end-radius", "border-end-start-radius", "border-start-end-radius", "border-start-start-radius", "forced-color-adjust"],
    90: ["overflow-clip-margin"],
    91: ["additive-symbols", "fallback", "negative", "pad", "prefix", "range", "speak-as", "suffix", "symbols", "system"],
    92: ["size-adjust"],
    93: ["accent-color"],
    94: ["scrollbar-gutter"],
    "95-96": ["app-region", "contain-intrinsic-block-size", "contain-intrinsic-height", "contain-intrinsic-inline-size", "contain-intrinsic-width"],
    "97-98": ["font-synthesis-small-caps", "font-synthesis-style", "font-synthesis-weight", "font-synthesis"],
    "99-100": ["text-emphasis-color", "text-emphasis-position", "text-emphasis-style", "text-emphasis"],
    "101-103": ["font-palette", "base-palette", "override-colors"],
    104: ["object-view-box"],
    105: ["container-name", "container-type", "container"],
    "106-107": ["hyphenate-character"],
    108: ["hyphenate-character", "!orientation", "!max-zoom", "!min-zoom", "!user-zoom"],
    109: ["hyphenate-limit-chars", "math-depth", "math-shift", "math-style"],
    110: ["initial-letter"],
    "111-113": ["baseline-source", "font-variant-alternates", "view-transition-name"],
    "114-115": ["text-wrap", "white-space-collapse"]
  }, r = {
    80: ["CompressionStream", "DecompressionStream", "FeaturePolicy", "FragmentDirective", "PeriodicSyncManager", "VideoPlaybackQuality"],
    81: ["SubmitEvent", "XRHitTestResult", "XRHitTestSource", "XRRay", "XRTransientInputHitTestResult", "XRTransientInputHitTestSource"],
    83: ["BarcodeDetector", "XRDOMOverlayState", "XRSystem"],
    84: ["AnimationPlaybackEvent", "AnimationTimeline", "CSSAnimation", "CSSTransition", "DocumentTimeline", "FinalizationRegistry", "LayoutShiftAttribution", "ResizeObserverSize", "WakeLock", "WakeLockSentinel", "WeakRef", "XRLayer"],
    85: ["AggregateError", "CSSPropertyRule", "EventCounts", "XRAnchor", "XRAnchorSet"],
    86: ["RTCEncodedAudioFrame", "RTCEncodedVideoFrame"],
    87: ["CookieChangeEvent", "CookieStore", "CookieStoreManager", "Scheduling"],
    88: ["Scheduling", "!BarcodeDetector"],
    89: ["ReadableByteStreamController", "ReadableStreamBYOBReader", "ReadableStreamBYOBRequest", "ReadableStreamDefaultController", "XRWebGLBinding"],
    90: ["AbstractRange", "CustomStateSet", "NavigatorUAData", "XRCPUDepthInformation", "XRDepthInformation", "XRLightEstimate", "XRLightProbe", "XRWebGLDepthInformation"],
    91: ["CSSCounterStyleRule", "GravitySensor", "NavigatorManagedData"],
    92: ["CSSCounterStyleRule", "!SharedArrayBuffer"],
    93: ["WritableStreamDefaultController"],
    94: ["AudioData", "AudioDecoder", "AudioEncoder", "EncodedAudioChunk", "EncodedVideoChunk", "IdleDetector", "ImageDecoder", "ImageTrack", "ImageTrackList", "VideoColorSpace", "VideoDecoder", "VideoEncoder", "VideoFrame", "MediaStreamTrackGenerator", "MediaStreamTrackProcessor", "Profiler", "VirtualKeyboard", "DelegatedInkTrailPresenter", "Ink", "Scheduler", "TaskController", "TaskPriorityChangeEvent", "TaskSignal", "VirtualKeyboardGeometryChangeEvent"],
    "95-96": ["URLPattern"],
    "97-98": ["WebTransport", "WebTransportBidirectionalStream", "WebTransportDatagramDuplexStream", "WebTransportError"],
    99: ["CanvasFilter", "CSSLayerBlockRule", "CSSLayerStatementRule"],
    100: ["CSSMathClamp"],
    "101-104": ["CSSFontPaletteValuesRule"],
    "105-106": ["CSSContainerRule"],
    "107-108": ["XRCamera"],
    109: ["MathMLElement"],
    110: ["AudioSinkInfo"],
    "111-112": ["ViewTransition"],
    "113-115": ["ViewTransition", "!CanvasFilter"]
  }, i = {
    71: ["Promise.allSettled"],
    "72-73": ["Document.onformdata", "Element.part"],
    74: ["!Array.toSource", "!Boolean.toSource", "!Date.toSource", "!Error.toSource", "!Function.toSource", "!Intl.toSource", "!JSON.toSource", "!Math.toSource", "!Number.toSource", "!Object.toSource", "!RegExp.toSource", "!String.toSource", "!WebAssembly.toSource"],
    "75-76": ["Document.getAnimations", "Document.timeline", "Element.getAnimations", "Intl.Locale"],
    77: ["String.replaceAll"],
    78: ["Atomics.add", "Atomics.and", "Atomics.compareExchange", "Atomics.exchange", "Atomics.isLockFree", "Atomics.load", "Atomics.notify", "Atomics.or", "Atomics.store", "Atomics.sub", "Atomics.wait", "Atomics.wake", "Atomics.xor", "Document.replaceChildren", "Element.replaceChildren", "Intl.ListFormat", "RegExp.dotAll"],
    "79-84": ["Promise.any"],
    85: ["!Document.onshow", "Promise.any"],
    86: ["Intl.DisplayNames"],
    87: ["Document.onbeforeinput"],
    "88-89": ["RegExp.hasIndices"],
    "90-91": ["Array.at", "String.at"],
    92: ["Object.hasOwn"],
    "93-99": ["Intl.supportedValuesOf", "Document.onsecuritypolicyviolation", "Document.onslotchange"],
    100: ["WebAssembly.Tag", "WebAssembly.Exception"],
    "101-103": ["Document.adoptedStyleSheets"],
    "104-108": ["Array.findLast", "Array.findLastIndex"],
    "109-112": ["Document.onscrollend"]
  }, c = {
    71: ["-moz-column-span"],
    72: ["offset", "offset-anchor", "offset-distance", "offset-path", "offset-rotate", "rotate", "scale", "translate"],
    73: ["overscroll-behavior-block", "overscroll-behavior-inline"],
    "74-79": ["!-moz-stack-sizing", "text-underline-position"],
    "80-88": ["appearance"],
    "89-90": ["!-moz-outline-radius", "!-moz-outline-radius-bottomleft", "!-moz-outline-radius-bottomright", "!-moz-outline-radius-topleft", "!-moz-outline-radius-topright", "aspect-ratio"],
    91: ["tab-size"],
    "92-95": ["accent-color"],
    96: ["color-scheme"],
    97: ["print-color-adjust", "scrollbar-gutter", "d"],
    "98-101": ["hyphenate-character"],
    102: ["overflow-clip-margin"],
    "103-106": ["scroll-snap-stop"],
    "107-108": ["backdrop-filter", "font-palette", "contain-intrinsic-block-size", "contain-intrinsic-height", "contain-intrinsic-inline-size", "contain-intrinsic-width", "contain-intrinsic-size"],
    109: ["-webkit-clip-path"],
    110: ["container-type", "container-name", "page", "container"],
    111: ["font-synthesis-small-caps", "font-synthesis-style", "font-synthesis-weight"],
    112: ["font-synthesis-small-caps", "!-moz-image-region"]
  }, a = {
    // disregard: 'reportError','onsecuritypolicyviolation','onslotchange'
    71: ["MathMLElement", "!SVGZoomAndPan"],
    "72-73": ["!BatteryManager", "FormDataEvent", "Geolocation", "GeolocationCoordinates", "GeolocationPosition", "GeolocationPositionError", "!mozPaintCount"],
    74: ["FormDataEvent", "!uneval"],
    75: ["AnimationTimeline", "CSSAnimation", "CSSTransition", "DocumentTimeline", "SubmitEvent"],
    "76-77": ["AudioParamMap", "AudioWorklet", "AudioWorkletNode", "Worklet"],
    78: ["Atomics"],
    "79-81": ["AggregateError", "FinalizationRegistry"],
    82: ["MediaMetadata", "MediaSession", "Sanitizer"],
    83: ["MediaMetadata", "MediaSession", "!Sanitizer"],
    84: ["PerformancePaintTiming"],
    "85-86": ["PerformancePaintTiming", "!HTMLMenuItemElement", "!onshow"],
    87: ["onbeforeinput"],
    88: ["onbeforeinput", "!VisualViewport"],
    "89-92": ["!ondevicelight", "!ondeviceproximity", "!onuserproximity"],
    "93-95": ["ElementInternals"],
    96: ["Lock", "LockManager"],
    97: ["CSSLayerBlockRule", "CSSLayerStatementRule"],
    98: ["HTMLDialogElement"],
    99: ["NavigationPreloadManager"],
    "100-104": ["WritableStream"],
    "105-106": ["TextDecoderStream", "OffscreenCanvasRenderingContext2D", "OffscreenCanvas", "TextEncoderStream"],
    "107-109": ["CSSFontPaletteValuesRule"],
    110: ["CSSContainerRule"],
    111: ["FileSystemFileHandle", "FileSystemDirectoryHandle"],
    112: ["FileSystemFileHandle", "!U2F"]
  }, s = e == "Chrome", o = e == "Firefox";
  return {
    css: s ? n : o ? c : {},
    win: s ? r : o ? a : {},
    js: s ? t : o ? i : {}
  };
}, Dn = (e) => {
  const t = [
    "Object",
    "Function",
    "Boolean",
    "Symbol",
    "Error",
    "Number",
    "BigInt",
    "Math",
    "Date",
    "String",
    "RegExp",
    "Array",
    "Map",
    "Set",
    "WeakMap",
    "WeakSet",
    "Atomics",
    "JSON",
    "Promise",
    "Reflect",
    "Proxy",
    "Intl",
    "WebAssembly",
    "Document",
    "Element"
  ];
  try {
    return t.reduce((r, i) => {
      const c = ["name", "length", "constructor", "prototype", "arguments", "caller"], a = Object.keys(Object.getOwnPropertyDescriptors(e[i] || {})), s = Object.keys(Object.getOwnPropertyDescriptors((e[i] || {}).prototype || {})), m = [...new Set([...a, ...s].filter((d) => !c.includes(d)))].map((d) => `${i}.${d}`);
      return [...r, ...m];
    }, []);
  } catch (n) {
    return console.error(n), [];
  }
}, Ke = (e) => e.sort((t, n) => /\d+/.exec(t)[0] - /\d+/.exec(n)[0]).reverse(), Re = (e, t, n = 0) => {
  const r = Tn(), { version: i } = r[it] || {};
  if (!(e && t))
    return {};
  const [a, s] = t ? t.split("-") : [], o = s || a, m = +e > +o + n, d = +e < +a - n, u = m || d, l = !(+o == i && +e > i) && u, S = l ? Math.abs(e - (d ? a : o)) : 0;
  return { liedVersion: l, distance: S };
};
async function Cn({
  cssComputed: e,
  navigatorComputed: t,
  windowFeaturesComputed: n
}) {
  try {
    const r = $ || window;
    if (!e || !n) {
      Se({ test: "features", passed: !1 });
      return;
    }
    const i = Dn(r), { keys: c } = e.computedStyle || {}, { keys: a } = n || {}, { userAgentParsed: s } = t || {}, o = (_, G) => /\[native code\]/.test(_[G] + "") && "prototype" in _[G] && _[G].prototype.constructor.name === G, m = ({ context: _, allKeys: G, engineMap: j, checkNative: R = !1 } = {}) => {
      const B = new Set(G), V = /* @__PURE__ */ new Set(), Q = Object.keys(j || {}).reduce((ee, M) => {
        const O = j[M], q = O.length, Y = O.filter((x) => {
          if (x.charAt(0) == "!") {
            const z = x.slice(1);
            return !B.has(z) && V.add(x);
          }
          return B.has(x) && (R ? o(_, x) : !0) && V.add(x);
        }).length;
        return q == Y ? [...ee, M] : ee;
      }, []);
      return {
        version: Ke(Q)[0],
        features: V
      };
    }, {
      css: d,
      win: u,
      js: b
    } = vn(it), {
      version: l,
      features: S
    } = m({
      context: r,
      allKeys: c,
      engineMap: d
    }), {
      version: h,
      features: g
    } = m({
      context: r,
      allKeys: a,
      engineMap: u,
      checkNative: !0
    }), {
      version: y,
      features: p
    } = m({
      context: r,
      allKeys: i,
      engineMap: b
    }), k = (_, G) => {
      const j = G.find((Q) => Q && !/-/.test(Q));
      if (j)
        return j;
      const R = _.length, B = _[0], V = _[R - 1];
      return R ? R == 1 ? B : `${V}-${B}` : "";
    }, v = /* @__PURE__ */ new Set([
      l,
      h,
      y
    ]);
    v.delete(void 0);
    const I = Ke(
      [...v].reduce((_, G) => [..._, ...G.split("-")], [])
    ), E = k(I, [l, h, y]), f = (/\d+/.exec(s) || [])[0], {
      liedVersion: D,
      distance: A
    } = Re(f, l), {
      liedVersion: T,
      distance: N
    } = Re(f, y), {
      liedVersion: F,
      distance: L
    } = Re(f, h);
    return D && (U("userAgent", `v${f} failed v${l} CSS features`), A > 1 && H(
      "Navigator.userAgent",
      `v${f} failed CSS features by ${A} versions`
    )), T && (U("userAgent", `v${f} failed v${y} JS features`), N > 2 && H(
      "Navigator.userAgent",
      `v${f} failed JS features by ${N} versions`
    )), F && (U("userAgent", `v${f} failed v${h} Window features`), L > 3 && H(
      "Navigator.userAgent",
      `v${f} failed Window features by ${L} versions`
    )), {
      versionRange: I,
      version: E,
      cssVersion: l,
      windowVersion: h,
      jsVersion: y,
      cssFeatures: [...S],
      windowFeatures: [...g],
      jsFeatures: [...p],
      jsFeaturesKeys: i
    };
  } catch (r) {
    W(r);
    return;
  }
}
var J = /* @__PURE__ */ ((e) => (e.WINDOWS = "Windows", e.MAC = "Mac", e.LINUX = "Linux", e.ANDROID = "Android", e.CHROME_OS = "Chrome OS", e))(J || {});
const Rn = [
  "caption",
  "icon",
  "menu",
  "message-box",
  "small-caption",
  "status-bar"
];
function Nn() {
  var D;
  if (!K) return [];
  const e = "getVideoPlaybackQuality" in HTMLVideoElement.prototype, t = CSS.supports("color-scheme: initial"), n = CSS.supports("appearance: initial"), r = "DisplayNames" in Intl, i = CSS.supports("aspect-ratio: initial"), c = CSS.supports("border-end-end-radius: initial"), a = "randomUUID" in Crypto.prototype, s = "BarcodeDetector" in window, o = "downlinkMax" in (((D = window.NetworkInformation) == null ? void 0 : D.prototype) || {}), m = "ContentIndex" in window, d = "ContactsManager" in window, u = "EyeDropper" in window, b = "FileSystemWritableFileStream" in window, l = "HID" in window && "HIDDevice" in window, S = "SerialPort" in window && "Serial" in window, h = "SharedWorker" in window, g = "ontouchstart" in Window && "TouchEvent" in window, y = "setAppBadge" in Navigator.prototype, p = (A, T) => A ? [T] : [], k = {
    [J.ANDROID]: [
      ...p(i, s),
      ...p(n, m),
      ...p(e, d),
      o,
      ...p(a, !u),
      ...p(r, !b),
      ...p(c, !l),
      ...p(c, !S),
      !h,
      g,
      ...p(t, !y)
    ],
    [J.CHROME_OS]: [
      ...p(i, s),
      ...p(n, !m),
      ...p(e, !d),
      o,
      ...p(a, u),
      ...p(r, b),
      ...p(c, l),
      ...p(c, S),
      h,
      g || !g,
      ...p(t, !y)
    ],
    [J.WINDOWS]: [
      ...p(i, !s),
      ...p(n, !m),
      ...p(e, !d),
      !o,
      ...p(a, u),
      ...p(r, b),
      ...p(c, l),
      ...p(c, S),
      h,
      g || !g,
      ...p(t, y)
    ],
    [J.MAC]: [
      ...p(i, s),
      ...p(n, !m),
      ...p(e, !d),
      !o,
      ...p(a, u),
      ...p(r, b),
      ...p(c, l),
      ...p(c, S),
      h,
      !g,
      ...p(t, y)
    ],
    [J.LINUX]: [
      ...p(i, !s),
      ...p(n, !m),
      ...p(e, !d),
      !o,
      ...p(a, u),
      ...p(r, b),
      ...p(c, l),
      ...p(c, S),
      h,
      !g || !g,
      ...p(t, !y)
    ]
  }, v = {
    noContentIndex: n && !m,
    noContactsManager: e && !d,
    noDownlinkMax: !o
  }, I = Object.keys(k).reduce((A, T) => {
    const N = k[T], F = +(N.filter((L) => L).length / N.length).toFixed(2);
    return A[T] = F, A;
  }, {}), E = Object.keys(I).reduce((A, T) => I[A] > I[T] ? A : T), f = I[E];
  return [I, f, v];
}
const $e = {
  "-apple-system": J.MAC,
  "Segoe UI": J.WINDOWS,
  Tahoma: J.WINDOWS,
  "Yu Gothic UI": J.WINDOWS,
  "Microsoft JhengHei UI": J.WINDOWS,
  "Microsoft YaHei UI": J.WINDOWS,
  "Meiryo UI": J.WINDOWS,
  Cantarell: J.LINUX,
  Ubuntu: J.LINUX,
  Sans: J.LINUX,
  "sans-serif": J.LINUX,
  "Fira Sans": J.LINUX,
  Roboto: J.ANDROID
};
function xn() {
  const { body: e } = document, t = document.createElement("div");
  e.appendChild(t);
  try {
    const n = String(
      [
        ...Rn.reduce((i, c) => (t.setAttribute("style", `font: ${c} !important`), i.add(getComputedStyle(t).fontFamily)), /* @__PURE__ */ new Set())
      ]
    ), r = $e[n];
    return $e[n] ? `${n}:${r}` : n;
  } catch {
    return "";
  } finally {
    e.removeChild(t);
  }
}
async function In({
  webgl: e,
  workerScope: t
}) {
  var n;
  try {
    const r = Object.keys({ ...navigator.mimeTypes }), i = xn(), [c, a, s] = Nn(), o = {
      chromium: K,
      likeHeadless: {
        noChrome: K && !("chrome" in window),
        hasPermissionsBug: K && "permissions" in navigator && await (async () => (await navigator.permissions.query({ name: "notifications" })).state == "prompt" && "Notification" in window && Notification.permission === "denied")(),
        noPlugins: K && navigator.plugins.length === 0,
        noMimeTypes: K && r.length === 0,
        notificationIsDenied: K && "Notification" in window && Notification.permission == "denied",
        hasKnownBgColor: K && (() => {
          let p = me;
          if (me || (p = document.createElement("div"), document.body.appendChild(p)), !p) return !1;
          p.setAttribute("style", "background-color: ActiveText");
          const { backgroundColor: k } = getComputedStyle(p) || [];
          return me || document.body.removeChild(p), k === "rgb(255, 0, 0)";
        })(),
        prefersLightColor: matchMedia("(prefers-color-scheme: light)").matches,
        uaDataIsBlank: "userAgentData" in navigator && // @ts-expect-error if userAgentData is null
        (((n = navigator.userAgentData) == null ? void 0 : n.platform) === "" || // @ts-expect-error if userAgentData is null
        await navigator.userAgentData.getHighEntropyValues(["platform"]).platform === ""),
        pdfIsDisabled: "pdfViewerEnabled" in navigator && navigator.pdfViewerEnabled === !1,
        noTaskbar: screen.height === screen.availHeight && screen.width === screen.availWidth,
        hasVvpScreenRes: innerWidth === screen.width && outerHeight === screen.height || "visualViewport" in window && // @ts-expect-error if unsupported
        visualViewport.width === screen.width && visualViewport.height === screen.height,
        hasSwiftShader: /SwiftShader/.test(t == null ? void 0 : t.webglRenderer),
        noWebShare: K && CSS.supports("accent-color: initial") && (!("share" in navigator) || !("canShare" in navigator)),
        noContentIndex: !!(s != null && s.noContentIndex),
        noContactsManager: !!(s != null && s.noContactsManager),
        noDownlinkMax: !!(s != null && s.noDownlinkMax)
      },
      headless: {
        webDriverIsOn: CSS.supports("border-end-end-radius: initial") && navigator.webdriver === void 0 || !!navigator.webdriver || !!w["Navigator.webdriver"],
        hasHeadlessUA: /HeadlessChrome/.test(navigator.userAgent) || /HeadlessChrome/.test(navigator.appVersion),
        hasHeadlessWorkerUA: !!t && /HeadlessChrome/.test(t.userAgent)
      },
      stealth: {
        hasIframeProxy: (() => {
          try {
            const p = document.createElement("iframe");
            return p.srcdoc = rt, !!p.contentWindow;
          } catch {
            return !0;
          }
        })(),
        hasHighChromeIndex: (() => {
          const p = "chrome";
          return Object.keys(window).slice(-50).includes(p) && Object.getOwnPropertyNames(window).slice(-50).includes(p);
        })(),
        hasBadChromeRuntime: (() => {
          if (!("chrome" in window && "runtime" in chrome))
            return !1;
          try {
            return "prototype" in chrome.runtime.sendMessage || // @ts-expect-error if unsupported
            "prototype" in chrome.runtime.connect || (new chrome.runtime.sendMessage(), new chrome.runtime.connect()), !0;
          } catch (p) {
            return p.constructor.name != "TypeError";
          }
        })(),
        hasToStringProxy: !!w["Function.toString"],
        hasBadWebGL: (() => {
          const { UNMASKED_RENDERER_WEBGL: p } = (e == null ? void 0 : e.parameters) || {}, { webglRenderer: k } = t || {};
          return p && k && p !== k;
        })()
      }
    }, { likeHeadless: m, headless: d, stealth: u } = o, b = Object.keys(m), l = Object.keys(d), S = Object.keys(u), h = +(b.filter((p) => m[p]).length / b.length * 100).toFixed(0), g = +(l.filter((p) => d[p]).length / l.length * 100).toFixed(0), y = +(S.filter((p) => u[p]).length / S.length * 100).toFixed(0);
    return {
      ...o,
      likeHeadlessRating: h,
      headlessRating: g,
      stealthRating: y,
      systemFonts: i,
      platformEstimate: [c, a]
    };
  } catch (r) {
    W(r);
    return;
  }
}
async function Pn() {
  const e = (t) => {
    const r = [
      "Collator",
      "DateTimeFormat",
      "DisplayNames",
      "ListFormat",
      "NumberFormat",
      "PluralRules",
      "RelativeTimeFormat"
    ].reduce((i, c) => {
      try {
        const a = new t[c]();
        if (!a)
          return i;
        const { locale: s } = a.resolvedOptions() || {};
        return [...i, s];
      } catch {
        return i;
      }
    }, []);
    return [...new Set(r)];
  };
  try {
    const t = w["Intl.Collator.resolvedOptions"] || w["Intl.DateTimeFormat.resolvedOptions"] || w["Intl.DisplayNames.resolvedOptions"] || w["Intl.ListFormat.resolvedOptions"] || w["Intl.NumberFormat.resolvedOptions"] || w["Intl.PluralRules.resolvedOptions"] || w["Intl.RelativeTimeFormat.resolvedOptions"] || !1, n = se(() => new Intl.DateTimeFormat(void 0, {
      month: "long",
      timeZoneName: "long"
    }).format(9636444e5)), r = se(() => new Intl.DisplayNames(void 0, {
      type: "language"
    }).of("en-US")), i = se(() => new Intl.ListFormat(void 0, {
      style: "long",
      type: "disjunction"
    }).format(["0", "1"])), c = se(() => new Intl.NumberFormat(void 0, {
      notation: "compact",
      compactDisplay: "long"
    }).format(21e6)), a = se(() => new Intl.PluralRules().select(1)), s = se(() => new Intl.RelativeTimeFormat(void 0, {
      localeMatcher: "best fit",
      numeric: "auto",
      style: "long"
    }).format(1, "year")), o = e(Intl);
    return {
      dateTimeFormat: n,
      displayNames: r,
      listFormat: i,
      numberFormat: c,
      pluralRules: a,
      relativeTimeFormat: s,
      locale: "" + o,
      lied: t
    };
  } catch (t) {
    W(t);
    return;
  }
}
function Ln() {
  try {
    const e = [
      "acos",
      "acosh",
      "asin",
      "asinh",
      "atan",
      "atanh",
      "atan2",
      "cbrt",
      "cos",
      "cosh",
      "expm1",
      "exp",
      "hypot",
      "log",
      "log1p",
      "log10",
      "sin",
      "sinh",
      "sqrt",
      "tan",
      "tanh",
      "pow"
    ];
    let t = !1;
    e.forEach((a) => {
      w[`Math.${a}`] && (t = !0);
      const s = a == "cos" ? [1e308] : a == "acos" || a == "asin" || a == "atanh" ? [0.5] : a == "pow" || a == "atan2" ? [Math.PI, 2] : [Math.PI], o = Math[a](...s), m = Math[a](...s);
      (isNaN(o) && isNaN(m) ? !0 : o == m) || (t = !0, H(`Math.${a}`, "expected x and got y"));
    });
    const n = 0.123, r = 5860847362277284e23, i = [
      ["acos", [n], `acos(${n})`, 1.4474840516030247, NaN, NaN, 1.4474840516030245],
      ["acos", [Math.SQRT1_2], "acos(Math.SQRT1_2)", 0.7853981633974483, NaN, NaN, NaN],
      ["acosh", [1e308], "acosh(1e308)", 709.889355822726, NaN, NaN, NaN],
      ["acosh", [Math.PI], "acosh(Math.PI)", 1.811526272460853, NaN, NaN, NaN],
      ["acosh", [Math.SQRT2], "acosh(Math.SQRT2)", 0.881373587019543, NaN, NaN, 0.8813735870195432],
      ["asin", [n], `asin(${n})`, 0.12331227519187199, NaN, NaN, NaN],
      ["asinh", [1e300], "asinh(1e308)", 691.4686750787736, NaN, NaN, NaN],
      ["asinh", [Math.PI], "asinh(Math.PI)", 1.8622957433108482, NaN, NaN, NaN],
      ["atan", [2], "atan(2)", 1.1071487177940904, NaN, NaN, 1.1071487177940906],
      ["atan", [Math.PI], "atan(Math.PI)", 1.2626272556789115, NaN, NaN, NaN],
      ["atanh", [0.5], "atanh(0.5)", 0.5493061443340548, NaN, NaN, 0.5493061443340549],
      ["atan2", [1e-310, 2], "atan2(1e-310, 2)", 5e-311, NaN, NaN, NaN],
      ["atan2", [Math.PI, 2], "atan2(Math.PI)", 1.0038848218538872, NaN, NaN, NaN],
      ["cbrt", [100], "cbrt(100)", 4.641588833612779, NaN, NaN, NaN],
      ["cbrt", [Math.PI], "cbrt(Math.PI)", 1.4645918875615231, NaN, NaN, 1.4645918875615234],
      ["cos", [n], `cos(${n})`, 0.9924450321351935, NaN, NaN, NaN],
      ["cos", [Math.PI], "cos(Math.PI)", -1, NaN, NaN, NaN],
      ["cos", [r], `cos(${r})`, -0.10868049424995659, NaN, -0.9779661551196617, NaN],
      ["cos", [-1e308], "cos(-1e308)", -0.8913089376870335, NaN, 0.99970162388838, NaN],
      ["cos", [13 * Math.E], "cos(13*Math.E)", -0.7108118501064331, -0.7108118501064332, NaN, NaN],
      ["cos", [57 * Math.E], "cos(57*Math.E)", -0.536911695749024, -0.5369116957490239, NaN, NaN],
      ["cos", [21 * Math.LN2], "cos(21*Math.LN2)", -0.4067775970251724, -0.40677759702517235, -0.6534063185820197, NaN],
      ["cos", [51 * Math.LN2], "cos(51*Math.LN2)", -0.7017203400855446, -0.7017203400855445, NaN, NaN],
      ["cos", [21 * Math.LOG2E], "cos(21*Math.LOG2E)", 0.4362848063618998, 0.43628480636189976, NaN, NaN],
      ["cos", [25 * Math.SQRT2], "cos(25*Math.SQRT2)", -0.6982689820462377, -0.6982689820462376, NaN, NaN],
      ["cos", [50 * Math.SQRT1_2], "cos(50*Math.SQRT1_2)", -0.6982689820462377, -0.6982689820462376, NaN, NaN],
      ["cos", [21 * Math.SQRT1_2], "cos(21*Math.SQRT1_2)", -0.6534063185820198, NaN, NaN, NaN],
      ["cos", [17 * Math.LOG10E], "cos(17*Math.LOG10E)", 0.4537557425982784, 0.45375574259827833, NaN, NaN],
      ["cos", [2 * Math.LOG10E], "cos(2*Math.LOG10E)", 0.6459044007438142, NaN, 0.6459044007438141, NaN],
      ["cosh", [1], "cosh(1)", 1.5430806348152437, NaN, NaN, NaN],
      ["cosh", [Math.PI], "cosh(Math.PI)", 11.591953275521519, NaN, NaN, NaN],
      ["cosh", [492 * Math.LOG2E], "cosh(492*Math.LOG2E)", 9199870313877772e292, 9199870313877774e292, NaN, NaN],
      ["cosh", [502 * Math.SQRT2], "cosh(502*Math.SQRT2)", 10469199669023138e292, 1046919966902314e293, NaN, NaN],
      ["expm1", [1], "expm1(1)", 1.718281828459045, NaN, NaN, 1.7182818284590453],
      ["expm1", [Math.PI], "expm1(Math.PI)", 22.140692632779267, NaN, NaN, NaN],
      ["exp", [n], `exp(${n})`, 1.1308844209474893, NaN, NaN, NaN],
      ["exp", [Math.PI], "exp(Math.PI)", 23.140692632779267, NaN, NaN, NaN],
      ["hypot", [1, 2, 3, 4, 5, 6], "hypot(1, 2, 3, 4, 5, 6)", 9.539392014169456, NaN, NaN, NaN],
      ["hypot", [r, r], `hypot(${r}, ${r})`, 8288489826731116e23, 8288489826731114e23, NaN, NaN],
      ["hypot", [2 * Math.E, -100], "hypot(2*Math.E, -100)", 100.14767208675259, 100.14767208675258, NaN, NaN],
      ["hypot", [6 * Math.PI, -100], "hypot(6*Math.PI, -100)", 101.76102278593319, 101.7610227859332, NaN, NaN],
      ["hypot", [2 * Math.LN2, -100], "hypot(2*Math.LN2, -100)", 100.0096085986525, 100.00960859865252, NaN, NaN],
      ["hypot", [Math.LOG2E, -100], "hypot(Math.LOG2E, -100)", 100.01040630344929, 100.01040630344927, NaN, NaN],
      ["hypot", [Math.SQRT2, -100], "hypot(Math.SQRT2, -100)", 100.00999950004999, 100.00999950005, NaN, NaN],
      ["hypot", [Math.SQRT1_2, -100], "hypot(Math.SQRT1_2, -100)", 100.0024999687508, 100.00249996875078, NaN, NaN],
      ["hypot", [2 * Math.LOG10E, -100], "hypot(2*Math.LOG10E, -100)", 100.00377216279416, 100.00377216279418, NaN, NaN],
      ["log", [n], `log(${n})`, -2.0955709236097197, NaN, NaN, NaN],
      ["log", [Math.PI], "log(Math.PI)", 1.1447298858494002, NaN, NaN, NaN],
      ["log1p", [n], `log1p(${n})`, 0.11600367575630613, NaN, NaN, NaN],
      ["log1p", [Math.PI], "log1p(Math.PI)", 1.4210804127942926, NaN, NaN, NaN],
      ["log10", [n], `log10(${n})`, -0.9100948885606021, NaN, NaN, NaN],
      ["log10", [Math.PI], "log10(Math.PI)", 0.4971498726941338, 0.49714987269413385, NaN, NaN],
      ["log10", [Math.E], "log10(Math.E)", 0.4342944819032518, NaN, NaN, NaN],
      ["log10", [34 * Math.E], "log10(34*Math.E)", 1.9657733989455068, 1.965773398945507, NaN, NaN],
      ["log10", [Math.LN2], "log10(Math.LN2)", -0.1591745389548616, NaN, NaN, NaN],
      ["log10", [11 * Math.LN2], "log10(11*Math.LN2)", 0.8822181462033634, 0.8822181462033635, NaN, NaN],
      ["log10", [Math.LOG2E], "log10(Math.LOG2E)", 0.15917453895486158, NaN, NaN, NaN],
      ["log10", [43 * Math.LOG2E], "log10(43*Math.LOG2E)", 1.792642994534448, 1.7926429945344482, NaN, NaN],
      ["log10", [Math.LOG10E], "log10(Math.LOG10E)", -0.36221568869946325, NaN, NaN, NaN],
      ["log10", [7 * Math.LOG10E], "log10(7*Math.LOG10E)", 0.4828823513147936, 0.48288235131479357, NaN, NaN],
      ["log10", [Math.SQRT1_2], "log10(Math.SQRT1_2)", -0.15051499783199057, NaN, NaN, NaN],
      ["log10", [2 * Math.SQRT1_2], "log10(2*Math.SQRT1_2)", 0.1505149978319906, 0.15051499783199063, NaN, NaN],
      ["log10", [Math.SQRT2], "log10(Math.SQRT2)", 0.1505149978319906, 0.15051499783199063, NaN, NaN],
      ["sin", [r], `sin(${r})`, 0.994076732536068, NaN, -0.20876350121720488, NaN],
      ["sin", [Math.PI], "sin(Math.PI)", 12246467991473532e-32, NaN, 12246063538223773e-32, NaN],
      ["sin", [39 * Math.E], "sin(39*Math.E)", -0.7181630308570677, -0.7181630308570678, NaN, NaN],
      ["sin", [35 * Math.LN2], "sin(35*Math.LN2)", -0.7659964138980511, -0.765996413898051, NaN, NaN],
      ["sin", [110 * Math.LOG2E], "sin(110*Math.LOG2E)", 0.9989410140273756, 0.9989410140273757, NaN, NaN],
      ["sin", [7 * Math.LOG10E], "sin(7*Math.LOG10E)", 0.10135692924965616, 0.10135692924965614, NaN, NaN],
      ["sin", [35 * Math.SQRT1_2], "sin(35*Math.SQRT1_2)", -0.3746357547858202, -0.37463575478582023, NaN, NaN],
      ["sin", [21 * Math.SQRT2], "sin(21*Math.SQRT2)", -0.9892668187780498, -0.9892668187780497, NaN, NaN],
      ["sinh", [1], "sinh(1)", 1.1752011936438014, NaN, NaN, NaN],
      ["sinh", [Math.PI], "sinh(Math.PI)", 11.548739357257748, NaN, NaN, 11.548739357257746],
      ["sinh", [Math.E], "sinh(Math.E)", 7.544137102816975, NaN, NaN, NaN],
      ["sinh", [Math.LN2], "sinh(Math.LN2)", 0.75, NaN, NaN, NaN],
      ["sinh", [Math.LOG2E], "sinh(Math.LOG2E)", 1.9978980091062795, NaN, NaN, NaN],
      ["sinh", [492 * Math.LOG2E], "sinh(492*Math.LOG2E)", 9199870313877772e292, 9199870313877774e292, NaN, NaN],
      ["sinh", [Math.LOG10E], "sinh(Math.LOG10E)", 0.44807597941469024, NaN, NaN, NaN],
      ["sinh", [Math.SQRT1_2], "sinh(Math.SQRT1_2)", 0.7675231451261164, NaN, NaN, NaN],
      ["sinh", [Math.SQRT2], "sinh(Math.SQRT2)", 1.935066822174357, NaN, NaN, 1.9350668221743568],
      ["sinh", [502 * Math.SQRT2], "sinh(502*Math.SQRT2)", 10469199669023138e292, 1046919966902314e293, NaN, NaN],
      ["sqrt", [n], `sqrt(${n})`, 0.3507135583350036, NaN, NaN, NaN],
      ["sqrt", [Math.PI], "sqrt(Math.PI)", 1.7724538509055159, NaN, NaN, NaN],
      ["tan", [-1e308], "tan(-1e308)", 0.5086861259107568, NaN, NaN, 0.5086861259107567],
      ["tan", [Math.PI], "tan(Math.PI)", -12246467991473532e-32, NaN, NaN, NaN],
      ["tan", [6 * Math.E], "tan(6*Math.E)", 0.6866761546452431, 0.686676154645243, NaN, NaN],
      ["tan", [6 * Math.LN2], "tan(6*Math.LN2)", 1.6182817135715877, 1.618281713571588, NaN, 1.6182817135715875],
      ["tan", [10 * Math.LOG2E], "tan(10*Math.LOG2E)", -3.3537128705376014, -3.353712870537601, NaN, -3.353712870537602],
      ["tan", [17 * Math.SQRT2], "tan(17*Math.SQRT2)", -1.9222955461799982, -1.922295546179998, NaN, NaN],
      ["tan", [34 * Math.SQRT1_2], "tan(34*Math.SQRT1_2)", -1.9222955461799982, -1.922295546179998, NaN, NaN],
      ["tan", [10 * Math.LOG10E], "tan(10*Math.LOG10E)", 2.5824856130712432, 2.5824856130712437, NaN, NaN],
      ["tanh", [n], `tanh(${n})`, 0.12238344189440875, NaN, NaN, 0.12238344189440876],
      ["tanh", [Math.PI], "tanh(Math.PI)", 0.99627207622075, NaN, NaN, NaN],
      ["pow", [n, -100], `pow(${n}, -100)`, 1022089333584519e76, 10220893335845176e75, NaN, NaN],
      ["pow", [Math.PI, -100], "pow(Math.PI, -100)", 19275814160560204e-66, 19275814160560185e-66, NaN, 19275814160560206e-66],
      ["pow", [Math.E, -100], "pow(Math.E, -100)", 37200759760208555e-60, 3720075976020851e-59, NaN, NaN],
      ["pow", [Math.LN2, -100], "pow(Math.LN2, -100)", 8269017203802394, 8269017203802410, NaN, NaN],
      ["pow", [Math.LN10, -100], "pow(Math.LN10, -100)", 6003867926738829e-52, 6003867926738811e-52, NaN, NaN],
      ["pow", [Math.LOG2E, -100], "pow(Math.LOG2E, -100)", 120933355845501e-30, 12093335584550061e-32, NaN, NaN],
      ["pow", [Math.LOG10E, -100], "pow(Math.LOG10E, -100)", 16655929347585958e20, 1665592934758592e21, NaN, 16655929347585955e20],
      ["pow", [Math.SQRT1_2, -100], "pow(Math.SQRT1_2, -100)", 11258999068426162e-1, 11258999068426115e-1, NaN, NaN],
      ["pow", [Math.SQRT2, -100], "pow(Math.SQRT2, -100)", 8881784197001191e-31, 8881784197001154e-31, NaN, NaN],
      ["polyfill", [2e-3 ** -100], "polyfill pow(2e-3, -100)", 7888609052210102e254, 7888609052210126e254, NaN, NaN]
    ], c = {};
    return i.forEach((a) => {
      c[a[2]] = C(() => {
        const s = a[0] != "polyfill" ? Math[a[0]](...a[1]) : a[1], o = s == a[3], m = a[4] ? s == a[4] : !1, d = a[5] ? s == a[5] : !1, u = a[6] ? s == a[6] : !1;
        return { result: s, chrome: o, firefox: m, torBrowser: d, safari: u };
      });
    }), { data: c, lied: t };
  } catch (e) {
    W(e);
    return;
  }
}
const On = () => [
  'audio/ogg; codecs="vorbis"',
  "audio/mpeg",
  "audio/mpegurl",
  'audio/wav; codecs="1"',
  "audio/x-m4a",
  "audio/aac",
  'video/ogg; codecs="theora"',
  "video/quicktime",
  'video/mp4; codecs="avc1.42E01E"',
  'video/webm; codecs="vp8"',
  'video/webm; codecs="vp9"',
  "video/x-matroska"
].sort();
async function Bn() {
  const e = () => {
    try {
      const t = On(), n = document.createElement("video"), r = new Audio(), i = "MediaRecorder" in window;
      return t.reduce((a, s) => {
        const o = {
          mimeType: s,
          audioPlayType: r.canPlayType(s),
          videoPlayType: n.canPlayType(s),
          mediaSource: MediaSource.isTypeSupported(s),
          mediaRecorder: i ? MediaRecorder.isTypeSupported(s) : !1
        };
        return !o.audioPlayType && !o.videoPlayType && !o.mediaSource && !o.mediaRecorder || a.push(o), a;
      }, []);
    } catch {
      return;
    }
  };
  try {
    return { mimeTypes: e() };
  } catch (t) {
    W(t);
    return;
  }
}
const Fn = () => {
  const { ApplePaySession: e } = window;
  if (typeof (e == null ? void 0 : e.canMakePayments) != "function")
    return {
      aP: -1
    };
  try {
    return {
      aP: e.canMakePayments() ? 1 : 0
    };
  } catch (t) {
    return _n(t);
  }
};
function _n(e) {
  if (e instanceof Error) {
    if (e.name === "InvalidAccessError") {
      if (/\bfrom\b.*\binsecure\b/i.test(e.message))
        return {
          aP: -2
        };
      if (/\bdifferent\b.*\borigin\b.*top.level\b.*\bframe\b/i.test(e.message))
        return {
          aP: -3
        };
    }
    if (e.name === "SecurityError" && /\bthird.party iframes?.*\bnot.allowed\b/i.test(e.message))
      return {
        aP: -3
      };
  }
  throw e;
}
async function Gn(e) {
  try {
    let t = w["Navigator.appVersion"] || w["Navigator.deviceMemory"] || w["Navigator.doNotTrack"] || w["Navigator.hardwareConcurrency"] || w["Navigator.language"] || w["Navigator.languages"] || w["Navigator.maxTouchPoints"] || w["Navigator.oscpu"] || w["Navigator.platform"] || w["Navigator.userAgent"] || w["Navigator.vendor"] || w["Navigator.plugins"] || w["Navigator.mimeTypes"] || !1;
    const n = "chrome" in window ? navigator.userAgent.includes(navigator.appVersion) : !0, r = {
      platform: C(() => {
        const { platform: o } = navigator;
        return typeof o == "string" && ["win", "linux", "mac", "arm", "pike", "linux", "iphone", "ipad", "ipod", "android", "x11"].filter((u) => o.toLowerCase().includes(u))[0] || U("platform", `${o} is unusual`), ke !== We && (t = !0, H(
          "Navigator.platform",
          `${We} platform and ${ke} user agent do not match`
        )), o;
      }),
      system: C(() => Ve(navigator.userAgent), "userAgent system failed"),
      userAgentParsed: await C(async () => {
        const o = se(() => navigator.userAgent), m = Ve(o), d = await et();
        return Ct({
          ua: o,
          os: m,
          isBrave: d
        });
      }),
      device: C(() => Rt({ userAgent: navigator.userAgent }), "userAgent device failed"),
      userAgent: C(() => {
        const { userAgent: o } = navigator;
        return n || U("userAgent", `${o} does not match appVersion`), /\s{2,}|^\s|\s$/g.test(o) && U("userAgent", "extra spaces detected"), Ae(o).length && U("userAgent is gibberish", o), o.trim().replace(/\s{2,}/, " ");
      }, "userAgent failed"),
      uaPostReduction: Nt((navigator || {}).userAgent),
      appVersion: C(() => {
        const { appVersion: o } = navigator;
        return n || U("appVersion", `${o} does not match userAgent`), "appVersion" in navigator && !o && U("appVersion", "Living Standard property returned falsy value"), /\s{2,}|^\s|\s$/g.test(o) && U("appVersion", "extra spaces detected"), o.trim().replace(/\s{2,}/, " ");
      }, "appVersion failed"),
      deviceMemory: C(() => {
        var b;
        if (!("deviceMemory" in navigator))
          return;
        const { deviceMemory: o } = navigator;
        ({
          "0.25": !0,
          "0.5": !0,
          1: !0,
          2: !0,
          4: !0,
          8: !0
        })[o] || U("deviceMemory", `${o} is not a valid value [0.25, 0.5, 1, 2, 4, 8]`);
        const d = ((b = performance == null ? void 0 : performance.memory) == null ? void 0 : b.jsHeapSizeLimit) || null, u = d ? +(d / 1073741824).toFixed(1) : 0;
        return u > o && U("deviceMemory", `available memory ${u}GB is greater than device memory ${o}GB`), o;
      }, "deviceMemory failed"),
      doNotTrack: C(() => {
        const { doNotTrack: o } = navigator;
        return {
          1: !0,
          true: !0,
          yes: !0,
          0: !0,
          false: !0,
          no: !0,
          unspecified: !0,
          null: !0,
          undefined: !0
        }[o] || U("doNotTrack - unusual result", o), o;
      }, "doNotTrack failed"),
      globalPrivacyControl: C(() => {
        if (!("globalPrivacyControl" in navigator))
          return;
        const { globalPrivacyControl: o } = navigator;
        return {
          1: !0,
          true: !0,
          yes: !0,
          0: !0,
          false: !0,
          no: !0,
          unspecified: !0,
          null: !0,
          undefined: !0
        }[o] || U("globalPrivacyControl - unusual result", o), o;
      }, "globalPrivacyControl failed"),
      hardwareConcurrency: C(() => {
        if (!("hardwareConcurrency" in navigator))
          return;
        const { hardwareConcurrency: o } = navigator;
        return o;
      }, "hardwareConcurrency failed"),
      language: C(() => {
        const { language: o, languages: m } = navigator;
        if (o && m) {
          const d = /^.{0,2}/g.exec(o)[0];
          return /^.{0,2}/g.exec(m[0])[0] != d && U("language/languages", `${[o, m].join(" ")} mismatch`), `${m.join(", ")} (${o})`;
        }
        return `${o} ${m}`;
      }, "language(s) failed"),
      maxTouchPoints: C(() => "maxTouchPoints" in navigator ? navigator.maxTouchPoints : null, "maxTouchPoints failed"),
      vendor: C(() => navigator.vendor, "vendor failed"),
      mimeTypes: C(() => {
        const { mimeTypes: o } = navigator;
        return o ? [...o].map((m) => m.type) : [];
      }, "mimeTypes failed"),
      // @ts-ignore
      oscpu: C(() => navigator.oscpu, "oscpu failed"),
      plugins: C(() => {
        const { plugins: o } = navigator;
        if (!(o instanceof PluginArray))
          return;
        const m = o ? [...o].map((u) => {
          const b = [];
          for (let l = 0; l < u.length; ++l) {
            const S = u[l];
            b.push({
              type: S.type,
              suffixes: S.suffixes
            });
          }
          return {
            name: u.name,
            description: u.description,
            filename: u.filename,
            mimeTypes: b
          };
        }) : [], { lies: d } = Yt(o, navigator.mimeTypes);
        return d.length && (t = !0, d.forEach((u) => H("Navigator.plugins", u))), m.length && m.forEach((u) => {
          const { name: b, description: l } = u, S = Ae(b), h = Ae(l);
          S.length && U("plugin name is gibberish", b), h.length && U("plugin description is gibberish", l);
        }), m;
      }, "plugins failed"),
      properties: C(() => Object.keys(Object.getPrototypeOf(navigator)), "navigator keys failed"),
      applePay: C(() => Fn(), "apple pay failed")
    }, i = () => C(() => {
      if (!(!navigator.userAgentData || // @ts-ignore
      !navigator.userAgentData.getHighEntropyValues))
        return navigator.userAgentData.getHighEntropyValues(
          ["platform", "platformVersion", "architecture", "bitness", "model", "uaFullVersion"]
        ).then((o) => {
          const { brands: m, mobile: d } = navigator.userAgentData || {}, u = (S, h = !1) => S.filter((g) => !/Not/.test(g.brand)).map((g) => `${g.brand}${h ? ` ${g.version}` : ""}`), b = (S) => S.length > 1 ? S.filter((h) => !/Chromium/.test(h)) : S;
          return o.brands || (o.brands = m), o.brandsVersion = u(o.brands, !0), o.brands = u(o.brands), o.brandsVersion = b(o.brandsVersion), o.brands = b(o.brands), o.mobile || (o.mobile = d), Object.keys(o).sort().reduce((S, h) => (S[h] = o[h], S), {});
        });
    }, "userAgentData failed"), c = () => C(() => {
      if (!(!("bluetooth" in navigator) || // @ts-ignore
      !navigator.bluetooth || // @ts-ignore
      !navigator.bluetooth.getAvailability))
        return navigator.bluetooth.getAvailability();
    }, "bluetoothAvailability failed"), a = () => C(() => {
      const o = (d) => navigator.permissions.query({ name: d }).then((u) => ({ name: d, state: u.state })).catch((u) => ({ name: d, state: "unknown" }));
      return "permissions" in navigator ? Promise.all([
        o("accelerometer"),
        o("ambient-light-sensor"),
        o("background-fetch"),
        o("background-sync"),
        o("bluetooth"),
        o("camera"),
        o("clipboard"),
        o("device-info"),
        o("display-capture"),
        o("gamepad"),
        o("geolocation"),
        o("gyroscope"),
        o("magnetometer"),
        o("microphone"),
        o("midi"),
        o("nfc"),
        o("notifications"),
        o("persistent-storage"),
        o("push"),
        o("screen-wake-lock"),
        o("speaker"),
        o("speaker-selection")
      ]).then((d) => d.reduce((u, b) => {
        const { state: l, name: S } = b || {};
        return u[l] ? (u[l].push(S), u) : (u[l] = [S], u);
      }, {})).catch((d) => console.error(d)) : void 0;
    }, "permissions failed"), s = () => C(() => {
      if ("gpu" in navigator)
        return navigator.gpu.requestAdapter().then((o) => {
          if (!o) return;
          const { limits: m = {}, features: d = [] } = o || {}, u = (l) => {
            const { architecture: S, description: h, device: g, vendor: y } = l, p = [y, S, h, g], k = [...d.values()], v = ((I) => {
              const E = {};
              for (const f in I)
                E[f] = I[f];
              return E;
            })(m);
            return ae.webGpuAdapter = p, ae.webGpuFeatures = Ee(k), ae.webGpuLimits = Ee(v), {
              adapterInfo: p,
              features: k,
              limits: v
            };
          }, { info: b } = o;
          return b ? u(b) : o.requestAdapterInfo().then(u);
        });
    }, "webgpu failed");
    return Promise.all([
      i(),
      c(),
      a(),
      s()
    ]).then(([
      o,
      m,
      d,
      u
    ]) => ({
      ...r,
      userAgentData: o,
      bluetoothAvailability: m,
      permissions: d,
      webgpu: u,
      lied: t
    })).catch((o) => (console.error(o), {
      ...r,
      lied: t
    }));
  } catch (t) {
    W(t, "Navigator failed or blocked by client");
    return;
  }
}
function Vn() {
  try {
    return "ontouchstart" in window && !!document.createEvent("TouchEvent");
  } catch {
    return !1;
  }
}
const Wn = () => {
  if (matchMedia("(dynamic-range: high)").matches)
    return !0;
  if (matchMedia("(dynamic-range: standard)").matches)
    return !1;
};
async function Hn(e = !0) {
  try {
    let t = w["Screen.width"] || w["Screen.height"] || w["Screen.availWidth"] || w["Screen.availHeight"] || w["Screen.colorDepth"] || w["Screen.pixelDepth"] || !1;
    const n = window.screen || {}, {
      width: r,
      height: i,
      availWidth: c,
      availHeight: a,
      colorDepth: s,
      pixelDepth: o
    } = n, m = window.devicePixelRatio || 0;
    de && m != 1 || !matchMedia(
      `(device-width: ${r}px) and (device-height: ${i}px)`
    ).matches && (t = !0, H("Screen", "failed matchMedia"));
    const u = !matchMedia(`(resolution: ${m}dppx)`).matches;
    !pe && u && (t = !0, H("Window.devicePixelRatio", "lied dpr"));
    const b = !(r - c || i - a);
    return r > 800 && b && (re.SCREEN = !0), {
      width: r,
      height: i,
      availWidth: c,
      availHeight: a,
      colorDepth: s,
      pixelDepth: o,
      touch: Vn(),
      hdr: Wn(),
      lied: t
    };
  } catch (t) {
    W(t);
    return;
  }
}
async function zn() {
  return await new Promise((e) => setTimeout(() => e(void 0), 50)), new Promise(async (e) => {
    try {
      const t = "speechSynthesis" in window;
      if (t && speechSynthesis.getVoices(), !t)
        return Se({ test: "speech", passed: !1 }), e(null);
      const n = !!w["SpeechSynthesis.getVoices"], r = setTimeout(() => (Se({ test: "speech", passed: !1 }), e(null)), 300), i = () => {
        const c = speechSynthesis.getVoices(), a = (c || []).find((g) => g.localService);
        if (!c || !c.length || K && !a)
          return;
        clearTimeout(r);
        const o = ((g, y) => g.filter((p) => {
          const { voiceURI: k } = p;
          return y.has(k) ? !1 : (y.add(k), !0);
        }))(c, /* @__PURE__ */ new Set()), m = o.filter((g) => g.localService).map((g) => g.name), d = o.filter((g) => !g.localService).map((g) => g.name), u = [...new Set(o.map((g) => g.lang))], b = o.filter((g) => g.default && g.localService);
        let l = "", S = "";
        if (b.length === 1) {
          const { name: g, lang: y } = b[0];
          l = g, S = (y || "").replace(/_/, "-");
        }
        const { locale: h } = Intl.DateTimeFormat().resolvedOptions();
        return S && S.split("-")[0] !== h.split("-")[0] && (ae.voiceLangMismatch = !0, re.TIME_ZONE = !0), e({
          local: m,
          remote: d,
          languages: u,
          defaultVoiceName: l,
          defaultVoiceLang: S,
          lied: n
        });
      };
      if (i(), speechSynthesis.addEventListener)
        return speechSynthesis.addEventListener("voiceschanged", i);
      speechSynthesis.onvoiceschanged = i;
    } catch (t) {
      return W(t), e(null);
    }
  });
}
const qe = 1073741824;
function Un() {
  const e = () => {
    try {
      return 1 + e();
    } catch {
      return 1;
    }
  };
  return [...Array(10)].forEach(() => e()), e();
}
function jn() {
  let t = 1, n = 1, r;
  for (let i = 0; i < 5e3; i++) {
    const c = performance.now(), a = performance.now();
    c < a && (r = a - c, r > t && r < n ? n = r : r < t && (n = t, t = r));
  }
  return [t, n];
}
async function Xn() {
  return "getBattery" in navigator ? navigator.getBattery() : null;
}
async function Ie() {
  var e;
  return (e = navigator == null ? void 0 : navigator.storage) != null && e.estimate ? Promise.all([
    navigator.storage.estimate().then(({ quota: t }) => t),
    new Promise((t) => {
      navigator.webkitTemporaryStorage.queryUsageAndQuota((n, r) => {
        t(r);
      });
    }).catch(() => null)
  ]).then(([t, n]) => n || t) : null;
}
async function Kn() {
  var p;
  const [
    e,
    t,
    n,
    r,
    i
  ] = await Promise.all([
    Xn(),
    Ie(),
    Ie(),
    Un(),
    jn()
  ]), {
    charging: c,
    chargingTime: a,
    dischargingTime: s,
    level: o
  } = e || {}, m = ((p = performance == null ? void 0 : performance.memory) == null ? void 0 : p.jsHeapSizeLimit) || null, d = m ? +(m / qe).toFixed(2) : null, u = t ? +(+t / qe).toFixed(2) : null, {
    downlink: b,
    effectiveType: l,
    rtt: S,
    saveData: h,
    downlinkMax: g,
    type: y
    // @ts-expect-error if not supported
  } = (navigator == null ? void 0 : navigator.connection) || {};
  return [
    ...document.querySelectorAll("script")
  ].map((k) => k.src.replace(/^https?:\/\//, "")).slice(0, 10), {
    charging: c,
    chargingTime: a,
    dischargingTime: s,
    level: o,
    memory: m,
    memoryInGigabytes: d,
    quota: t,
    quotaIsInsecure: t !== n,
    quotaInGigabytes: u,
    downlink: b,
    effectiveType: l,
    rtt: S,
    saveData: h,
    downlinkMax: g,
    type: y,
    stackSize: r,
    timingRes: i
  };
}
async function $n() {
  try {
    let e = w["SVGRect.height"] || w["SVGRect.width"] || w["SVGRect.x"] || w["SVGRect.y"] || w["String.fromCodePoint"] || w["SVGRectElement.getBBox"] || w["SVGTextContentElement.getExtentOfChar"] || w["SVGTextContentElement.getSubStringLength"] || w["SVGTextContentElement.getComputedTextLength"] || !1;
    const t = $ && $.document && $.document.body ? $.document : document, n = document.createElement("div");
    t.body.appendChild(n), Be(n, Fe`
			<div id="svg-container">
				<style>
				#svg-container {
					position: absolute;
					left: -9999px;
					height: auto;
				}
				#svg-container .shift-svg {
					transform: scale(1.000999) !important;
				}
				.svgrect-emoji {
					font-family: ${ce};
					font-size: 200px !important;
					height: auto;
					position: absolute !important;
					transform: scale(1.000999);
				}
				</style>
				<svg>
					<g id="svgBox">
						${le.map((y) => `<text x="32" y="32" class="svgrect-emoji">${y}</text>`).join("")}
					</g>
				</svg>
			</div>
		`);
    const r = (y) => Object.keys(y.__proto__).reduce((k, v) => {
      const I = y[v];
      return typeof I == "function" ? k : { ...k, [v]: I };
    }, {}), i = (y) => Object.keys(y.__proto__).reduce((k, v) => {
      const I = y[v];
      return isNaN(I) ? k : k += I;
    }, 0), c = (y) => y ? Object.keys(y).reduce((p, k) => p += Math.abs(y[k]), 0) : 0, a = t.getElementById("svgBox"), s = r(a.getBBox()), o = /* @__PURE__ */ new Set(), m = [...a.getElementsByClassName("svgrect-emoji")], d = m.reduce((y, p, k) => {
      const v = le[k], I = "" + p.getComputedTextLength();
      return o.has(I) || (o.add(I), y.add(v)), y;
    }, /* @__PURE__ */ new Set()), u = 1e-5 * [...o].map((y) => y.split(",").reduce((p, k) => p += +k || 0, 0)).reduce((y, p) => y += p, 0), b = m[0], l = b.getComputedTextLength();
    b.classList.add("shift-svg");
    const S = b.getComputedTextLength();
    b.classList.remove("shift-svg");
    const h = b.getComputedTextLength();
    l - S != h - S && (e = !0, H("SVGTextContentElement.getComputedTextLength", "failed unshift calculation"));
    const g = {
      bBox: c(s),
      extentOfChar: i(m[0].getExtentOfChar(le[0])),
      subStringLength: m[0].getSubStringLength(0, 10),
      computedTextLength: m[0].getComputedTextLength(),
      emojiSet: [...d],
      svgrectSystemSum: u,
      lied: e
    };
    return t.body.removeChild(t.getElementById("svg-container")), g;
  } catch (e) {
    W(e);
    return;
  }
}
function qn() {
  const e = [
    "UTC",
    "GMT",
    "Etc/GMT+0",
    "Etc/GMT+1",
    "Etc/GMT+10",
    "Etc/GMT+11",
    "Etc/GMT+12",
    "Etc/GMT+2",
    "Etc/GMT+3",
    "Etc/GMT+4",
    "Etc/GMT+5",
    "Etc/GMT+6",
    "Etc/GMT+7",
    "Etc/GMT+8",
    "Etc/GMT+9",
    "Etc/GMT-1",
    "Etc/GMT-10",
    "Etc/GMT-11",
    "Etc/GMT-12",
    "Etc/GMT-13",
    "Etc/GMT-14",
    "Etc/GMT-2",
    "Etc/GMT-3",
    "Etc/GMT-4",
    "Etc/GMT-5",
    "Etc/GMT-6",
    "Etc/GMT-7",
    "Etc/GMT-8",
    "Etc/GMT-9",
    "Etc/GMT",
    "Africa/Abidjan",
    "Africa/Accra",
    "Africa/Addis_Ababa",
    "Africa/Algiers",
    "Africa/Asmara",
    "Africa/Bamako",
    "Africa/Bangui",
    "Africa/Banjul",
    "Africa/Bissau",
    "Africa/Blantyre",
    "Africa/Brazzaville",
    "Africa/Bujumbura",
    "Africa/Cairo",
    "Africa/Casablanca",
    "Africa/Ceuta",
    "Africa/Conakry",
    "Africa/Dakar",
    "Africa/Dar_es_Salaam",
    "Africa/Djibouti",
    "Africa/Douala",
    "Africa/El_Aaiun",
    "Africa/Freetown",
    "Africa/Gaborone",
    "Africa/Harare",
    "Africa/Johannesburg",
    "Africa/Juba",
    "Africa/Kampala",
    "Africa/Khartoum",
    "Africa/Kigali",
    "Africa/Kinshasa",
    "Africa/Lagos",
    "Africa/Libreville",
    "Africa/Lome",
    "Africa/Luanda",
    "Africa/Lubumbashi",
    "Africa/Lusaka",
    "Africa/Malabo",
    "Africa/Maputo",
    "Africa/Maseru",
    "Africa/Mbabane",
    "Africa/Mogadishu",
    "Africa/Monrovia",
    "Africa/Nairobi",
    "Africa/Ndjamena",
    "Africa/Niamey",
    "Africa/Nouakchott",
    "Africa/Ouagadougou",
    "Africa/Porto-Novo",
    "Africa/Sao_Tome",
    "Africa/Tripoli",
    "Africa/Tunis",
    "Africa/Windhoek",
    "America/Adak",
    "America/Anchorage",
    "America/Anguilla",
    "America/Antigua",
    "America/Araguaina",
    "America/Argentina/Buenos_Aires",
    "America/Argentina/Catamarca",
    "America/Argentina/Cordoba",
    "America/Argentina/Jujuy",
    "America/Argentina/La_Rioja",
    "America/Argentina/Mendoza",
    "America/Argentina/Rio_Gallegos",
    "America/Argentina/Salta",
    "America/Argentina/San_Juan",
    "America/Argentina/San_Luis",
    "America/Argentina/Tucuman",
    "America/Argentina/Ushuaia",
    "America/Aruba",
    "America/Asuncion",
    "America/Atikokan",
    "America/Bahia",
    "America/Bahia_Banderas",
    "America/Barbados",
    "America/Belem",
    "America/Belize",
    "America/Blanc-Sablon",
    "America/Boa_Vista",
    "America/Bogota",
    "America/Boise",
    "America/Cambridge_Bay",
    "America/Campo_Grande",
    "America/Cancun",
    "America/Caracas",
    "America/Cayenne",
    "America/Cayman",
    "America/Chicago",
    "America/Chihuahua",
    "America/Costa_Rica",
    "America/Creston",
    "America/Cuiaba",
    "America/Curacao",
    "America/Danmarkshavn",
    "America/Dawson",
    "America/Dawson_Creek",
    "America/Denver",
    "America/Detroit",
    "America/Dominica",
    "America/Edmonton",
    "America/Eirunepe",
    "America/El_Salvador",
    "America/Fort_Nelson",
    "America/Fortaleza",
    "America/Glace_Bay",
    "America/Godthab",
    "America/Goose_Bay",
    "America/Grand_Turk",
    "America/Grenada",
    "America/Guadeloupe",
    "America/Guatemala",
    "America/Guayaquil",
    "America/Guyana",
    "America/Halifax",
    "America/Havana",
    "America/Hermosillo",
    "America/Indiana/Indianapolis",
    "America/Indiana/Knox",
    "America/Indiana/Marengo",
    "America/Indiana/Petersburg",
    "America/Indiana/Tell_City",
    "America/Indiana/Vevay",
    "America/Indiana/Vincennes",
    "America/Indiana/Winamac",
    "America/Inuvik",
    "America/Iqaluit",
    "America/Jamaica",
    "America/Juneau",
    "America/Kentucky/Louisville",
    "America/Kentucky/Monticello",
    "America/Kralendijk",
    "America/La_Paz",
    "America/Lima",
    "America/Los_Angeles",
    "America/Lower_Princes",
    "America/Maceio",
    "America/Managua",
    "America/Manaus",
    "America/Marigot",
    "America/Martinique",
    "America/Matamoros",
    "America/Mazatlan",
    "America/Menominee",
    "America/Merida",
    "America/Metlakatla",
    "America/Mexico_City",
    "America/Miquelon",
    "America/Moncton",
    "America/Monterrey",
    "America/Montevideo",
    "America/Montserrat",
    "America/Nassau",
    "America/New_York",
    "America/Nipigon",
    "America/Nome",
    "America/Noronha",
    "America/North_Dakota/Beulah",
    "America/North_Dakota/Center",
    "America/North_Dakota/New_Salem",
    "America/Ojinaga",
    "America/Panama",
    "America/Pangnirtung",
    "America/Paramaribo",
    "America/Phoenix",
    "America/Port-au-Prince",
    "America/Port_of_Spain",
    "America/Porto_Velho",
    "America/Puerto_Rico",
    "America/Punta_Arenas",
    "America/Rainy_River",
    "America/Rankin_Inlet",
    "America/Recife",
    "America/Regina",
    "America/Resolute",
    "America/Rio_Branco",
    "America/Santarem",
    "America/Santiago",
    "America/Santo_Domingo",
    "America/Sao_Paulo",
    "America/Scoresbysund",
    "America/Sitka",
    "America/St_Barthelemy",
    "America/St_Johns",
    "America/St_Kitts",
    "America/St_Lucia",
    "America/St_Thomas",
    "America/St_Vincent",
    "America/Swift_Current",
    "America/Tegucigalpa",
    "America/Thule",
    "America/Thunder_Bay",
    "America/Tijuana",
    "America/Toronto",
    "America/Tortola",
    "America/Vancouver",
    "America/Whitehorse",
    "America/Winnipeg",
    "America/Yakutat",
    "America/Yellowknife",
    "Antarctica/Casey",
    "Antarctica/Davis",
    "Antarctica/DumontDUrville",
    "Antarctica/Macquarie",
    "Antarctica/Mawson",
    "Antarctica/McMurdo",
    "Antarctica/Palmer",
    "Antarctica/Rothera",
    "Antarctica/Syowa",
    "Antarctica/Troll",
    "Antarctica/Vostok",
    "Arctic/Longyearbyen",
    "Asia/Aden",
    "Asia/Almaty",
    "Asia/Amman",
    "Asia/Anadyr",
    "Asia/Aqtau",
    "Asia/Aqtobe",
    "Asia/Ashgabat",
    "Asia/Atyrau",
    "Asia/Baghdad",
    "Asia/Bahrain",
    "Asia/Baku",
    "Asia/Bangkok",
    "Asia/Barnaul",
    "Asia/Beirut",
    "Asia/Bishkek",
    "Asia/Brunei",
    "Asia/Calcutta",
    "Asia/Chita",
    "Asia/Choibalsan",
    "Asia/Colombo",
    "Asia/Damascus",
    "Asia/Dhaka",
    "Asia/Dili",
    "Asia/Dubai",
    "Asia/Dushanbe",
    "Asia/Famagusta",
    "Asia/Gaza",
    "Asia/Hebron",
    "Asia/Ho_Chi_Minh",
    "Asia/Hong_Kong",
    "Asia/Hovd",
    "Asia/Irkutsk",
    "Asia/Jakarta",
    "Asia/Jayapura",
    "Asia/Jerusalem",
    "Asia/Kabul",
    "Asia/Kamchatka",
    "Asia/Karachi",
    "Asia/Kathmandu",
    "Asia/Khandyga",
    "Asia/Kolkata",
    "Asia/Krasnoyarsk",
    "Asia/Kuala_Lumpur",
    "Asia/Kuching",
    "Asia/Kuwait",
    "Asia/Macau",
    "Asia/Magadan",
    "Asia/Makassar",
    "Asia/Manila",
    "Asia/Muscat",
    "Asia/Nicosia",
    "Asia/Novokuznetsk",
    "Asia/Novosibirsk",
    "Asia/Omsk",
    "Asia/Oral",
    "Asia/Phnom_Penh",
    "Asia/Pontianak",
    "Asia/Pyongyang",
    "Asia/Qatar",
    "Asia/Qostanay",
    "Asia/Qyzylorda",
    "Asia/Riyadh",
    "Asia/Sakhalin",
    "Asia/Samarkand",
    "Asia/Seoul",
    "Asia/Shanghai",
    "Asia/Singapore",
    "Asia/Srednekolymsk",
    "Asia/Taipei",
    "Asia/Tashkent",
    "Asia/Tbilisi",
    "Asia/Tehran",
    "Asia/Thimphu",
    "Asia/Tokyo",
    "Asia/Tomsk",
    "Asia/Ulaanbaatar",
    "Asia/Urumqi",
    "Asia/Ust-Nera",
    "Asia/Vientiane",
    "Asia/Vladivostok",
    "Asia/Yakutsk",
    "Asia/Yangon",
    "Asia/Yekaterinburg",
    "Asia/Yerevan",
    "Atlantic/Azores",
    "Atlantic/Bermuda",
    "Atlantic/Canary",
    "Atlantic/Cape_Verde",
    "Atlantic/Faroe",
    "Atlantic/Madeira",
    "Atlantic/Reykjavik",
    "Atlantic/South_Georgia",
    "Atlantic/St_Helena",
    "Atlantic/Stanley",
    "Australia/Adelaide",
    "Australia/Brisbane",
    "Australia/Broken_Hill",
    "Australia/Currie",
    "Australia/Darwin",
    "Australia/Eucla",
    "Australia/Hobart",
    "Australia/Lindeman",
    "Australia/Lord_Howe",
    "Australia/Melbourne",
    "Australia/Perth",
    "Australia/Sydney",
    "Europe/Amsterdam",
    "Europe/Andorra",
    "Europe/Astrakhan",
    "Europe/Athens",
    "Europe/Belgrade",
    "Europe/Berlin",
    "Europe/Bratislava",
    "Europe/Brussels",
    "Europe/Bucharest",
    "Europe/Budapest",
    "Europe/Busingen",
    "Europe/Chisinau",
    "Europe/Copenhagen",
    "Europe/Dublin",
    "Europe/Gibraltar",
    "Europe/Guernsey",
    "Europe/Helsinki",
    "Europe/Isle_of_Man",
    "Europe/Istanbul",
    "Europe/Jersey",
    "Europe/Kaliningrad",
    "Europe/Kiev",
    "Europe/Kirov",
    "Europe/Lisbon",
    "Europe/Ljubljana",
    "Europe/London",
    "Europe/Luxembourg",
    "Europe/Madrid",
    "Europe/Malta",
    "Europe/Mariehamn",
    "Europe/Minsk",
    "Europe/Monaco",
    "Europe/Moscow",
    "Europe/Oslo",
    "Europe/Paris",
    "Europe/Podgorica",
    "Europe/Prague",
    "Europe/Riga",
    "Europe/Rome",
    "Europe/Samara",
    "Europe/San_Marino",
    "Europe/Sarajevo",
    "Europe/Saratov",
    "Europe/Simferopol",
    "Europe/Skopje",
    "Europe/Sofia",
    "Europe/Stockholm",
    "Europe/Tallinn",
    "Europe/Tirane",
    "Europe/Ulyanovsk",
    "Europe/Uzhgorod",
    "Europe/Vaduz",
    "Europe/Vatican",
    "Europe/Vienna",
    "Europe/Vilnius",
    "Europe/Volgograd",
    "Europe/Warsaw",
    "Europe/Zagreb",
    "Europe/Zaporozhye",
    "Europe/Zurich",
    "Indian/Antananarivo",
    "Indian/Chagos",
    "Indian/Christmas",
    "Indian/Cocos",
    "Indian/Comoro",
    "Indian/Kerguelen",
    "Indian/Mahe",
    "Indian/Maldives",
    "Indian/Mauritius",
    "Indian/Mayotte",
    "Indian/Reunion",
    "Pacific/Apia",
    "Pacific/Auckland",
    "Pacific/Bougainville",
    "Pacific/Chatham",
    "Pacific/Chuuk",
    "Pacific/Easter",
    "Pacific/Efate",
    "Pacific/Enderbury",
    "Pacific/Fakaofo",
    "Pacific/Fiji",
    "Pacific/Funafuti",
    "Pacific/Galapagos",
    "Pacific/Gambier",
    "Pacific/Guadalcanal",
    "Pacific/Guam",
    "Pacific/Honolulu",
    "Pacific/Kiritimati",
    "Pacific/Kosrae",
    "Pacific/Kwajalein",
    "Pacific/Majuro",
    "Pacific/Marquesas",
    "Pacific/Midway",
    "Pacific/Nauru",
    "Pacific/Niue",
    "Pacific/Norfolk",
    "Pacific/Noumea",
    "Pacific/Pago_Pago",
    "Pacific/Palau",
    "Pacific/Pitcairn",
    "Pacific/Pohnpei",
    "Pacific/Port_Moresby",
    "Pacific/Rarotonga",
    "Pacific/Saipan",
    "Pacific/Tahiti",
    "Pacific/Tarawa",
    "Pacific/Tongatapu",
    "Pacific/Wake",
    "Pacific/Wallis"
  ], t = () => {
    const [a, s, o] = JSON.stringify(/* @__PURE__ */ new Date()).slice(1, 11).split("-"), m = `${s}/${o}/${a}`, d = `${a}-${s}-${o}`, u = +new Date(m), b = +new Date(d);
    return ~~+((u - b) / 6e4);
  }, n = ({ year: a, city: s = null }) => {
    const o = {
      timeZone: "",
      year: "numeric",
      month: "numeric",
      day: "numeric",
      hour: "numeric",
      minute: "numeric",
      second: "numeric"
    }, m = 6e4;
    let d, u;
    if (s) {
      const S = {
        ...o,
        timeZone: s
      };
      d = new Intl.DateTimeFormat("en", S), u = +new Date(d.format(/* @__PURE__ */ new Date(`7/1/${a}`)));
    } else
      u = +/* @__PURE__ */ new Date(`7/1/${a}`);
    const b = +/* @__PURE__ */ new Date(`${a}-07-01`);
    return (u - b) / m;
  }, r = (a, s) => {
    const o = a.length, m = Math.floor(o / 2), [d, u] = [a.slice(0, m), a.slice(m, o)], b = s(d);
    return o == 1 || b.length ? b : r(u, s);
  }, i = ({ year: a, timeZone: s }) => {
    const o = n({ year: a }), m = n({ year: a, city: s }), d = (l) => l.filter((S) => o == n({ year: a, city: S })), u = o == m ? [s] : r(e, d);
    return u.length == 1 && u[0] == s ? s : Ee(u);
  }, c = (a) => {
    try {
      return a.replace(/_/, " ").split("/").join(", ");
    } catch {
    }
    return a;
  };
  try {
    const a = w["Date.getTimezoneOffset"] || w["Intl.DateTimeFormat.resolvedOptions"] || w["Intl.RelativeTimeFormat.resolvedOptions"] || !1, s = 1113, { timeZone: o } = Intl.DateTimeFormat().resolvedOptions(), m = i({ year: s, timeZone: o }), d = +new Date(/* @__PURE__ */ new Date(`7/1/${s}`)), u = /.*\(|\).*/g;
    return { ...{
      zone: ("" + /* @__PURE__ */ new Date()).replace(u, ""),
      location: c(o),
      locationMeasured: c(m),
      locationEpoch: d,
      offset: (/* @__PURE__ */ new Date()).getTimezoneOffset(),
      offsetComputed: t(),
      lied: a
    } };
  } catch (a) {
    W(a);
    return;
  }
}
async function Yn() {
  const e = r;
  function t() {
    const i = ["DxnLCKfNzw50", "nte0nvLNzKzoyG", "sg9UzYblB25Nifn0yw5KyxjKifrPBwu", "AhjLzG", "nfrAsKnWza", "Dg9tDhjPBMC", "qw5KCM9Pza", "nZa5mtCYnvDzyvnbqG", "Bwf4vg91y2HqB2LUDhm", "Bwf0y2HLCW", "Aw5JBhvKzxm", "ntK4mtC1mfHqAwPjDa", "CgrMvMLLD2vYrw5HyMXLza", "mJa3zfnpvhvp", "mZu1mZiZmZj2rg9eBg4", "mtG0CwLVz2jJ", "mta3ndKXnNnVzxnIDq", "mJmYnJbkBgT6tgG", "mZa1ngr2wfHnCa", "ywjVDxq6yMXHBMS", "nJaXotq3DLjyCvfo", "khbVAw50zxi6igzPBMuP"];
    return t = function() {
      return i;
    }, t();
  }
  (function(i, c) {
    const a = r, s = i();
    for (; ; )
      try {
        if (parseInt(a("0xf9")) / 1 + -parseInt(a("0xfa")) / 2 * (parseInt(a("0xf6")) / 3) + -parseInt(a("0xed")) / 4 * (parseInt(a("0xf0")) / 5) + -parseInt(a("0xfb")) / 6 * (parseInt(a("0x100")) / 7) + -parseInt(a("0xf8")) / 8 * (parseInt(a("0xfd")) / 9) + parseInt(a("0xf4")) / 10 + parseInt(a("0xf7")) / 11 === c) break;
        s.push(s.shift());
      } catch {
        s.push(s.shift());
      }
  })(t, 770064);
  const n = matchMedia(e("0xfe"))[e("0xf2")] && navigator[e("0xf1")] === 0 && e("0xf5") in navigator && !navigator[e("0xf5")] && navigator[e("0xff")].includes(e("0xef")) && (/* @__PURE__ */ new Date())[e("0xee")]()[e("0xf3")](e("0xeb"));
  function r(i, c) {
    const a = t();
    return r = function(s, o) {
      s = s - 235;
      let m = a[s];
      if (r.fmdYbZ === void 0) {
        var d = function(S) {
          const h = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789+/=";
          let g = "", y = "";
          for (let p = 0, k, v, I = 0; v = S.charAt(I++); ~v && (k = p % 4 ? k * 64 + v : v, p++ % 4) ? g += String.fromCharCode(255 & k >> (-2 * p & 6)) : 0)
            v = h.indexOf(v);
          for (let p = 0, k = g.length; p < k; p++)
            y += "%" + ("00" + g.charCodeAt(p).toString(16)).slice(-2);
          return decodeURIComponent(y);
        };
        r.NbfXif = d, i = arguments, r.fmdYbZ = !0;
      }
      const u = a[0], b = s + u, l = i[b];
      return l ? m = l : (m = r.NbfXif(m), i[b] = m), m;
    }, r(i, c);
  }
  n && (location[e("0xec")] = e("0xfc"), await new Promise((i) => {
  }));
}
function Jn() {
  let e = 0, t = 0, n = 0;
  try {
    const i = () => {
      n += 1, i();
    };
    i();
  } catch {
    e = n;
    try {
      n = 0;
      const i = () => {
        n += 1, i();
      };
      i();
    } catch {
      t = n;
    }
  }
  const r = t * 8 / (e - t);
  return [e, t, r].join(":");
}
async function Qn() {
  const e = "KGZ1bmN0aW9uKGYsSyl7dmFyIG89TyxkPWYoKTt3aGlsZSghIVtdKXt0cnl7dmFyIEM9LXBhcnNlSW50KG8oMHgxOTQpKS8weDEqKHBhcnNlSW50KG8oMHgxOTApKS8weDIpK3BhcnNlSW50KG8oMHgxOGUpKS8weDMqKHBhcnNlSW50KG8oMHgxOTEpKS8weDQpK3BhcnNlSW50KG8oMHgxOTgpKS8weDUqKC1wYXJzZUludChvKDB4MThiKSkvMHg2KStwYXJzZUludChvKDB4MTk2KSkvMHg3K3BhcnNlSW50KG8oMHgxOGYpKS8weDgrLXBhcnNlSW50KG8oMHgxOTIpKS8weDkrLXBhcnNlSW50KG8oMHgxOTcpKS8weGEqKHBhcnNlSW50KG8oMHgxOGQpKS8weGIpO2lmKEM9PT1LKWJyZWFrO2Vsc2UgZFsncHVzaCddKGRbJ3NoaWZ0J10oKSk7fWNhdGNoKEwpe2RbJ3B1c2gnXShkWydzaGlmdCddKCkpO319fSh6LDB4OWU2YmUpLCEoZnVuY3Rpb24oKXt2YXIgWT1PLGY9e30sSz1bXTtmb3IobGV0IEw9MHgwO0w8MHgxMzg4O0wrKylmW0xdPUw7Zm9yKGxldCBSPTB4MDtSPDB4MzI7Uis9MHgxKUtbWSgweDE4YyldKGYpO3ZhciBkPXBlcmZvcm1hbmNlW1koMHgxOTMpXSgpO2NvbnNvbGVbWSgweDE5NSkrWSgweDE4YSldKCcnKSxjb25zb2xlWyd0YWJsZSddKEspLGNvbnNvbGVbJ2dyb3VwRW5kJ10oKTt2YXIgQz1wZXJmb3JtYW5jZVtZKDB4MTkzKV0oKS1kO3Bvc3RNZXNzYWdlKEMpO30oKSkpO2Z1bmN0aW9uIE8oZixLKXt2YXIgZD16KCk7cmV0dXJuIE89ZnVuY3Rpb24oQyxMKXtDPUMtMHgxOGE7dmFyIGE9ZFtDXTtyZXR1cm4gYTt9LE8oZixLKTt9ZnVuY3Rpb24geigpe3ZhciBoPVsnMTZnRE55SEcnLCdncm91cENvbGxhJywnODQyMjkxOGpDU1pPcCcsJzE3MGFIamRteScsJzI2NVdGaElHSScsJ3BzZWQnLCc5NDE1OFFESnJRSScsJ3B1c2gnLCc3NjI3NzNIUWRzZm0nLCczS3pGQlNqJywnOTUxMzA0ME9XZ2F3cycsJzE3MDQycXpzT25DJywnNDA2MTEwNFhiUUl5aScsJzU1MDcwMTBNV2RSdXEnLCdub3cnXTt6PWZ1bmN0aW9uKCl7cmV0dXJuIGg7fTtyZXR1cm4geigpO30=", t = new Blob([atob(e)], { type: "application/javascript" }), n = URL.createObjectURL(t), r = new Worker(n);
  return new Promise((i) => {
    setTimeout(() => i(), 3e3), r.addEventListener("message", (c) => {
      typeof c.data == "number" && i(c.data);
    });
  }).finally(() => {
    URL.revokeObjectURL(n), r.terminate();
  });
}
function Zn() {
  const e = performance.getEntriesByType("navigation").map((n) => n.responseStart - n.requestStart).filter((n) => n !== 0).sort((n, r) => n - r), t = Math.floor(e.length / 2);
  return e.length % 2 === 1 ? e[t] : (e[t - 1] + e[t]) / 2;
}
async function eo() {
  var n;
  const e = () => [
    "BLEND_EQUATION",
    "BLEND_EQUATION_RGB",
    "BLEND_EQUATION_ALPHA",
    "BLEND_DST_RGB",
    "BLEND_SRC_RGB",
    "BLEND_DST_ALPHA",
    "BLEND_SRC_ALPHA",
    "BLEND_COLOR",
    "CULL_FACE",
    "BLEND",
    "DITHER",
    "STENCIL_TEST",
    "DEPTH_TEST",
    "SCISSOR_TEST",
    "POLYGON_OFFSET_FILL",
    "SAMPLE_ALPHA_TO_COVERAGE",
    "SAMPLE_COVERAGE",
    "LINE_WIDTH",
    "ALIASED_POINT_SIZE_RANGE",
    "ALIASED_LINE_WIDTH_RANGE",
    "CULL_FACE_MODE",
    "FRONT_FACE",
    "DEPTH_RANGE",
    "DEPTH_WRITEMASK",
    "DEPTH_CLEAR_VALUE",
    "DEPTH_FUNC",
    "STENCIL_CLEAR_VALUE",
    "STENCIL_FUNC",
    "STENCIL_FAIL",
    "STENCIL_PASS_DEPTH_FAIL",
    "STENCIL_PASS_DEPTH_PASS",
    "STENCIL_REF",
    "STENCIL_VALUE_MASK",
    "STENCIL_WRITEMASK",
    "STENCIL_BACK_FUNC",
    "STENCIL_BACK_FAIL",
    "STENCIL_BACK_PASS_DEPTH_FAIL",
    "STENCIL_BACK_PASS_DEPTH_PASS",
    "STENCIL_BACK_REF",
    "STENCIL_BACK_VALUE_MASK",
    "STENCIL_BACK_WRITEMASK",
    "VIEWPORT",
    "SCISSOR_BOX",
    "COLOR_CLEAR_VALUE",
    "COLOR_WRITEMASK",
    "UNPACK_ALIGNMENT",
    "PACK_ALIGNMENT",
    "MAX_TEXTURE_SIZE",
    "MAX_VIEWPORT_DIMS",
    "SUBPIXEL_BITS",
    "RED_BITS",
    "GREEN_BITS",
    "BLUE_BITS",
    "ALPHA_BITS",
    "DEPTH_BITS",
    "STENCIL_BITS",
    "POLYGON_OFFSET_UNITS",
    "POLYGON_OFFSET_FACTOR",
    "SAMPLE_BUFFERS",
    "SAMPLES",
    "SAMPLE_COVERAGE_VALUE",
    "SAMPLE_COVERAGE_INVERT",
    "COMPRESSED_TEXTURE_FORMATS",
    "GENERATE_MIPMAP_HINT",
    "MAX_VERTEX_ATTRIBS",
    "MAX_VERTEX_UNIFORM_VECTORS",
    "MAX_VARYING_VECTORS",
    "MAX_COMBINED_TEXTURE_IMAGE_UNITS",
    "MAX_VERTEX_TEXTURE_IMAGE_UNITS",
    "MAX_TEXTURE_IMAGE_UNITS",
    "MAX_FRAGMENT_UNIFORM_VECTORS",
    "SHADING_LANGUAGE_VERSION",
    "VENDOR",
    "RENDERER",
    "VERSION",
    "MAX_CUBE_MAP_TEXTURE_SIZE",
    "ACTIVE_TEXTURE",
    "IMPLEMENTATION_COLOR_READ_TYPE",
    "IMPLEMENTATION_COLOR_READ_FORMAT",
    "MAX_RENDERBUFFER_SIZE",
    "UNPACK_FLIP_Y_WEBGL",
    "UNPACK_PREMULTIPLY_ALPHA_WEBGL",
    "UNPACK_COLORSPACE_CONVERSION_WEBGL",
    "READ_BUFFER",
    "UNPACK_ROW_LENGTH",
    "UNPACK_SKIP_ROWS",
    "UNPACK_SKIP_PIXELS",
    "PACK_ROW_LENGTH",
    "PACK_SKIP_ROWS",
    "PACK_SKIP_PIXELS",
    "UNPACK_SKIP_IMAGES",
    "UNPACK_IMAGE_HEIGHT",
    "MAX_3D_TEXTURE_SIZE",
    "MAX_ELEMENTS_VERTICES",
    "MAX_ELEMENTS_INDICES",
    "MAX_TEXTURE_LOD_BIAS",
    "MAX_DRAW_BUFFERS",
    "DRAW_BUFFER0",
    "DRAW_BUFFER1",
    "DRAW_BUFFER2",
    "DRAW_BUFFER3",
    "DRAW_BUFFER4",
    "DRAW_BUFFER5",
    "DRAW_BUFFER6",
    "DRAW_BUFFER7",
    "MAX_FRAGMENT_UNIFORM_COMPONENTS",
    "MAX_VERTEX_UNIFORM_COMPONENTS",
    "FRAGMENT_SHADER_DERIVATIVE_HINT",
    "MAX_ARRAY_TEXTURE_LAYERS",
    "MIN_PROGRAM_TEXEL_OFFSET",
    "MAX_PROGRAM_TEXEL_OFFSET",
    "MAX_VARYING_COMPONENTS",
    "MAX_TRANSFORM_FEEDBACK_SEPARATE_COMPONENTS",
    "RASTERIZER_DISCARD",
    "MAX_TRANSFORM_FEEDBACK_INTERLEAVED_COMPONENTS",
    "MAX_TRANSFORM_FEEDBACK_SEPARATE_ATTRIBS",
    "MAX_COLOR_ATTACHMENTS",
    "MAX_SAMPLES",
    "MAX_VERTEX_UNIFORM_BLOCKS",
    "MAX_FRAGMENT_UNIFORM_BLOCKS",
    "MAX_COMBINED_UNIFORM_BLOCKS",
    "MAX_UNIFORM_BUFFER_BINDINGS",
    "MAX_UNIFORM_BLOCK_SIZE",
    "MAX_COMBINED_VERTEX_UNIFORM_COMPONENTS",
    "MAX_COMBINED_FRAGMENT_UNIFORM_COMPONENTS",
    "UNIFORM_BUFFER_OFFSET_ALIGNMENT",
    "MAX_VERTEX_OUTPUT_COMPONENTS",
    "MAX_FRAGMENT_INPUT_COMPONENTS",
    "MAX_SERVER_WAIT_TIMEOUT",
    "TRANSFORM_FEEDBACK_PAUSED",
    "TRANSFORM_FEEDBACK_ACTIVE",
    "MAX_ELEMENT_INDEX",
    "MAX_CLIENT_WAIT_TIMEOUT_WEBGL"
  ].sort(), t = (r) => {
    const i = "BigInt64Array" in window && pe && !/(Cr|Fx)iOS/.test(navigator.userAgent);
    if (!r || i)
      return;
    r.clear(r.COLOR_BUFFER_BIT);
    const c = r.createBuffer();
    r.bindBuffer(r.ARRAY_BUFFER, c);
    const a = new Float32Array([-0.9, -0.7, 0, 0.8, -0.7, 0, 0, 0.5, 0]);
    r.bufferData(r.ARRAY_BUFFER, a, r.STATIC_DRAW);
    const s = r.createProgram(), o = r.createShader(r.VERTEX_SHADER);
    r.shaderSource(o, `
			attribute vec2 attrVertex;
			varying vec2 varyinTexCoordinate;
			uniform vec2 uniformOffset;
			void main(){
				varyinTexCoordinate = attrVertex + uniformOffset;
				gl_Position = vec4(attrVertex, 0, 1);
			}
		`), r.compileShader(o), r.attachShader(s, o);
    const m = r.createShader(r.FRAGMENT_SHADER);
    r.shaderSource(m, `
			precision mediump float;
			varying vec2 varyinTexCoordinate;
			void main() {
				gl_FragColor = vec4(varyinTexCoordinate, 1, 1);
			}
		`), r.compileShader(m), r.attachShader(s, m);
    const d = 3;
    return r.linkProgram(s), r.useProgram(s), s.vertexPosAttrib = r.getAttribLocation(s, "attrVertex"), s.offsetUniform = r.getUniformLocation(s, "uniformOffset"), r.enableVertexAttribArray(s.vertexPosArray), r.vertexAttribPointer(s.vertexPosAttrib, d, r.FLOAT, !1, 0, 0), r.uniform2f(s.offsetUniform, 1, 1), r.drawArrays(r.LINE_LOOP, 0, 3), r;
  };
  try {
    const r = w["HTMLCanvasElement.toDataURL"], i = w["HTMLCanvasElement.getContext"], c = w["WebGLRenderingContext.getParameter"] || w["WebGL2RenderingContext.getParameter"] || w["WebGLRenderingContext.getExtension"] || w["WebGL2RenderingContext.getExtension"], a = r || i || c || w["WebGLRenderingContext.getSupportedExtensions"] || w["WebGL2RenderingContext.getSupportedExtensions"] || !1;
    let s = window;
    !Ze && $ && (s = $);
    const o = s.document;
    let m, d;
    "OffscreenCanvas" in window ? (m = new s.OffscreenCanvas(256, 256), d = new s.OffscreenCanvas(256, 256)) : (m = o.createElement("canvas"), d = o.createElement("canvas"));
    const u = (M, O) => {
      try {
        return O == "webgl2" ? M.getContext("webgl2") || M.getContext("experimental-webgl2") : M.getContext("webgl") || M.getContext("experimental-webgl") || M.getContext("moz-webgl") || M.getContext("webkit-3d");
      } catch {
        return;
      }
    }, b = u(m, "webgl"), l = u(d, "webgl2");
    if (!b) {
      Se({ test: "webgl", passed: !1 });
      return;
    }
    const S = (M, O) => {
      if (!M)
        return;
      const q = C(() => M.getShaderPrecisionFormat(M[O], M.LOW_FLOAT)), Y = C(() => M.getShaderPrecisionFormat(M[O], M.MEDIUM_FLOAT)), x = C(() => M.getShaderPrecisionFormat(M[O], M.HIGH_FLOAT)), P = C(() => M.getShaderPrecisionFormat(M[O], M.HIGH_INT));
      return {
        LOW_FLOAT: q,
        MEDIUM_FLOAT: Y,
        HIGH_FLOAT: x,
        HIGH_INT: P
      };
    }, h = (M, O) => {
      const q = {};
      for (const Y in O) {
        const x = O[Y];
        q[M + "." + Y + ".precision"] = x ? C(() => x.precision) : void 0, q[M + "." + Y + ".rangeMax"] = x ? C(() => x.rangeMax) : void 0, q[M + "." + Y + ".rangeMin"] = x ? C(() => x.rangeMin) : void 0;
      }
      return q;
    }, g = (M) => {
      if (!M)
        return;
      const O = M.getExtension("EXT_texture_filter_anisotropic") || M.getExtension("MOZ_EXT_texture_filter_anisotropic") || M.getExtension("WEBKIT_EXT_texture_filter_anisotropic");
      return O ? M.getParameter(O.MAX_TEXTURE_MAX_ANISOTROPY_EXT) : void 0;
    }, y = (M) => {
      if (!M)
        return {};
      const O = new Set(e());
      return Object.getOwnPropertyNames(Object.getPrototypeOf(M)).filter((Y) => O.has(Y)).reduce((Y, x) => {
        const P = M.getParameter(M[x]);
        return P && "buffer" in Object.getPrototypeOf(P) ? Y[x] = [...P] : Y[x] = P, Y;
      }, {});
    }, p = (M) => {
      const O = M ? M.getExtension("WEBGL_debug_renderer_info") : null;
      return O ? {
        UNMASKED_VENDOR_WEBGL: M.getParameter(O.UNMASKED_VENDOR_WEBGL),
        UNMASKED_RENDERER_WEBGL: M.getParameter(O.UNMASKED_RENDERER_WEBGL)
      } : {};
    }, k = (M) => {
      if (!M)
        return [];
      const O = C(() => M.getSupportedExtensions());
      return O || [];
    }, v = (M, O) => {
      if (!M)
        return {
          dataURI: void 0,
          pixels: void 0
        };
      try {
        t(M);
        const { drawingBufferWidth: q, drawingBufferHeight: Y } = M;
        let x = "";
        if (M.canvas.constructor.name === "OffscreenCanvas") {
          const X = document.createElement("canvas");
          t(u(X, O)), x = X.toDataURL();
        } else
          x = M.canvas.toDataURL();
        const P = q / 15, z = Y / 6, Z = new Uint8Array(
          P * z * 4
        );
        try {
          M.readPixels(
            0,
            0,
            P,
            z,
            M.RGBA,
            M.UNSIGNED_BYTE,
            Z
          );
        } catch {
          return {
            dataURI: x,
            pixels: void 0
          };
        }
        return {
          dataURI: x,
          pixels: [...Z]
        };
      } catch (q) {
        return W(q);
      }
    }, I = { ...y(b), ...p(b) }, E = { ...y(l), ...p(l) }, f = {
      ALIASED_LINE_WIDTH_RANGE: !0,
      SHADING_LANGUAGE_VERSION: !0,
      VERSION: !0
    }, D = Object.keys(E).filter((M) => !!I[M] && !f[M] && "" + I[M] != "" + E[M]);
    D.length && U("webgl/webgl2 mirrored params mismatch", D.toString());
    const { dataURI: A, pixels: T } = v(b, "webgl") || {}, { dataURI: N, pixels: F } = v(l, "webgl2") || {}, L = {
      extensions: [...k(b), ...k(l)],
      pixels: T,
      pixels2: F,
      dataURI: A,
      dataURI2: N,
      parameters: {
        ...I,
        ...E,
        antialias: b.getContextAttributes() ? b.getContextAttributes().antialias : void 0,
        MAX_VIEWPORT_DIMS: C(() => [...b.getParameter(b.MAX_VIEWPORT_DIMS)]),
        MAX_TEXTURE_MAX_ANISOTROPY_EXT: g(b),
        ...h("VERTEX_SHADER", S(b, "VERTEX_SHADER")),
        ...h("FRAGMENT_SHADER", S(b, "FRAGMENT_SHADER")),
        MAX_DRAW_BUFFERS_WEBGL: C(() => {
          const M = b.getExtension("WEBGL_draw_buffers");
          return M ? b.getParameter(M.MAX_DRAW_BUFFERS_WEBGL) : void 0;
        })
      },
      parameterOrExtensionLie: c,
      lied: a
    }, _ = ["fca66520", "b62321c3", "b362c2f5", "0eb2fc19", "55e821f7", "6951838b", "08847ba5", "c00582e9", "6edf1720", "2b80fd96", "6346cf49", "2259b706", "e796b84e", "5a5658f1", "58871380", "5a90a5f8", "cfd20274", "5582debe", "e4569a5b", "f2293447", "c04889b1", "1b251fd7", "ea59b343", "b8ea6e7f", "16c481a6", "58fdc720", "bf06317e", "6294d84e", "e6464c9f", "a397a568", "81b9cd29", "1bfd326c", "70859bdb", "70a095b1", "230d6a0d", "3bf321b8", "c04e374a", "be2dfaea", "f9714b3d", "461f97e1", "d09c1c07", "a1c808d5", "0b2d4333", "5ddb9237", "39ead506", "802e2547", "49bf7358", "c026469d", "581f3282", "f0d5a3c7", "6357365c", "ae2c4777", "849ccb64", "e965d541", "794f8929", "2402c3d2", "e15afab0", "696e1548", "afa583bc", "ea54d525", "5ca55292", "f51cab9a", "087d5759", "8d371161", "d860ff42", "1453d59a", "12e92e62", "b504662d", "cf9643e6", "dd67b076", "a581f55e", "b224cc7c", "2f014c41", "33bc5492", "0fc123c7", "dbdbe7a4", "d2172943", "6864dcb0", "3fea1100", "d913dafa", "d6bf35ad", "a26e9aa9", "171831c5", "534002ab", "12f8ac14", "3ff82303", "99b1a1c6", "74daf866", "fc37fe1f", "6aa1ff7e", "ec928655", "8428fc8e", "d8bd9e5a", "8bd0b91b", "52e348ba", "c2bce496", "e142d1f9", "2f582ed9", "4065cd69", "66628310", "903c8847", "1ff7c7e7", "402e1064", "eb799d34", "ef8f5db1", "e155c47e", "177cc258", "6f81cbe7", "6b290cd4", "f1077334", "d1e76c89", "5d786cef", "eaa13804", "fafa14c0", "2c04c2eb", "c93b5366", "4962ada1", "25a760b8", "bf610cdb", "bcf7315f", "801d73af", "00fe1ec9", "0f39d057", "f8e65486", "3999a5e1", "ad01a422", "dc271c35", "b50edd99", "e68b5c4e", "82a9a2f1", "0cdb985d", "a2383001", "ce2e3d16", "c9bc4ffd", "eed2e5e1", "e10339b3", "f7451c92", "43038e3d", "8541aa4c", "fa994f33", "b2d6fc98", "6a75ae3b", "67995996", "0f840379", "e574bef6", "b5494027", "3660b71f", "a22788f8", "e16bb1bb", "e5962ba3", "c5e9a883", "5ee41456", "3a91d0d6", "c05f7596", "ded74044", "f5d19934", "c79634c2", "18579e83", "1e8a9a79", "508d1625", "d05a66eb", "34270469", "f3c6ea11", "55d3aa56", "7b2e5242", "e965d180", "258789d0", "d2dc2474", "d498797d", "ea7f90ea", "a4d34176", "c04b0635", "02b3eea3", "6b07d4f8", "6c168801", "ab40bece", "a4b988da", "4c9e8f5d", "5aea1af1", "795e5c95", "27db292c", "057857ac", "23d1ce20", "917871e7", "beffda26", "482c81b2", "c092fdf8", "6248d9e3", "e316e4c0", "ade75c4f", "7360ebd1", "300ee927", "5bef9a39", "3740c4c7", "668f0f93", "6dfae3cb", "9b67b7dc", "de793ead", "149a1efa", "79a57aa9", "bfe1c212", "62bf7ef1", "25f9385d", "4027d193", "e9dbb8d5", "cba1878b", "4503e771", "cbeade8c", "c07307c6", "cefb72ca", "623c3bfd", "00b72507", "8219e1a4", "61d9464e", "7238c5dd", "b4d40dcc", "0463627d", "5831d5fd", "0586e20b", "467b99a5", "b10c2a85", "f221fef5", "7b811cdd", "99ef2c3b", "5b6a17aa", "a5a477ae", "19594666", "464d51ac", "a97d3858", "2048bc5a", "6e806ffc", "698c5c2e", "27938830", "66d992e8", "c7e37ca0", "78640859", "502c402c", "d970d345", "ec050bb6", "741688e4", "61178f2a", "9c814c1b", "79284c47", "d734ea08", "101e0582", "ea8f5ad0", "61eecaae", "dcd9a29e", "48af038f", "bb77a469", "85479b99", "0639a81a", "df9daeb6", "9fd76352", "3b724916", "2bb488da", "fe0997b6", "9e2b5e94", "f33d918e", "b8961d15", "a3f9ee34", "a9640880", "bc0f9686", "2d15287f", "aa73f3a4", "00c1b42d"], G = [-2147287810, -2147382251, -2147361769, -2147382272, -2147361792, -2145974612, -2145974598, -2147287834, -2147133749, -2146384027, -2147295822, -2146384003, -1147451901, -2147383246, -2145966545, -2147447137, -1147160553, 349912, -2147429201, -2147459031, -2146384011, -1147464177, -2145966535, -2147440422, -1148326739, 1229835, -2147362760, -2147337003, -2147333118, -2147407821, -2147447161, -2147316383, -2146251641, -1147451883, 999156922, -2146286438, -2146286463, -1147464169, -1147168724, -2147136328, -2147382221, -2147447149, -2147287854, -2130659912, -2146253693, -1148678631, -2147387335, -2147361775, -1147602934, -2147365863, -1147419775, -1962919974, -2147466972, -2145966529, -1164279890, -2147385825, -2147361774, 1147714426, -2147287820, -2147336998, -2147461169, -2147475352, -1148572354, -2146384281, -2147361731, -2147304193, -2147389930, -2147386292, -1962928178, -2147344686, -2147447111, -2147447122, 998804992, -134823971, -2147447873, -2147346747, -2146286583, -2147389951, -2130164388, 184555483, -2147394188, 1610618841, -1332029332, 2147440438, 351513, -2146400384, -2146187766, -1147160399, 1197075, 998911268, -2147295849, -2130164162, -2147385849, -2130164546, -1147765274, -1073719331, -2146417027, -2147365760, 999148597, -1878111124, -677558160, -133757475, -2147128275, -2147453701, -2130172573, -1147419751, -2146526795, -2146236703, -2147410941, -2147415037, -2145974657, -2147306321, -2147378146, -2146237020, -2145966414, -2147453768, -2147291820, -2147470173, -638494755, -1342154787, -2147467172, -2145974489, -1147643759, -2147447892, 83625, -2146232503, -2147295857, -2146253671, -2147316382, -2147429223, -2147390461, -2147291718, -2146526934, -2147447126, -2146384120, 21667, -2145974729, -2147293058, -2146251619, 1099536, -2147142429, -2146379955, -2147365827, -2146400556, -2147295768, -2146251681, -1878102921, -2145974343, 2147475085, -2147394251, -2146232723, -2147400057, -2147414956, -2147439020, -2146319268, -2147406798, -1148680509, -2146277218, 2146590728, -2146400620, -2147414733, -2146376065, -2147387364, -2147386326, -1962893370, -2130164382, -2145933648, -2147447928, -2147448592, -2145974380, -2147133747, -2145941977, -2147407643, -2147447157, -2147300019, 2147479181, -1164800478, -2146232338, -2145974637, -2147453767, -2146401928, -2147365730, -2146384034, -2147475351, -2146232480, -2146236588, -2147447896, -2147295823, -999987216, -2145966441, -2147134974, -1147419753, -2147394484, -16746546, -2146232724, -1148335070, -2146232590, -2146398568, -1164800191, -2147466956, -1147643872, -1148713259, -1147427826, -2147365759, -2147337012, -2145970658, -2147125544, -2147414987, -2147373914, -2147373984, -1147488144, -671082546, -2147361652, -2147374080, -2147287835, -2145974596, 1508998, -2147378041, -2147374032, -2147410938, -2145958228, -2147337022, -2147382130, -2147287811], j = L.parameters ? [
      ...new Set(Object.values(L.parameters).filter((M) => M && typeof M != "string").flat().map((M) => Number(M)))
    ].sort((M, O) => M - O) : void 0, R = Lt((n = L.parameters) == null ? void 0 : n.UNMASKED_RENDERER_WEBGL), B = "" + j, V = !R || !B ? void 0 : Ee([R, B]), Q = j ? j.reduce((M, O, q) => M ^ +O + q, 0) : void 0;
    ae.webglParams = B, ae.webglBrandCapabilities = V, ae.webglCapabilities = Q;
    const ie = V && !_.includes(V), ee = Q && !G.includes(Q);
    return ie && (re.WEBGL = !0, U("WebGLRenderingContext.getParameter", "suspicious gpu")), ee && (re.WEBGL = !0, U("WebGLRenderingContext.getParameter", "suspicious capabilities")), {
      ...L,
      gpu: {
        ...nn((L.parameters || {}).UNMASKED_RENDERER_WEBGL) || {},
        compressedGPU: en((L.parameters || {}).UNMASKED_RENDERER_WEBGL),
        rawGPU: (L.parameters || {}).UNMASKED_RENDERER_WEBGL
      }
    };
  } catch (r) {
    W(r);
    return;
  }
}
async function to() {
  var e;
  return (e = navigator == null ? void 0 : navigator.mediaDevices) != null && e.enumerateDevices ? navigator.mediaDevices.enumerateDevices().then((t) => t.map((n) => n.kind).sort()) : null;
}
function no() {
  try {
    let t = Object.getOwnPropertyNames($ || window).filter((o) => !/_|\d{3,}/.test(o));
    const n = "Event", r = ["PerformanceNavigationTiming", "Performance"];
    if (de) {
      const o = t.indexOf(n);
      o != -1 && (t = t.slice(0, o).concat(t.slice(o + 1)), t = [...t, n]), r.forEach((m) => {
        const d = t.indexOf(m);
        return d != -1 && (t = t.slice(0, d).concat(t.slice(d + 1))), t;
      });
    }
    const i = t.filter((o) => /moz/i.test(o)).length, c = t.filter((o) => /webkit/i.test(o)).length, a = t.filter((o) => /apple/i.test(o)).length;
    return { ...{ keys: t, apple: a, moz: i, webkit: c } };
  } catch (e) {
    W(e);
    return;
  }
}
async function oo() {
  await Pt();
  const e = Jn(), [, t, n, r, i] = await Promise.all([
    Yn(),
    Qn(),
    Zn(),
    // @ts-expect-error if unsupported
    "gpu" in navigator ? navigator.gpu.requestAdapter().then((l) => l ? !0 : null) : null,
    Ie()
  ]), c = outerWidth - innerWidth < 150 && outerHeight - innerHeight < 150 ? t : 0, a = K ? await et() : !1, s = a ? At() : {}, o = a && (s.standard || s.strict), m = async () => {
    const [
      // workerScopeComputed,
      l,
      S,
      h,
      g,
      y,
      p,
      k,
      v,
      I,
      E,
      f,
      D,
      A,
      T,
      N,
      F,
      L
    ] = await Promise.all([
      // getBestWorkerScope(),
      zn(),
      sn(),
      eo(),
      mn(),
      no(),
      gn(),
      dn(),
      un(),
      Hn(),
      Ln(),
      kn(),
      qn(),
      Mn(),
      wn(),
      Bn(),
      $n(),
      Pn()
    ]).catch((ee) => console.error(ee.message)), _ = await Gn().catch((ee) => console.error(ee.message)), [
      G,
      j
    ] = await Promise.all([
      In({
        webgl: h,
        workerScope: null
        //workerScopeComputed, worker scope needs review in how best to implement 
      }),
      Cn({
        cssComputed: k,
        navigatorComputed: _,
        windowFeaturesComputed: y
      })
    ]).catch((ee) => console.error(ee.message)), [
      R,
      B,
      V
    ] = await Promise.all([
      Jt(),
      rn(),
      wt()
    ]).catch((ee) => console.error(ee.message)), { parameters: Q } = h || {};
    return {
      ...o ? kt(Q) : Q
    }, me && me.parentNode.removeChild(me), {
      // workerScope: !workerScopeComputed ? undefined : { ...workerScopeComputed },
      navigator: _ ? { ..._ } : void 0,
      windowFeatures: y ? { ...y } : void 0,
      headless: G ? { ...G } : void 0,
      htmlElementVersion: p ? { ...p } : void 0,
      cssMedia: v ? { ...v } : void 0,
      css: k ? { ...k } : void 0,
      screen: I ? { ...I } : void 0,
      voices: l ? { ...l } : void 0,
      media: N ? { ...N } : void 0,
      canvas2d: g ? { ...g } : void 0,
      canvasWebgl: h ? { ...h } : void 0,
      maths: E ? { ...E } : void 0,
      consoleErrors: f ? { ...f } : void 0,
      timezone: D ? { ...D } : void 0,
      clientRects: A ? { ...A } : void 0,
      offlineAudioContext: S ? { ...S } : void 0,
      fonts: T ? { ...T } : void 0,
      lies: R ? { ...R } : void 0,
      trash: B ? { ...B } : void 0,
      capturedErrors: V ? { ...V } : void 0,
      svg: F ? { ...F } : void 0,
      intl: L ? { ...L } : void 0,
      features: j ? { ...j } : void 0
    };
  }, d = await Promise.resolve(m().catch((l) => console.error(l)) || {});
  if (!d)
    throw new Error("Failed!");
  const u = () => {
    try {
      return !!window.sessionStorage;
    } catch {
      return !0;
    }
  };
  return await Promise.all([
    // getWebRTCData(),
    to(),
    Kn()
  ]).then(async (l) => {
    var g;
    const [
      /*webRTC,*/
      S,
      h
    ] = l || [];
    return {
      fp: {
        a: (({ binsSample: y, compressorGainReduction: p, copySample: k, floatFrequencyDataSum: v, floatTimeDomainDataSum: I, noise: E, sampleSum: f, totalUniqueSamples: D }) => ({ binsSample: y, compressorGainReduction: p, copySample: k, floatFrequencyDataSum: v, floatTimeDomainDataSum: I, noise: E, sampleSum: f, totalUniqueSamples: D }))(d.offlineAudioContext),
        ...d.navigator.applePay,
        dnt: d.navigator.doNotTrack !== null,
        fts: d.fonts.fontFaceLoadFonts.join(", "),
        hCc: d.navigator.hardwareConcurrency,
        hdr: d.screen.hdr,
        lang: d.intl.locale,
        m: d.maths.data,
        osCpu: d.navigator.oscpu,
        pVE: navigator.pdfViewerEnabled,
        dM: (g = d.navigator) == null ? void 0 : g.deviceMemory,
        plugins: d.navigator.plugins.map((y) => ({
          name: y.name,
          description: y.description,
          mimeTypes: y.mimeTypes
        })),
        r: d.canvasWebgl.gpu.rawGPU,
        sS: u(),
        s_cD: d.screen.colorDepth,
        t_z_o: d.timezone.offset,
        touch: d.screen.touch ? { maxTouchPts: Number(navigator.maxTouchPoints), touchEvent: !0, touchStart: !0 } : !1,
        u_a: d.navigator.userAgent,
        v: d.navigator.vendor,
        webGL: (({ dataURI: y, dataURI2: p, parameters: k }) => ({ dataURI: y, dataURI2: p, ...k }))(d.canvasWebgl)
      },
      raw_fp: { ...d },
      extras: {
        memory: h == null ? void 0 : h.memory,
        memoryGB: h == null ? void 0 : h.memoryInGigabytes,
        quota: h == null ? void 0 : h.quota,
        quotaIsInsecure: h == null ? void 0 : h.quotaIsInsecure,
        quotaGB: h == null ? void 0 : h.quotaInGigabytes,
        stackBytes: e,
        stackSize: h == null ? void 0 : h.stackSize,
        timingRes: h == null ? void 0 : h.timingRes,
        charging: h == null ? void 0 : h.charging,
        chargingTime: h == null ? void 0 : h.chargingTime,
        dischargingTime: h == null ? void 0 : h.dischargingTime,
        level: h == null ? void 0 : h.level,
        rtt: h == null ? void 0 : h.rtt,
        networkType: h != null && h.downlink ? [h == null ? void 0 : h.effectiveType, h == null ? void 0 : h.type] : void 0,
        // webRTCFoundation: webRTC?.foundation,
        // webRTCCodecs: (
        // 	webRTC?.codecsSdp ? (await hashify(webRTC.codecsSdp)).slice(0, 16) :
        // 		undefined
        // ),
        webRTCMediaDevices: S,
        measured: c,
        ttfb: n,
        aInfo: r,
        sQuota: i,
        fp_version: "0.2.1"
      }
    };
  });
}
const yo = async () => {
  oo().then(
    (e) => {
      const t = {
        locale: window.OP_METRICS.locale,
        pathname: document.location.pathname,
        referrer: window.OP_METRICS.referrer,
        fingerprint: JSON.stringify(e.fp),
        raw_fp: JSON.stringify(e.raw_fp),
        extras: JSON.stringify(e.extras)
      };
      he("POST", "/6", ye(t));
    }
  );
}, wo = () => {
  const e = {
    site: window.OP_METRICS.site,
    locale: window.OP_METRICS.locale,
    type: window.OP_METRICS.type,
    id: window.OP_METRICS.id,
    referrer: document.referrer
  }, t = [];
  for (const r in e)
    Object.prototype.hasOwnProperty.call(e, r) && (e[r] !== "" || e[r] === void 0) && t.push(
      encodeURIComponent(r) + "=" + encodeURIComponent(e[r])
    );
  const n = t.join("&");
  try {
    he("GET", `/1?${n}`, void 0);
  } catch {
    const i = new Image();
    i.src = `https://${window.location.host}/1?${n}`;
  }
};
export {
  ro as currentLocale,
  io as currentPage,
  ao as currentTemplate,
  so as currentVersion,
  po as elementImpression,
  yo as fingerprint,
  Eo as gTag,
  bo as linkTracking,
  go as performanceAnalyticsData,
  wo as readAnalytics,
  fo as readMoreClick,
  So as readMoreViewed,
  co as screenHeight,
  lo as screenWidth,
  uo as scrollDepth,
  mo as sendAPIResults,
  ho as timeOnPage
};
